import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["vatMode", "price", "discountedPrice", "selected", "handleClick"];
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.sort.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// src/components/selector/Selector.tsx
import { Grid as Grid3, useMediaQuery } from "@printdeal/ui-library";
import { useEffect as useEffect12, useMemo as useMemo5, useState as useState13 } from "react";
import clsx3 from "clsx";

// src/helpers/sentry.ts
import { ErrorManagement } from "@printdeal/error-management/react";
var Sentry = {
  addTrace(breadcrumb) {
    try {
      ErrorManagement.addTrace(breadcrumb);
    } catch (_error) {}
  },
  exception(exception) {
    try {
      ErrorManagement.exception(exception);
    } catch (_error) {}
  }
};

// src/helpers/jsonLogic.ts
import { apply } from "json-logic-js";
var applyLogic = (rule, data) => apply(rule, data);

// src/helpers/prices.ts
var pricePivotAttributes = ["Printing Process", "Printing", "PrintingProcess", "Delivery Type"];
var formatAttributes = attributes => attributes.map(_ref => {
  let [name, value] = _ref;
  return {
    name,
    value
  };
});
var getPricePivot = attributes => {
  const priceAttributes = pricePivotAttributes.map(pricePivotAttribute => attributes.find(attribute => attribute.name === pricePivotAttribute)).filter(Boolean);
  const sort = priceAttributes.map(attribute => {
    var _attribute$values;
    return {
      pivotAttribute: attribute.name,
      order: ((_attribute$values = attribute.values) === null || _attribute$values === void 0 ? void 0 : _attribute$values.map(_ref2 => {
        let {
          name
        } = _ref2;
        return name;
      })) || []
    };
  });
  return {
    priceAttributes,
    sort
  };
};
var getPriceGroups = groups => groups.map(group => ({
  attributes: formatAttributes(Object.entries(group.attributes)),
  quantity: Number(group.quantity)
}));
var getPriceAmount = (vatMode, price, discountedPrice) => {
  if (!discountedPrice) {
    return price[vatMode].centAmount;
  }
  if (price[vatMode].centAmount === discountedPrice[vatMode].centAmount) {
    return price[vatMode].centAmount;
  }
  return discountedPrice[vatMode].centAmount;
};
var getSelectedPriceAttributeValue = (priceAttributes, priceAttributeName) => {
  const lowerCasedKey = priceAttributeName.toLowerCase();
  const found = Object.entries(priceAttributes).find(_ref3 => {
    let [key2] = _ref3;
    return key2.toLowerCase().includes(lowerCasedKey);
  });
  const [key, value] = found || [];
  return key && value ? String(value) : void 0;
};
var getPriceByAttributes = (prices, attributes) => {
  const printingProcess = getSelectedPriceAttributeValue(attributes, "Printing");
  const printingProcessPrice = prices.find(process => {
    var _process$name;
    return ((_process$name = process.name) === null || _process$name === void 0 ? void 0 : _process$name.toLowerCase()) === (printingProcess === null || printingProcess === void 0 ? void 0 : printingProcess.toLowerCase());
  }) || prices[0];
  const quantityPrice = printingProcessPrice.quantities.find(quantityObject => {
    const quantity = typeof attributes.Quantity === "string" ? parseInt(attributes.Quantity, 10) : attributes.Quantity;
    return quantityObject.quantity === quantity;
  });
  if (quantityPrice) {
    const deliveryType = getSelectedPriceAttributeValue(attributes, "Delivery Type");
    const foundPrice = quantityPrice.deliveryTypes.find(delivery => delivery.name.toLowerCase() === (deliveryType === null || deliveryType === void 0 ? void 0 : deliveryType.toLowerCase()));
    if (foundPrice !== null && foundPrice !== void 0 && foundPrice.price) {
      return {
        price: foundPrice.price,
        discountedPrice: foundPrice.discountedPrice
      };
    }
  }
  return void 0;
};
var hasDiscount = (vatMode, price, discountedPrice) => {
  if (discountedPrice) {
    return Boolean(price[vatMode].centAmount !== discountedPrice[vatMode].centAmount);
  }
  return false;
};
var getBadgeVariant = deliveryType => {
  switch (deliveryType) {
    case "Express":
      return "success-outline";
    case "Next Day":
      return "success";
    case "Normal":
    default:
      return "dim";
  }
};
var getTotalPrice = (price, servicePrice) => {
  if (price) {
    return _objectSpread(_objectSpread({}, price), {}, {
      totalNet: _objectSpread(_objectSpread({}, price.totalNet), {}, {
        centAmount: price.totalNet.centAmount + ((servicePrice === null || servicePrice === void 0 ? void 0 : servicePrice.totalNet.centAmount) || 0)
      }),
      totalGross: _objectSpread(_objectSpread({}, price.totalGross), {}, {
        centAmount: price.totalGross.centAmount + ((servicePrice === null || servicePrice === void 0 ? void 0 : servicePrice.totalGross.centAmount) || 0)
      })
    });
  }
  return price;
};
var getSelectedPriceAttributes = (attributes, selection) => {
  const {
    priceAttributes
  } = getPricePivot(attributes);
  return priceAttributes.reduce((acc, attribute) => {
    if (selection[attribute.name]) {
      acc[attribute.name] = selection[attribute.name];
    }
    return acc;
  }, {});
};
var getValue = (values, name) => values === null || values === void 0 ? void 0 : values.find(value => value.name === name);
var getPriceAttribute = (attributes, priceAttributeName) => {
  const productAttribue = attributes.find(_ref4 => {
    let {
      values
    } = _ref4;
    return getValue(values, priceAttributeName);
  });
  return _objectSpread({}, productAttribue && {
    [productAttribue.name]: priceAttributeName
  });
};
var generatePriceAttributesMap = (attributes, printingProcessName, deliveryTypes, quantity) => {
  const map = /* @__PURE__ */new Map();
  deliveryTypes.forEach(deliveryType => {
    const key = quantity ? "".concat(quantity, "-").concat(deliveryType.name) : deliveryType.name;
    const priceAttributes = _objectSpread(_objectSpread(_objectSpread({}, getPriceAttribute(attributes, printingProcessName)), getPriceAttribute(attributes, deliveryType.name)), quantity && {
      Quantity: quantity
    });
    map.set(key, priceAttributes);
  });
  return map;
};
var getPricePerQuantity = prices => prices.quantities.reduce((quantities, _ref5) => {
  let {
    quantity,
    deliveryTypes
  } = _ref5;
  const deliveryTypesPerQuantity = deliveryTypes.map(deliveryType => ({
    deliveryType,
    quantity
  }));
  if (deliveryTypesPerQuantity.length > 0) {
    return [...quantities, ...deliveryTypesPerQuantity];
  }
  return quantities;
}, []);
var getSelectedPrice = (prices, selection, pricesPerQuantity, totalQuantity, selectedDeliveryOption, defaultValues) => {
  var _pricesPerQuantity$fi;
  if (!defaultValues) {
    const table = prices.length > 1 ? prices.find(_ref6 => {
      let {
        name
      } = _ref6;
      return name && Object.values(selection).includes(name);
    }) : prices[0];
    const quantity = table === null || table === void 0 ? void 0 : table.quantities.find(_ref7 => {
      let {
        quantity: quantity2
      } = _ref7;
      return quantity2 === totalQuantity;
    });
    return quantity === null || quantity === void 0 ? void 0 : quantity.deliveryTypes.find(_ref8 => {
      let {
        name
      } = _ref8;
      return name === selectedDeliveryOption;
    });
  }
  return (_pricesPerQuantity$fi = pricesPerQuantity.find(_ref9 => {
    let {
      quantity,
      deliveryType
    } = _ref9;
    return quantity === totalQuantity && deliveryType.name === selectedDeliveryOption;
  })) === null || _pricesPerQuantity$fi === void 0 ? void 0 : _pricesPerQuantity$fi.deliveryType;
};
var getDefaultValuesPrices = (prices, selectedDeliveryOption, totalQuantity, servicePrice) => {
  var _pricesPerQuantity$fi2, _pricesPerQuantity$, _pricesPerQuantity$2;
  const pricesPerQuantity = getPricePerQuantity(prices);
  const selectedPrice = totalQuantity ? (_pricesPerQuantity$fi2 = pricesPerQuantity.find(_ref10 => {
    let {
      quantity,
      deliveryType
    } = _ref10;
    return quantity === totalQuantity && deliveryType.name === selectedDeliveryOption;
  })) === null || _pricesPerQuantity$fi2 === void 0 ? void 0 : _pricesPerQuantity$fi2.deliveryType : (_pricesPerQuantity$ = pricesPerQuantity[0]) === null || _pricesPerQuantity$ === void 0 ? void 0 : _pricesPerQuantity$.deliveryType;
  return {
    pricesPerQuantity,
    price: selectedPrice === null || selectedPrice === void 0 ? void 0 : selectedPrice.discountedPrice,
    originalTotalPrice: getTotalPrice(selectedPrice === null || selectedPrice === void 0 ? void 0 : selectedPrice.price, servicePrice),
    totalPrice: getTotalPrice(selectedPrice === null || selectedPrice === void 0 ? void 0 : selectedPrice.discountedPrice, servicePrice),
    totalQuantity: totalQuantity || ((_pricesPerQuantity$2 = pricesPerQuantity[0]) === null || _pricesPerQuantity$2 === void 0 ? void 0 : _pricesPerQuantity$2.quantity)
  };
};
var getTotalQuantity = _ref11 => {
  let {
    quantity,
    quantityParam,
    urlSelection,
    defaultSelection
  } = _ref11;
  if (quantity) return quantity;
  if (Number(quantityParam)) return Number(quantityParam);
  if (Number(urlSelection === null || urlSelection === void 0 ? void 0 : urlSelection.groupedQuantity)) return Number(urlSelection === null || urlSelection === void 0 ? void 0 : urlSelection.groupedQuantity);
  if (Number(urlSelection === null || urlSelection === void 0 ? void 0 : urlSelection.Quantity)) return Number(urlSelection === null || urlSelection === void 0 ? void 0 : urlSelection.Quantity);
  if (Number(defaultSelection === null || defaultSelection === void 0 ? void 0 : defaultSelection.groupedQuantity)) return Number(defaultSelection === null || defaultSelection === void 0 ? void 0 : defaultSelection.groupedQuantity);
  return 0;
};
var getDeliveryOption = (deliveryOptions, deliveryOption) => deliveryOption !== null && deliveryOption !== void 0 && deliveryOption.id ? deliveryOptions.find(_ref12 => {
  let {
    id
  } = _ref12;
  return id === deliveryOption.id;
}) : deliveryOptions.find(_ref13 => {
  let {
    name
  } = _ref13;
  return name === deliveryOption.name;
});

// src/helpers/selection.ts
var getSelectedValue = (selection, attribute, productAttribute) => {
  var _attribute$values2, _productAttribute$val;
  if (attribute.type === "lor") {
    return {
      selectedValue: {
        name: selection[attribute.name]
      },
      selectedProductValue: void 0
    };
  }
  if (attribute.type === "group") {
    const attributes = attribute.attributes.filter(_ref14 => {
      let {
        template
      } = _ref14;
      return template !== "hidden";
    });
    return attributes.reduce((value, groupedAttribute) => {
      var _value$selectedValue, _groupedAttribute$ran3, _groupedAttribute$ran4;
      if (!selection[groupedAttribute.name]) {
        return value;
      }
      if ((_value$selectedValue = value.selectedValue) !== null && _value$selectedValue !== void 0 && _value$selectedValue.name) {
        var _groupedAttribute$ran, _groupedAttribute$ran2;
        return {
          selectedValue: {
            name: (_groupedAttribute$ran = groupedAttribute.range) !== null && _groupedAttribute$ran !== void 0 && (_groupedAttribute$ran = _groupedAttribute$ran[0]) !== null && _groupedAttribute$ran !== void 0 && _groupedAttribute$ran.unitOfMeasure ? "".concat(value.selectedValue.name, " x ").concat(selection[groupedAttribute.name], " ").concat((_groupedAttribute$ran2 = groupedAttribute.range[0]) === null || _groupedAttribute$ran2 === void 0 ? void 0 : _groupedAttribute$ran2.unitOfMeasure) : "".concat(value.selectedValue.name, " x ").concat(selection[groupedAttribute.name])
          },
          selectedProductValue: void 0
        };
      }
      return {
        selectedValue: {
          name: (_groupedAttribute$ran3 = groupedAttribute.range) !== null && _groupedAttribute$ran3 !== void 0 && (_groupedAttribute$ran3 = _groupedAttribute$ran3[0]) !== null && _groupedAttribute$ran3 !== void 0 && _groupedAttribute$ran3.unitOfMeasure ? "".concat(selection[groupedAttribute.name], " ").concat((_groupedAttribute$ran4 = groupedAttribute.range[0]) === null || _groupedAttribute$ran4 === void 0 ? void 0 : _groupedAttribute$ran4.unitOfMeasure) : selection[groupedAttribute.name]
        },
        selectedProductValue: void 0
      };
    }, {});
  }
  const selected = selection[attribute.name];
  if (!selected) {
    return {
      selectedValue: void 0,
      selectedProductValue: void 0
    };
  }
  const selectedValue = (_attribute$values2 = attribute.values) === null || _attribute$values2 === void 0 ? void 0 : _attribute$values2.find(_ref15 => {
    let {
      name
    } = _ref15;
    return name === selected;
  });
  const selectedProductValue = productAttribute === null || productAttribute === void 0 || (_productAttribute$val = productAttribute.values) === null || _productAttribute$val === void 0 ? void 0 : _productAttribute$val.find(_ref16 => {
    let {
      pimAttributeValue
    } = _ref16;
    return pimAttributeValue === selected;
  });
  return {
    selectedValue,
    selectedProductValue
  };
};
var getDefaultSelection = attributes => attributes.reduce((defaultSelection, attribute) => {
  if (attribute.defaultValue) {
    return _objectSpread(_objectSpread({}, defaultSelection), {}, {
      [attribute.name]: attribute.defaultValue
    });
  }
  if (attribute.type === "group") {
    const groupedAttributeValues = attribute.attributes.reduce((groupedAttributes, groupAttribute) => {
      if (groupAttribute.defaultValue) {
        return _objectSpread(_objectSpread({}, groupedAttributes), {}, {
          [groupAttribute.name]: groupAttribute.defaultValue
        });
      }
      return groupedAttributes;
    }, {});
    return _objectSpread(_objectSpread({}, defaultSelection), groupedAttributeValues);
  }
  return defaultSelection;
}, {});
var filterAttributes = (attributes, remainingOptions, reviewPage, selectorSelection, selectionMode, templateSelection) => attributes.filter(_ref17 => {
  let {
    name,
    template,
    onReviewPage,
    invalidValuesVisibility,
    values,
    isConditionalAttribute,
    conditionalAttributeRules
  } = _ref17;
  const isPricePivot = pricePivotAttributes.includes(name);
  if (!remainingOptions.length) {
    return template !== "hidden";
  }
  if (templateSelection !== null && templateSelection !== void 0 && templateSelection[name]) {
    return false;
  }
  try {
    const rule = conditionalAttributeRules ? JSON.parse(conditionalAttributeRules) : "";
    if (isConditionalAttribute && !applyLogic(rule, selectorSelection)) {
      return false;
    }
  } catch (error) {
    const message = "An unexpected error occurred while trying to parse the conditional attribute logic for ".concat(name);
    Sentry.exception({
      exception: error,
      tags: {
        fileLocation: "conditionalAttributes",
        featureFunction: "filterAttributes"
      },
      fingerprint: ["easy-selector"]
    });
    throw new Error(message);
  }
  const showOnReviewPage = reviewPage && onReviewPage || !reviewPage;
  return showOnReviewPage && remainingOptions.filter(_ref18 => {
    let {
      options
    } = _ref18;
    return options.length;
  }).some(remainingOption => {
    var _option$values$;
    const option = remainingOption.options.find(_ref19 => {
      let {
        key
      } = _ref19;
      return name === key;
    });
    const isRange = (option === null || option === void 0 || (_option$values$ = option.values[0]) === null || _option$values$ === void 0 ? void 0 : _option$values$.type) === "range";
    const foundValue = values === null || values === void 0 ? void 0 : values.find(value => {
      var _option$values$2;
      if ((option === null || option === void 0 || (_option$values$2 = option.values[0]) === null || _option$values$2 === void 0 ? void 0 : _option$values$2.type) === "stringLiteral") {
        return value.id === option.values[0].stringLiteral;
      }
      return true;
    });
    const isEnabled = (option === null || option === void 0 ? void 0 : option.values.length) === 1 && !isRange || (values === null || values === void 0 ? void 0 : values.length) === 1 ? (foundValue === null || foundValue === void 0 ? void 0 : foundValue.enabled) || (foundValue === null || foundValue === void 0 ? void 0 : foundValue.conditionalAttributeValueRules) : true;
    const notHidden = template !== "hidden";
    const oneOptionLeft = (option === null || option === void 0 ? void 0 : option.values.length) === 1 && !isPricePivot;
    if (selectionMode === "step-by-step") {
      return notHidden;
    }
    return notHidden && isEnabled && (oneOptionLeft && invalidValuesVisibility !== "hidden" || !oneOptionLeft);
  });
});
var hasGroupedQuantity = attributes => {
  const groupedQuantityAttribute = attributes.find(attribute => attribute.name === "groupedQuantity");
  return Boolean(groupedQuantityAttribute);
};
var formatPrefilledSelection = (attributes, payload) => {
  if (!payload || payload.length === 0) {
    const defaultValues = attributes.filter(attribute => attribute.defaultValue);
    if (defaultValues.length > 0) {
      return {
        selection: attributes.reduce((formattedSelection, attribute) => {
          if (attribute.defaultValue) {
            return _objectSpread(_objectSpread({}, formattedSelection), {}, {
              [attribute.name]: attribute.defaultValue
            });
          }
          return formattedSelection;
        }, {}),
        groupSelection: void 0
      };
    }
    return {
      selection: void 0,
      groupSelection: void 0
    };
  }
  const [attributeSelection] = Array.isArray(payload) ? payload : [payload];
  const selection = Object.keys(attributeSelection).reduce((formattedSelection, key) => _objectSpread(_objectSpread({}, formattedSelection), {}, {
    [key]: String(attributeSelection[key])
  }), {});
  if (Array.isArray(payload)) {
    const groupSelection = payload.map(item => {
      const attributesSelection = Object.keys(attributeSelection).reduce((formattedSelection, key) => {
        const attribute = attributes.find(contentAttribute => contentAttribute.name === key);
        if (!attribute) {
          return _objectSpread(_objectSpread({}, formattedSelection), {}, {
            [key]: item[key]
          });
        }
        return formattedSelection;
      }, {});
      return {
        attributes: attributesSelection,
        quantity: Number(item.Quantity)
      };
    });
    return {
      selection,
      groupSelection
    };
  }
  return {
    selection
  };
};
var getSelectionValue = (selection, value) => Object.values(selection).find(option => value === option);
var getSelectionAttributes = selection => Object.fromEntries(Object.entries(selection).filter(_ref20 => {
  let [name] = _ref20;
  return ![...pricePivotAttributes, "Quantity"].includes(name || "");
}));

// src/helpers/window.ts
var windowPresent = typeof window !== "undefined";
var getFromLocalStorage = key => {
  if (!windowPresent) {
    return void 0;
  }
  return window.localStorage.getItem(key);
};
var saveToLocalStorage = (key, value) => {
  if (!windowPresent) {
    return;
  }
  window.localStorage.setItem(key, value);
};
var getCurrentUrl = () => {
  if (!windowPresent) {
    return "";
  }
  if (window.top) {
    try {
      return window.top.location.href;
    } catch (_error) {
      return window.location.href;
    }
  }
  return window.location.href;
};

// src/helpers/queryParams.ts
var generateSelectionParameters = _ref21 => {
  let {
    selectionParameter,
    comboSelectionParameter,
    quantityParameter,
    deliveryOptionIdParameter
  } = _ref21;
  const url = new URL(getCurrentUrl());
  if (selectionParameter) {
    url.searchParams.set("selection", decodeURIComponent(selectionParameter));
  }
  if (comboSelectionParameter) {
    url.searchParams.set("comboSelection", comboSelectionParameter);
  }
  if (quantityParameter) {
    url.searchParams.set("quantity", quantityParameter);
  }
  if (deliveryOptionIdParameter) {
    url.searchParams.set("deliveryOptionId", deliveryOptionIdParameter);
  }
  return url;
};
var setUrlParameters = _ref22 => {
  let {
    selectionParameter,
    comboSelectionParameter,
    quantityParameter,
    deliveryOptionIdParameter
  } = _ref22;
  if (selectionParameter || comboSelectionParameter || quantityParameter || deliveryOptionIdParameter) {
    const url = generateSelectionParameters({
      selectionParameter,
      comboSelectionParameter,
      quantityParameter,
      deliveryOptionIdParameter
    });
    if (window.top) {
      window.top.history.replaceState({
        state: url.href
      }, "", url.href);
    } else {
      window.history.replaceState({
        state: url.href
      }, "", url.href);
    }
  }
};
var deleteSearchParameter = searchParameter => {
  const url = new URL(getCurrentUrl());
  url.searchParams.delete(searchParameter);
  if (window.top) {
    window.top.history.replaceState({
      state: url.href
    }, "", url.href);
  } else {
    window.history.replaceState({
      state: url.href
    }, "", url.href);
  }
};
var getParamFromUrl = (url, param) => {
  if (!url) return void 0;
  const parsedUrl = new URL(url, window.location.origin);
  const value = parsedUrl.searchParams.get(param);
  if (!value) {
    return void 0;
  }
  return value;
};
var getSelectionFromUrl = (url, attributes) => {
  const selectionParam = getParamFromUrl(url, "selection");
  if (selectionParam && typeof selectionParam === "string") {
    try {
      const selection = Object.fromEntries(new URLSearchParams(selectionParam));
      const currentSelection = Object.entries(selection).reduce((correctSelectionObject, _ref23) => {
        let [key, value] = _ref23;
        const foundAttribute = attributes.find(attribute => attribute.pimAttributeName.toLowerCase() === key.toLowerCase());
        if (foundAttribute) {
          var _foundAttribute$value;
          const foundAttributeValue = (_foundAttribute$value = foundAttribute.values) === null || _foundAttribute$value === void 0 ? void 0 : _foundAttribute$value.find(attributeValue => attributeValue.pimAttributeValue.toLowerCase() === value.toLowerCase());
          if (foundAttributeValue) {
            return _objectSpread(_objectSpread({}, correctSelectionObject), {}, {
              [foundAttribute.pimAttributeName]: foundAttributeValue.pimAttributeValue
            });
          }
          return _objectSpread(_objectSpread({}, correctSelectionObject), {}, {
            [foundAttribute.pimAttributeName]: value
          });
        }
        if (key === "quantity") {
          return _objectSpread(_objectSpread({}, correctSelectionObject), {}, {
            Quantity: value
          });
        }
        return correctSelectionObject;
      }, {});
      if (Object.keys(currentSelection).length > 0) {
        return currentSelection;
      }
    } catch (_error) {
      return void 0;
    }
  }
  return void 0;
};
var getGroupFromUrl = url => {
  if (url === "") return [];
  const parsedUrl = new URL(url, window.location.origin);
  const comboSelectionParam = decodeURIComponent(parsedUrl.searchParams.get("comboSelection") || "");
  if (comboSelectionParam && typeof comboSelectionParam === "string") {
    const group = JSON.parse(comboSelectionParam);
    const currentGroup = group.map(entry => {
      const mappedGroup = Object.entries(entry).reduce((acc, _ref24) => {
        let [key, value] = _ref24;
        if (key === "quantity") {
          return _objectSpread(_objectSpread({}, acc), {}, {
            quantity: Number(value)
          });
        }
        return _objectSpread(_objectSpread({}, acc), {}, {
          attributes: _objectSpread(_objectSpread({}, acc.attributes), {}, {
            [key]: String(value)
          })
        });
      }, {});
      return mappedGroup;
    });
    return currentGroup;
  }
  return [];
};

// src/helpers/validation.ts
import { dequal } from "dequal";

// src/translations.ts
import { defineMessages } from "react-intl";
var translations = defineMessages({
  splitSizeAlert: {
    id: "selector.group.splitSizeAlertTitle",
    defaultMessage: "Your product is large, exceeding the width of {width}{widthUnit} and height of {height}{heightUnit}, and will be split up."
  },
  noQuantity: {
    id: "selector.grid.noquantity",
    defaultMessage: "Please fill in the quantity per size and hit the confirm button"
  },
  "number-of-sheets": {
    id: "selector.attribute.numberOfSheets",
    defaultMessage: "{value} Pages"
  },
  groupedquantity: {
    id: "selector.quantity.suffix",
    defaultMessage: "{value} pieces"
  },
  cm: {
    id: "unit.ofMeasure.cm",
    defaultMessage: "cm"
  },
  pcs: {
    id: "unit.ofMeasure.pcs",
    defaultMessage: "pcs"
  },
  mm: {
    id: "unit.ofMeasure.mm",
    defaultMessage: "mm"
  },
  "customQuantities.placeholder": {
    id: "pricetable.customQuantities.placeholder",
    defaultMessage: "Higher quantities"
  },
  printingType_none: {
    id: "pricetable.printingtype.title.none",
    defaultMessage: "None"
  },
  printingType_offset: {
    id: "pricetable.printingtype.title.offset",
    defaultMessage: "Offset"
  },
  printingType_digital: {
    id: "pricetable.printingtype.title.digital",
    defaultMessage: "Digital"
  },
  printingType_offsetordigital: {
    id: "pricetable.printingtype.title.offsetOrDigital",
    defaultMessage: "Offset or digital"
  },
  printingType_directtogarment: {
    id: "pricetable.printingtype.title.directToGarment",
    defaultMessage: "Direct to garment"
  },
  printingType_heattransfer: {
    id: "pricetable.printingtype.title.heatTransfer",
    defaultMessage: "Heat transfer"
  },
  printingType_laserengraving: {
    id: "pricetable.printingtype.title.laserEngraving",
    defaultMessage: "Laser engraving"
  },
  printingType_inkjet: {
    id: "pricetable.printingtype.title.inkJet",
    defaultMessage: "Ink jet"
  },
  printingType_inkjetuv: {
    id: "pricetable.printingtype.title.inkJetUV",
    defaultMessage: "Inkjet UV"
  },
  printingType_thermography: {
    id: "pricetable.printingtype.title.thermography",
    defaultMessage: "Thermography"
  },
  printingType_embroideryflat: {
    id: "pricetable.printingtype.title.embroideryFlat",
    defaultMessage: "Embroidery flat"
  },
  printingType_embroiderycylinder: {
    id: "pricetable.printingtype.title.embroideryCylinder",
    defaultMessage: "Embroidery cylinder"
  },
  printingType_sublimation: {
    id: "pricetable.printingtype.title.sublimation",
    defaultMessage: "Sublimation"
  },
  printingType_undefined: {
    id: "pricetable.printingtype.title.undefined",
    defaultMessage: "Undefined"
  },
  printingType_flexographic: {
    id: "pricetable.printingtype.title.flexoGraphic",
    defaultMessage: "Flexo Graphic"
  },
  printingType_flexography: {
    id: "pricetable.printingtype.title.flexoGraphic",
    defaultMessage: "Flexo Graphic"
  },
  printingType_screenprinting: {
    id: "pricetable.printingtype.title.screenPrinting",
    defaultMessage: "Screen Printing"
  },
  printingType_padprinting: {
    id: "pricetable.printingtype.title.padPrinting",
    defaultMessage: "Pad Printing"
  },
  printingType_engraving: {
    id: "pricetable.printingtype.title.engraving",
    defaultMessage: "Engraving"
  },
  printingType_fullcolorrotaryprint: {
    id: "pricetable.printingtype.title.fullcolorrotaryprint",
    defaultMessage: "Full Color Rotary Print"
  },
  printingType_embroidery: {
    id: "pricetable.printingtype.title.embroidery",
    defaultMessage: "Embroidery"
  },
  printingType_digitaltransfer: {
    id: "pricetable.printingtype.title.digitalTransfer",
    defaultMessage: "Digital Transfer"
  },
  printingType_screenprinttransfer: {
    id: "pricetable.printingtype.title.screenPrintTransfer",
    defaultMessage: "Screen Print Transfer"
  },
  printingType_unprinted: {
    id: "pricetable.printingtype.title.unprinted",
    defaultMessage: "Unprinted"
  },
  printingType_dyesublimation: {
    id: "pricetable.printingtype.title.dyeSublimation",
    defaultMessage: "Dye Sublimation"
  },
  description_none: {
    id: "pricetable.printingtype.description.none",
    defaultMessage: "None"
  },
  description_offset: {
    id: "pricetable.printingtype.description.offset",
    defaultMessage: "Offset"
  },
  description_digital: {
    id: "pricetable.printingtype.description.digital",
    defaultMessage: "Digital"
  },
  description_offsetordigital: {
    id: "pricetable.printingtype.description.offsetOrDigital",
    defaultMessage: "Offset or digital"
  },
  description_directtogarment: {
    id: "pricetable.printingtype.description.directToGarment",
    defaultMessage: "Direct to garment"
  },
  description_heattransfer: {
    id: "pricetable.printingtype.description.heatTransfer",
    defaultMessage: "Heat transfer"
  },
  description_laserengraving: {
    id: "pricetable.printingtype.description.laserEngraving",
    defaultMessage: "Laser engraving"
  },
  description_inkjet: {
    id: "pricetable.printingtype.description.inkJet",
    defaultMessage: "Ink jet"
  },
  description_inkjetuv: {
    id: "pricetable.printingtype.description.inkJetUV",
    defaultMessage: "Inkjet UV"
  },
  description_thermography: {
    id: "pricetable.printingtype.description.thermography",
    defaultMessage: "Thermography"
  },
  description_embroideryflat: {
    id: "pricetable.printingtype.description.embroideryFlat",
    defaultMessage: "Embroidery flat"
  },
  description_embroiderycylinder: {
    id: "pricetable.printingtype.description.embroideryCylinder",
    defaultMessage: "Embroidery cylinder"
  },
  description_sublimation: {
    id: "pricetable.printingtype.description.sublimation",
    defaultMessage: "Sublimation"
  },
  description_undefined: {
    id: "pricetable.printingtype.description.undefined",
    defaultMessage: "Undefined"
  },
  description_flexographic: {
    id: "pricetable.printingtype.description.flexoGraphic",
    defaultMessage: "Flexo Graphic"
  },
  description_screenprinting: {
    id: "pricetable.printingtype.description.screenPrinting",
    defaultMessage: "Screen Printing"
  },
  description_padprinting: {
    id: "pricetable.printingtype.description.padPrinting",
    defaultMessage: "Pad Printing"
  },
  description_engraving: {
    id: "pricetable.printingtype.description.engraving",
    defaultMessage: "Engraving"
  },
  description_fullcolorrotaryprint: {
    id: "pricetable.printingtype.description.fullcolorrotaryprint",
    defaultMessage: "Full Color Rotary Print"
  },
  description_embroidery: {
    id: "pricetable.printingtype.description.embroidery",
    defaultMessage: "Embroidery"
  },
  description_digitaltransfer: {
    id: "pricetable.printingtype.description.digitalTransfer",
    defaultMessage: "Digital Transfer"
  },
  description_screenprinttransfer: {
    id: "pricetable.printingtype.description.screenPrintTransfer",
    defaultMessage: "Screen Print Transfer"
  },
  description_unprinted: {
    id: "pricetable.printingtype.description.unprinted",
    defaultMessage: "Unprinted"
  },
  description_dyesublimation: {
    id: "pricetable.printingtype.description.dyeSublimation",
    defaultMessage: "Dye Sublimation"
  },
  description_flexography: {
    id: "pricetable.printingtype.description.flexography",
    defaultMessage: "Flexography"
  },
  headerFlag: {
    id: "pricetable.header.flag",
    defaultMessage: "Choose quantity and delivery"
  },
  showMoreQuantities: {
    id: "selector.quantity.showMore",
    defaultMessage: "Show more quantities"
  },
  showLessQuantities: {
    id: "selector.quantity.showLess",
    defaultMessage: "Show less quantities"
  },
  customQunatitySelectOptionText: {
    id: "pricetable.customQunatitySelectOption.text",
    defaultMessage: "Choose a quantity"
  },
  quantity: {
    id: "pricetable.header.quantity",
    defaultMessage: "Quantity"
  },
  totalGross: {
    id: "pricetable.pricemode.gross",
    defaultMessage: "Incl. VAT"
  },
  totalNet: {
    id: "pricetable.pricemode.net",
    defaultMessage: "Excl. VAT"
  },
  missingDeliveryType: {
    id: "selector.missing.deliverytype",
    defaultMessage: "Please choose sizes and genders so we can show the correct delivery date"
  },
  Normal: {
    id: "general.selector.pricetable.deliverymethod.normal",
    defaultMessage: "Normal"
  },
  "Next Day": {
    id: "general.selector.pricetable.deliverymethod.nextDay",
    defaultMessage: "Next Day"
  },
  Express: {
    id: "general.selector.pricetable.deliverymethod.express",
    defaultMessage: "Express"
  },
  noInventory: {
    id: "selector.quantity.noInventory",
    defaultMessage: "Insufficient inventory"
  }
});

// src/helpers/validation.ts
var createNumberArrayFromRange = range => {
  const {
    minimum,
    maximum,
    increment
  } = range;
  const amountOfValues = Math.floor((maximum - minimum) / increment) + 1;
  const rangeValues = Array.from({
    length: amountOfValues
  }, (_, index) => minimum + index * increment);
  return rangeValues;
};
var hasResolvedValue = (remainingOptionsPerGroup, attributeKey, value) => {
  const enabled = remainingOptionsPerGroup.filter(group => group.state !== "unresolvable").some(group => {
    const attributeOption = group.options.find(_ref25 => {
      let {
        key
      } = _ref25;
      return key === attributeKey;
    });
    if (!attributeOption || attributeOption.type !== "string") {
      return false;
    }
    return attributeOption.values.some(option => option.stringLiteral === value);
  });
  return enabled;
};
var getResolvedAttribute = (remainingOptions, attributeName) => {
  const foundAttribute = remainingOptions.find(option => option.key === attributeName);
  return foundAttribute;
};
var getResolvedNumericAttribute = (remainingOptions, attributeName) => {
  const resolvedAttribute = getResolvedAttribute(remainingOptions, attributeName);
  if (resolvedAttribute && resolvedAttribute.type === "numeric") {
    return resolvedAttribute;
  }
  return void 0;
};
var getResolvedStringAttribute = (remainingOptions, attributeName) => {
  const resolvedAttribute = getResolvedAttribute(remainingOptions, attributeName);
  if (resolvedAttribute && resolvedAttribute.type === "string") {
    return resolvedAttribute;
  }
  return void 0;
};
var getResolvedAttributeFromGroup = (remainingOptionsPerGroup, attributeName) => {
  const resolvedOptions = remainingOptionsPerGroup.filter(groupResult => groupResult.state !== "unresolvable");
  const index = resolvedOptions.findIndex(_ref26 => {
    let {
      options
    } = _ref26;
    return options.some(remainingOptions => remainingOptions.key === attributeName);
  });
  if (index === -1) {
    return void 0;
  }
  return getResolvedAttribute(resolvedOptions[index].options, attributeName);
};
var getResolvedNumericAttributeFromGroup = (remainingOptionsPerGroup, attributeName) => {
  const resolvedAttribute = getResolvedAttributeFromGroup(remainingOptionsPerGroup, attributeName);
  if (resolvedAttribute && resolvedAttribute.type === "numeric") {
    return resolvedAttribute;
  }
  return void 0;
};
var getResolvedStringAttributeFromGroup = (remainingOptionsPerGroup, attributeName) => {
  const resolvedAttribute = getResolvedAttributeFromGroup(remainingOptionsPerGroup, attributeName);
  if (resolvedAttribute && resolvedAttribute.type === "string") {
    return resolvedAttribute;
  }
  return void 0;
};
var getRangeMaximum = function (remainingOptionsPerGroup, attributeName) {
  let maximum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  const resolvedAttribute = getResolvedNumericAttributeFromGroup(remainingOptionsPerGroup, attributeName);
  const firstResolvedValue = resolvedAttribute === null || resolvedAttribute === void 0 ? void 0 : resolvedAttribute.values[0];
  const attributeMaximum = (firstResolvedValue === null || firstResolvedValue === void 0 ? void 0 : firstResolvedValue.type) === "range" ? firstResolvedValue.range.maximum : maximum;
  return attributeMaximum > maximum ? maximum : attributeMaximum;
};
var getSplitSizePanelInfo = (remainingOptions, currentPanel) => {
  const substrateWidthOption = getResolvedNumericAttributeFromGroup(remainingOptions, "Substrate Width");
  const substrateHeightOption = getResolvedNumericAttributeFromGroup(remainingOptions, "Substrate Height");
  const isSinglePanelProduct = hasResolvedValue(remainingOptions, "Product has Multiple Panels", "No");
  if (!isSinglePanelProduct && substrateWidthOption && substrateHeightOption) {
    const widthValue = substrateWidthOption.values[0];
    const heightValue = substrateHeightOption.values[0];
    if (widthValue.type !== "numberLiteral" || heightValue.type !== "numberLiteral") {
      return currentPanel;
    }
    return {
      openPanel: true,
      showMessage: true,
      panelName: "group",
      message: translations.splitSizeAlert,
      variant: "info",
      values: {
        width: widthValue.numberLiteral,
        widthUnit: substrateWidthOption.unitOfMeasure,
        height: heightValue.numberLiteral,
        heightUnit: substrateHeightOption.unitOfMeasure
      }
    };
  }
  return _objectSpread(_objectSpread({}, currentPanel), {}, {
    openPanel: false,
    panelName: currentPanel.panelName,
    showMessage: false
  });
};
var isGridCellValid = (row, column, remainingOptionsPerGroup) => {
  const groupAttribute = {
    [row.name]: row.value,
    [column.name]: column.value
  };
  const foundRemainingOptions = remainingOptionsPerGroup.find(options => options.groupAttribute && dequal(options.groupAttribute, groupAttribute));
  if (foundRemainingOptions) {
    if (foundRemainingOptions.state === "unresolvable") {
      return false;
    }
    const rowOptions = foundRemainingOptions.options.find(option => option.key === row.name);
    if (rowOptions !== void 0 && rowOptions.type === "string") {
      const rowValid = rowOptions.values.find(value => value.stringLiteral === row.value);
      if (rowValid) {
        const columnOptions = foundRemainingOptions.options.find(option => option.key === column.name);
        if (columnOptions !== void 0 && columnOptions.type === "string") {
          const columnValid = columnOptions.values.find(value => value.stringLiteral === column.value);
          return Boolean(columnValid !== void 0);
        }
        return false;
      }
      return false;
    }
    return false;
  }
  return true;
};
var getRemainingOptionsPerGroup = validationResults => validationResults.map(validation => ({
  options: validation.result.remainingOptions,
  groupAttribute: validation.groupAttribute,
  state: validation.result.state
}));
var updateAttributes = (attributes, remainingOptions) => {
  const mappedAttributes = attributes.map(attribute => {
    if (attribute.type === "group") {
      const updatedAttributes = attribute.attributes.map(groupAttribute => {
        const remainingAttribute = getResolvedNumericAttributeFromGroup(remainingOptions, groupAttribute.name);
        if (groupAttribute.type === "lor" && remainingAttribute) {
          var _groupAttribute$range;
          const hasRange = (_groupAttribute$range = groupAttribute.range) === null || _groupAttribute$range === void 0 ? void 0 : _groupAttribute$range.find(range => range.maximum && range.increment);
          const validationRanges = remainingAttribute.values.reduce((allRanges, value) => {
            if (value.type === "range") {
              return [...allRanges, _objectSpread(_objectSpread({}, value.range), {}, {
                unitOfMeasure: remainingAttribute.unitOfMeasure
              })];
            }
            return allRanges;
          }, []);
          if (hasRange) {
            return _objectSpread(_objectSpread({}, groupAttribute), {}, {
              range: validationRanges
            });
          }
        }
        return groupAttribute;
      });
      return _objectSpread(_objectSpread({}, attribute), {}, {
        attributes: updatedAttributes
      });
    }
    return attribute;
  });
  return mappedAttributes;
};

// src/helpers/product.ts
var getProductAttribute = (productAttributes, attributeName) => productAttributes.find(_ref27 => {
  let {
    pimAttributeName
  } = _ref27;
  return pimAttributeName === attributeName;
});
var getAttribute = (attributes, attributeName) => attributes.find(attribute => attribute.name === attributeName);
var getAttributeValue = (attributeValueName, attributeValues) => attributeValues === null || attributeValues === void 0 ? void 0 : attributeValues.find(value => value.pimAttributeValue === attributeValueName);
var getLockedAttributes = (selection, attributes, violatedAttributes) => violatedAttributes.map(attributeName => {
  const attribute = getAttribute(attributes, attributeName);
  return (attribute === null || attribute === void 0 ? void 0 : attribute.template) === "hidden" ? selection[attributeName] : void 0;
}).filter(Boolean);
var getRequiredAttributes = (attributes, arePriceAttributeRequired) => {
  if (arePriceAttributeRequired) {
    return attributes;
  }
  return attributes.reduce((requiredAttributes, attribute) => {
    if (attribute.type === "group") {
      return [...requiredAttributes, ...attribute.attributes];
    }
    if (!pricePivotAttributes.includes(attribute.name)) {
      return [...requiredAttributes, attribute];
    }
    return requiredAttributes;
  }, []);
};
var areRequiredAttributesSelected = _ref28 => {
  let {
    attributes,
    selection,
    arePriceAttributeRequired = false,
    group,
    includingGroup = false
  } = _ref28;
  const hasGroup = includingGroup && hasGroupedQuantity(attributes) && (group === null || group === void 0 ? void 0 : group.length);
  const requiredAttributes = getRequiredAttributes(attributes, arePriceAttributeRequired);
  const requiredAttributeNames = requiredAttributes.map(attribute => attribute.name);
  if (hasGroup) {
    const requiredGroupedAttributes = attributes.reduce((requiredAttributesNames, attribute) => {
      if (attribute.grid) {
        return [...requiredAttributesNames, attribute.grid.column.name, attribute.grid.row.name];
      }
      return requiredAttributesNames;
    }, []);
    return [...requiredAttributeNames, ...requiredGroupedAttributes].every(attributeName => Boolean(selection[attributeName]) || Boolean(group.some(groupSelection => Object.keys(groupSelection.attributes).includes(attributeName))));
  }
  return requiredAttributeNames.every(attributeName => Boolean(selection[attributeName]));
};
var getTotalQuantity2 = groups => groups.reduce((partialSum, group) => partialSum + Number(group.quantity), 0);

// src/components/selector/Attribute.tsx
import { useState as useState11, memo, useMemo as useMemo4, useRef as useRef3, useEffect as useEffect10 } from "react";
import { FormattedMessage as FormattedMessage15, useIntl as useIntl10 } from "react-intl";
import { Alert as Alert3, Collapsible as Collapsible2, LinkAsButton as LinkAsButton5 } from "@printdeal/ui-library";
import { configurationProvider as configurationProvider11 } from "@printdeal/configuration";

// src/hooks/useCollapseLogic.ts
import { useEffect, useState } from "react";
import { useExperiment } from "@printdeal/feature-management/react";

// src/hooks/useMachine.ts
import { useContext } from "react";

// src/contexts/SelectorContext.tsx
import React, { createContext } from "react";
import { createActorContext } from "@xstate/react";

// src/statemachines/selector/selector.machine.ts
import { assertEvent, assign, setup } from "xstate";

// src/helpers/arrivalDates.ts
var hasInsufficientInventory = arrivalDates => arrivalDates.some(date => date.date === "INVENTORY_INSUFFICIENT");
var getArrivalDate = (dates, deliveryType, printingProcess) => {
  var _dates$find;
  return dates === null || dates === void 0 || (_dates$find = dates.find(date => {
    if (!printingProcess) return date.deliveryType === deliveryType;
    return date.deliveryType === deliveryType && date.printingProcess === printingProcess;
  })) === null || _dates$find === void 0 ? void 0 : _dates$find.date;
};

// src/statemachines/guards/selectorGuards.ts
var isConfigurationInvalid = _ref29 => {
  let {
    context
  } = _ref29;
  const {
    attributes
  } = context;
  const totalUniqueAttributes = new Set(attributes.map(attribute => attribute.id)).size;
  return totalUniqueAttributes < attributes.length;
};
var isUnresolvable = (_, params) => params.groupValidationResult.every(validation => validation.result.state === "unresolvable");
var canPreselectAttribute = (_ref30, params) => {
  let {
    context
  } = _ref30;
  const {
    selection,
    attributes,
    totalQuantity,
    selectionMode
  } = context;
  if (selectionMode === "step-by-step") {
    const remainingOptions = getRemainingOptionsPerGroup(params.groupValidationResult);
    return getRequiredAttributes(attributes, false).some(attribute => {
      const attributeValue = getResolvedAttributeFromGroup(remainingOptions, attribute.name);
      if (!attributeValue || selection[attribute.name]) {
        return false;
      }
      if (attributeValue.values.length !== 1) {
        return false;
      }
      const [value] = attributeValue.values;
      if (value.type === "range") {
        return value.range.minimum === value.range.maximum;
      }
      return true;
    });
  }
  const fullySelected = areRequiredAttributesSelected({
    attributes,
    selection,
    arePriceAttributeRequired: true
  });
  const defaultSelectionHasGroupedQuantity = !getDefaultSelection(attributes).groupedQuantity;
  return !fullySelected || !defaultSelectionHasGroupedQuantity && !totalQuantity;
};
var canUnset = (_ref31, params) => {
  let {
    context
  } = _ref31;
  return params.groupValidationResult.some(validation => validation.result.violatedAttributes.some(attributeName => {
    const attribute = getAttribute(context.attributes, attributeName);
    return attributeName && (attribute === null || attribute === void 0 ? void 0 : attribute.template) !== "hidden";
  }));
};
var cannotUnset = (_ref32, params) => {
  let {
    context
  } = _ref32;
  return params.groupValidationResult.some(validation => validation.result.violatedAttributes.some(attributeName => {
    const attribute = getAttribute(context.attributes, attributeName);
    return attributeName && (attribute === null || attribute === void 0 ? void 0 : attribute.template) === "hidden";
  }));
};
var areAllRequiredAttributesSelected = _ref33 => {
  let {
    context
  } = _ref33;
  const {
    attributes,
    selection,
    group
  } = context;
  return areRequiredAttributesSelected({
    attributes,
    selection,
    group,
    includingGroup: true
  });
};
var shouldFetchServicePrices = _ref34 => {
  let {
    context
  } = _ref34;
  return context.serviceKeys.length > 0 && context.servicePrices === void 0 && context.serviceError !== "ServicePricingError";
};
var isSelectionInvalid = _ref35 => {
  var _event$attributeSelec;
  let {
    context,
    event
  } = _ref35;
  return Boolean(!event.valid && ((_event$attributeSelec = event.attributeSelection) === null || _event$attributeSelec === void 0 ? void 0 : _event$attributeSelec.name) && context.selectionMode === "step-by-step" && !pricePivotAttributes.includes(event.attributeSelection.name));
};
var insufficientInventory = (_ref36, params) => {
  let {
    context
  } = _ref36;
  return hasResolvedValue(context.remainingOptionsPerGroup, "InventoryCheck", "Yes") && hasInsufficientInventory(params.arrivalDates);
};
var hasInsufficientInventoryWithoutGroup = (_ref37, params) => {
  let {
    context
  } = _ref37;
  return hasResolvedValue(context.remainingOptionsPerGroup, "InventoryCheck", "Yes") && hasInsufficientInventory(params.arrivalDates) && hasGroupedQuantity(context.attributes) && !context.group.length;
};
var isInventoryInsufficient = (_ref38, params) => {
  var _params$inventory$fin, _inventory$availabili, _inventory$availabili2;
  let {
    context
  } = _ref38;
  const {
    totalQuantity
  } = context;
  const inventory = (_params$inventory$fin = params.inventory.find(_ref39 => {
    let {
      name
    } = _ref39;
    return name === context.selectedDeliveryOption.name;
  })) === null || _params$inventory$fin === void 0 ? void 0 : _params$inventory$fin.inventory;
  if (params.inventory.length === 0 && context.selectionMode === "default-values") {
    return true;
  }
  const firstAvailable = inventory === null || inventory === void 0 || (_inventory$availabili = inventory.availability) === null || _inventory$availabili === void 0 ? void 0 : _inventory$availabili.firstAvailable;
  const nextAvailable = inventory === null || inventory === void 0 || (_inventory$availabili2 = inventory.availability) === null || _inventory$availabili2 === void 0 ? void 0 : _inventory$availabili2.nextAvailable;
  if (!firstAvailable && !nextAvailable) {
    return false;
  }
  if (firstAvailable && !nextAvailable) {
    return totalQuantity > firstAvailable.inventory;
  }
  if (firstAvailable && nextAvailable && firstAvailable.inventory === 0) {
    return totalQuantity > nextAvailable.inventory;
  }
  if (firstAvailable && nextAvailable && firstAvailable.inventory > 0) {
    if (totalQuantity <= firstAvailable.inventory) {
      return false;
    }
    if (totalQuantity > firstAvailable.inventory && totalQuantity <= nextAvailable.inventory) {
      return false;
    }
    return totalQuantity > nextAvailable.inventory;
  }
  return false;
};
var isStepByStep = _ref40 => {
  let {
    context
  } = _ref40;
  return context.selectionMode === "step-by-step";
};

// src/statemachines/actions/selectorActions.ts
import { configurationProvider } from "@printdeal/configuration";

// src/helpers/dataLayer.ts
import { addDataLayerEntry } from "@printdeal/data-layer-manager";
var dispatchDataLayerEntry = (eventName, actionName, changes) => {
  const GA4Event = ["click", "display"].includes(actionName) ? "".concat(eventName, "_").concat(actionName) : actionName;
  addDataLayerEntry(GA4Event, _objectSpread({}, changes));
};

// src/statemachines/actions/selectorActions.ts
var sendPreselectedAttributeToGA = payload => {
  const {
    template,
    name,
    value
  } = payload;
  dispatchDataLayerEntry("selector", "click", {
    "element-type": template,
    "element-content": "attribute_value",
    "attribute-name": name,
    "attribute-value": value,
    "attribute-preselected": true
  });
};
var preselectAttribute = _ref41 => {
  let {
    context,
    event
  } = _ref41;
  const selection = _objectSpread({}, context.selection);
  const selectionAttributes = Object.keys(selection);
  const remainingOptions = getRemainingOptionsPerGroup(event.output);
  const quantity = getResolvedNumericAttributeFromGroup(remainingOptions, "Quantity");
  if (context.selectionMode === "step-by-step") {
    const requiredAttributes = getRequiredAttributes(context.attributes, false);
    const preSelectedAttributes = requiredAttributes.reduce((preSelectedSelection, attribute) => {
      var _attribute$values3;
      const attributeValue = getResolvedStringAttributeFromGroup(remainingOptions, attribute.name);
      const value = attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.values[0];
      if (((attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.values.length) === 1 || ((_attribute$values3 = attribute.values) === null || _attribute$values3 === void 0 ? void 0 : _attribute$values3.length) === 1) && (value === null || value === void 0 ? void 0 : value.type) === "stringLiteral") {
        var _attribute$values4;
        sendPreselectedAttributeToGA({
          template: attribute.template,
          name: attribute.name,
          value: value.stringLiteral
        });
        return _objectSpread(_objectSpread({}, preSelectedSelection), {}, {
          [attribute.name]: ((_attribute$values4 = attribute.values) === null || _attribute$values4 === void 0 ? void 0 : _attribute$values4.length) === 1 ? attribute.values[0].name : value.stringLiteral
        });
      }
      const attributeRange = getResolvedNumericAttributeFromGroup(remainingOptions, attribute.name);
      const number = attributeRange === null || attributeRange === void 0 ? void 0 : attributeRange.values[0];
      if ((attributeRange === null || attributeRange === void 0 ? void 0 : attributeRange.values.length) === 1 && (number === null || number === void 0 ? void 0 : number.type) === "range" && number.range.minimum === number.range.maximum) {
        sendPreselectedAttributeToGA({
          template: attribute.template,
          name: attribute.name,
          value: String(number.range.minimum)
        });
        return _objectSpread(_objectSpread({}, preSelectedSelection), {}, {
          [attribute.name]: String(number.range.minimum)
        });
      }
      if ((attributeRange === null || attributeRange === void 0 ? void 0 : attributeRange.values.length) === 1 && (number === null || number === void 0 ? void 0 : number.type) === "numberLiteral") {
        sendPreselectedAttributeToGA({
          template: attribute.template,
          name: attribute.name,
          value: number.numberLiteral
        });
        return _objectSpread(_objectSpread({}, preSelectedSelection), {}, {
          [attribute.name]: number.numberLiteral
        });
      }
      return preSelectedSelection;
    }, {});
    return {
      selection: _objectSpread(_objectSpread({}, selection), preSelectedAttributes),
      touchedAttributes: [...context.touchedAttributes, ...Object.keys(preSelectedAttributes)]
    };
  }
  context.attributes.some(_ref42 => {
    let {
      name,
      defaultValue
    } = _ref42;
    if (!selectionAttributes.includes(name)) {
      var _remainingAttributeOp;
      const remainingAttributeOptions = getResolvedStringAttributeFromGroup(remainingOptions, name);
      const attributeValue = remainingAttributeOptions === null || remainingAttributeOptions === void 0 || (_remainingAttributeOp = remainingAttributeOptions.values[0]) === null || _remainingAttributeOp === void 0 ? void 0 : _remainingAttributeOp.stringLiteral;
      if (defaultValue && remainingAttributeOptions !== null && remainingAttributeOptions !== void 0 && remainingAttributeOptions.values.some(_ref43 => {
        let {
          stringLiteral
        } = _ref43;
        return stringLiteral === defaultValue;
      })) {
        selection[name] = defaultValue;
        return selection;
      }
      if (attributeValue) {
        selection[name] = attributeValue;
        return selection;
      }
    }
    return void 0;
  });
  if (!hasGroupedQuantity(context.attributes) && !context.totalQuantity) {
    var _context$product, _context$product$cust;
    const quantityValue = quantity === null || quantity === void 0 ? void 0 : quantity.values[0];
    const defaultQuantity = (_context$product = context.product) !== null && _context$product !== void 0 && _context$product.isPimProduct ? (_context$product$cust = context.product.customProductQuantities) === null || _context$product$cust === void 0 ? void 0 : _context$product$cust[0] : (quantityValue === null || quantityValue === void 0 ? void 0 : quantityValue.type) === "range" && quantityValue.range.minimum || (quantityValue === null || quantityValue === void 0 ? void 0 : quantityValue.type) === "numberLiteral" && parseInt(quantityValue.numberLiteral, 10) || void 0;
    return {
      selection: _objectSpread(_objectSpread({}, selection), {}, {
        Quantity: String(defaultQuantity)
      }),
      totalQuantity: defaultQuantity
    };
  }
  return {
    selection
  };
};
var unsetAttribute = _ref44 => {
  let {
    context,
    event
  } = _ref44;
  const violated = event.output.filter(validation => validation.result.violatedAttributes.length);
  const [updatedSelection] = violated.map(violatedValidation => violatedValidation.result.violatedAttributes.reduce((selection, attributeName) => {
    const attribute = getAttribute(context.attributes, attributeName);
    if ((attribute === null || attribute === void 0 ? void 0 : attribute.template) !== "hidden") {
      const touchedAttributes = context.touchedAttributes.filter(touchedAttribute => touchedAttribute !== attributeName);
      const unsetSelection = Object.keys(selection.selection).length ? selection.selection : _objectSpread({}, context.selection);
      if (attributeName === "groupedQuantity") {
        unsetSelection[attributeName] = "1";
        return {
          selection: unsetSelection,
          group: [],
          totalQuantity: 1,
          touchedAttributes
        };
      }
      delete unsetSelection[attributeName];
      if (context.group.some(group => Object.keys(group.attributes).includes(attributeName))) {
        return {
          selection: unsetSelection,
          group: [],
          totalQuantity: selection.totalQuantity,
          touchedAttributes
        };
      }
      return {
        selection: unsetSelection,
        group: context.group,
        totalQuantity: selection.totalQuantity,
        touchedAttributes
      };
    }
    return selection;
  }, {
    selection: {},
    group: [],
    totalQuantity: context.totalQuantity,
    touchedAttributes: context.touchedAttributes
  }));
  return {
    selection: updatedSelection.selection,
    group: updatedSelection.group,
    totalQuantity: updatedSelection.totalQuantity || context.totalQuantity,
    touchedAttributes: updatedSelection.touchedAttributes,
    invalidSelection: {}
  };
};
var storePrices = _ref45 => {
  let {
    context,
    event
  } = _ref45;
  const {
    attributes,
    totalQuantity,
    selection,
    servicePrice
  } = context;
  const prices = event.output;
  Sentry.addTrace({
    category: "product-selector",
    message: "Price selected",
    data: {
      prices
    },
    level: "debug"
  });
  const combinedPrices = prices.flat();
  const {
    priceAttributes
  } = getPricePivot(attributes);
  const [printingProcess, deliveryType] = priceAttributes;
  const productPrice = combinedPrices.find(_ref46 => {
    let {
      name
    } = _ref46;
    return name === selection[printingProcess.name];
  });
  const pricesPerQuantity = productPrice === null || productPrice === void 0 ? void 0 : productPrice.quantities.reduce((quantities, _ref47) => {
    let {
      quantity,
      deliveryTypes
    } = _ref47;
    const deliveryTypesPerQuantity = deliveryTypes.filter(type => getSelectionValue(selection, type.name) && type.price);
    if (deliveryTypesPerQuantity.length > 0) {
      return [...quantities, {
        quantity,
        deliveryType: deliveryTypesPerQuantity[0]
      }];
    }
    return quantities;
  }, []);
  const selectedQuantity = productPrice === null || productPrice === void 0 ? void 0 : productPrice.quantities.find(_ref48 => {
    let {
      quantity
    } = _ref48;
    return quantity === (totalQuantity || (pricesPerQuantity === null || pricesPerQuantity === void 0 ? void 0 : pricesPerQuantity[0].quantity));
  });
  const updatedSelection = !totalQuantity && !hasGroupedQuantity(attributes) ? _objectSpread(_objectSpread({}, selection), {}, {
    Quantity: String(pricesPerQuantity === null || pricesPerQuantity === void 0 ? void 0 : pricesPerQuantity[0].quantity)
  }) : selection;
  const selectedPrice = selectedQuantity === null || selectedQuantity === void 0 ? void 0 : selectedQuantity.deliveryTypes.find(_ref49 => {
    let {
      name
    } = _ref49;
    return name === selection[deliveryType.name];
  });
  const allPriceAttributeValues = priceAttributes.flatMap(attribute => attribute.values || []);
  const alternativePrices = allPriceAttributeValues.reduce((alternativePriceAttributeValues, value) => {
    var _alternativePrice$pri, _selectedPrice$price;
    if (value.name === selection[printingProcess.name]) {
      return [...alternativePriceAttributeValues, {
        [value.name]: 0
      }];
    }
    const price = combinedPrices.find(_ref50 => {
      let {
        name
      } = _ref50;
      return name === value.name;
    });
    const alternativePriceQuantity = price === null || price === void 0 ? void 0 : price.quantities.find(_ref51 => {
      let {
        quantity
      } = _ref51;
      return quantity === totalQuantity;
    });
    const alternativePrice = (alternativePriceQuantity === null || alternativePriceQuantity === void 0 ? void 0 : alternativePriceQuantity.deliveryTypes.find(_ref52 => {
      let {
        name
      } = _ref52;
      return name === selection[deliveryType.name];
    })) || (selectedQuantity === null || selectedQuantity === void 0 ? void 0 : selectedQuantity.deliveryTypes.find(_ref53 => {
      let {
        name
      } = _ref53;
      return name === value.name;
    }));
    if (alternativePrice !== null && alternativePrice !== void 0 && (_alternativePrice$pri = alternativePrice.price) !== null && _alternativePrice$pri !== void 0 && _alternativePrice$pri.totalNet.centAmount && selectedPrice !== null && selectedPrice !== void 0 && (_selectedPrice$price = selectedPrice.price) !== null && _selectedPrice$price !== void 0 && _selectedPrice$price.totalNet.centAmount) {
      return [...alternativePriceAttributeValues, {
        [value.name]: alternativePrice.price.totalNet.centAmount - selectedPrice.price.totalNet.centAmount
      }];
    }
    return [...alternativePriceAttributeValues, {
      [value.name]: void 0
    }];
  }, []);
  return {
    prices: combinedPrices,
    price: selectedPrice === null || selectedPrice === void 0 ? void 0 : selectedPrice.price,
    totalPrice: getTotalPrice(selectedPrice === null || selectedPrice === void 0 ? void 0 : selectedPrice.price, servicePrice),
    alternativePrices,
    pricesPerQuantity,
    selection: updatedSelection,
    totalQuantity: updatedSelection.Quantity ? Number(updatedSelection.Quantity) : totalQuantity
  };
};
var storePricing = _ref54 => {
  var _product$customProduc;
  let {
    context,
    event
  } = _ref54;
  const {
    totalQuantity,
    customQuantity,
    selectionMode,
    selectedDeliveryOption,
    product,
    servicePrice
  } = context;
  const [prices] = event.output;
  const hasDefaultValues = selectionMode === "default-values";
  const customQuantitySelected = !(product !== null && product !== void 0 && (_product$customProduc = product.customProductQuantities) !== null && _product$customProduc !== void 0 && _product$customProduc.includes(totalQuantity));
  return _objectSpread({
    prices: event.output,
    customQuantity: customQuantitySelected ? totalQuantity : customQuantity
  }, hasDefaultValues && _objectSpread({}, getDefaultValuesPrices(prices, selectedDeliveryOption.name, totalQuantity, servicePrice)));
};
var storePivotPrices = _ref55 => {
  let {
    event
  } = _ref55;
  return {
    pivotPrices: event.output
  };
};
var storeDeliveryDates = _ref56 => {
  let {
    context,
    event
  } = _ref56;
  const deliveryOption = getDeliveryOption(event.output, context.selectedDeliveryOption);
  return _objectSpread({
    deliveryDates: event.output
  }, event.output.length > 0 && {
    selectedDeliveryOption: deliveryOption !== null && deliveryOption !== void 0 && deliveryOption.id ? deliveryOption : event.output.find(_ref57 => {
      let {
        name
      } = _ref57;
      return name === "Normal";
    })
  });
};
var initializeContext = _ref58 => {
  let {
    event
  } = _ref58;
  return {
    attributes: event.attributes,
    attributesCount: event.attributes.length,
    selection: event.selection,
    group: event.group,
    groupAttributes: event.groupAttributes,
    totalQuantity: Number(event.totalQuantity),
    productKey: event.productKey,
    serviceKeys: event.serviceKeys,
    selectedService: void 0,
    mcpSku: event.mcpSku,
    shippingAddress: event.shippingAddress,
    touchedAttributes: event.touchedAttributes,
    customerGroupId: event.customerGroupId,
    invalidSelection: {},
    panel: event.panel,
    device: event.device,
    isReviewPage: event.isReviewPage,
    selectionMode: event.selectionMode,
    product: event.product,
    selectedDeliveryOption: {
      id: event.selectedDeliveryOptionId,
      name: "Normal"
    }
  };
};
var storeRemainingOptions = _ref59 => {
  let {
    context,
    event
  } = _ref59;
  const remainingOptionsPerGroup = getRemainingOptionsPerGroup(event.output);
  return {
    remainingOptionsPerGroup,
    artworkRequired: hasResolvedValue(remainingOptionsPerGroup, "Artwork Required", "Yes"),
    productAttributes: event.output[0].result.attributes,
    panel: getSplitSizePanelInfo(remainingOptionsPerGroup, context.panel),
    attributes: updateAttributes(context.attributes, remainingOptionsPerGroup)
  };
};
var updateSelection = _ref60 => {
  let {
    context,
    event
  } = _ref60;
  const {
    groupSelection,
    attributeSelection,
    groupedAttributes,
    valid,
    groupName
  } = event;
  const defaultValueNoPrintArea = 1;
  if (groupedAttributes) {
    return _objectSpread(_objectSpread({
      selection: _objectSpread(_objectSpread({}, context.selection), groupedAttributes)
    }, groupName && {
      touchedAttributes: [groupName, ...context.touchedAttributes]
    }), groupedAttributes.Quantity && {
      totalQuantity: Number(groupedAttributes.Quantity)
    });
  }
  if (groupSelection) {
    const totalQuantity = getTotalQuantity2(groupSelection);
    return {
      selection: _objectSpread(_objectSpread({}, context.selection), {}, {
        groupedQuantity: String(totalQuantity)
      }),
      group: groupSelection,
      totalQuantity,
      panel: {
        openPanel: false,
        panelName: "groupedQuantity"
      },
      touchedAttributes: [...context.touchedAttributes, "groupedQuantity"]
    };
  }
  if (attributeSelection) {
    var _conditionalAttribute;
    if (attributeSelection.name === "Print Area" && attributeSelection.value === "No Print") {
      return _objectSpread(_objectSpread({
        selection: _objectSpread(_objectSpread({}, context.selection), {}, {
          [attributeSelection.name]: attributeSelection.value,
          groupedQuantity: String(defaultValueNoPrintArea)
        }),
        totalQuantity: defaultValueNoPrintArea,
        group: []
      }, !valid && {
        invalidSelection: {
          [attributeSelection.name]: attributeSelection.value,
          groupedQuantity: String(defaultValueNoPrintArea)
        }
      }), {}, {
        touchedAttributes: [...context.touchedAttributes, attributeSelection.name]
      });
    }
    if (["groupedQuantity", "Quantity"].includes(attributeSelection.name)) {
      return {
        selection: _objectSpread(_objectSpread({}, context.selection), {}, {
          [attributeSelection.name]: attributeSelection.value
        }),
        totalQuantity: Number(attributeSelection.value),
        group: [],
        touchedAttributes: [...context.touchedAttributes, attributeSelection.name]
      };
    }
    const conditionalAttribute = context.attributes.find(attribute => attribute.isConditionalAttribute);
    const conditionChanged = conditionalAttribute === null || conditionalAttribute === void 0 || (_conditionalAttribute = conditionalAttribute.conditionalAttributeRules) === null || _conditionalAttribute === void 0 ? void 0 : _conditionalAttribute.includes(attributeSelection.name);
    if (conditionChanged && (conditionalAttribute === null || conditionalAttribute === void 0 ? void 0 : conditionalAttribute.type) === "group") {
      const conditionalAttributes = conditionalAttribute.attributes.map(attribute => attribute.name);
      const newSelection = _objectSpread({}, context.selection);
      conditionalAttributes.forEach(attributeName => {
        delete newSelection[attributeName];
      });
      return {
        selection: _objectSpread(_objectSpread({}, newSelection), {}, {
          [attributeSelection.name]: attributeSelection.value
        }),
        invalidSelection: valid ? {} : {
          [attributeSelection.name]: attributeSelection.value
        },
        touchedAttributes: [...context.touchedAttributes, attributeSelection.name],
        price: void 0
      };
    }
    return {
      selection: _objectSpread(_objectSpread({}, context.selection), {}, {
        [attributeSelection.name]: attributeSelection.value
      }),
      invalidSelection: valid ? {} : {
        [attributeSelection.name]: attributeSelection.value
      },
      touchedAttributes: [...context.touchedAttributes, attributeSelection.name],
      price: void 0
    };
  }
  return context;
};
var restoreDefaults = _ref61 => {
  let {
    context,
    event
  } = _ref61;
  Sentry.addTrace({
    category: "product-selector",
    message: "Restored to defaults",
    level: "debug",
    data: event
  });
  const attributes = event.attributes || context.attributes;
  return {
    selection: getDefaultSelection(attributes),
    attributes,
    group: [],
    totalQuantity: Number(getDefaultSelection(attributes).groupedQuantity) || 0,
    invalidSelection: {},
    touchedAttributes: [],
    device: context.device,
    merchantRules: {
      deliveryTool: {}
    },
    price: void 0,
    prices: [],
    totalPrice: void 0,
    originalTotalPrice: void 0,
    selectedService: void 0,
    servicePrices: void 0,
    selectedDeliveryOption: {
      name: "Normal"
    },
    selectionMode: event.selectionMode || context.selectionMode,
    panel: {
      openPanel: false,
      showMessage: false,
      panelName: ""
    },
    productRouteClicked: false
  };
};
var storeInvalidSelection = _ref62 => {
  let {
    event
  } = _ref62;
  return _objectSpread({}, event.attributeSelection && {
    invalidSelection: {
      [event.attributeSelection.name]: event.attributeSelection.value
    }
  });
};
var replaceSelection = _ref63 => {
  let {
    context,
    event
  } = _ref63;
  Sentry.addTrace({
    category: "product-selector",
    message: "Product route selected",
    data: {
      selection: event.selection
    },
    level: "debug"
  });
  const {
    isPimProduct
  } = context.product || {};
  const {
    selection,
    groupSelection,
    touchedAttributes: attributes,
    totalQuantity,
    deliveryOption
  } = event;
  const touchedAttributes = attributes || Object.keys(selection);
  const selectedDeliveryOption = (deliveryOption === null || deliveryOption === void 0 ? void 0 : deliveryOption.id) && context.deliveryDates.find(_ref64 => {
    let {
      id
    } = _ref64;
    return id === (deliveryOption === null || deliveryOption === void 0 ? void 0 : deliveryOption.id);
  }) || deliveryOption;
  if (groupSelection.length > 0) {
    const groupedQuantity = getTotalQuantity2(groupSelection);
    return _objectSpread({
      selection: _objectSpread(_objectSpread({}, selection), {}, {
        groupedQuantity: String(groupedQuantity)
      }),
      group: groupSelection,
      totalQuantity: groupedQuantity,
      panel: {
        openPanel: false,
        panelName: "groupedQuantity"
      },
      touchedAttributes: [...touchedAttributes, "groupedQuantity"]
    }, isPimProduct && selectedDeliveryOption && {
      selectedDeliveryOption
    });
  }
  return _objectSpread({
    selection,
    group: groupSelection,
    totalQuantity,
    touchedAttributes,
    productRouteClicked: true
  }, isPimProduct && selectedDeliveryOption && {
    selectedDeliveryOption
  });
};
var selectService = _ref65 => {
  var _context$servicePrice;
  let {
    context,
    event
  } = _ref65;
  return {
    selectedService: event.selectedService,
    totalPrice: getTotalPrice(context.price, (_context$servicePrice = context.servicePrices) === null || _context$servicePrice === void 0 ? void 0 : _context$servicePrice[event.selectedService])
  };
};
var togglePanel = _ref66 => {
  var _event$openPanel, _event$showMessage;
  let {
    context,
    event
  } = _ref66;
  return {
    panel: {
      panelName: event.panelName || context.panel.panelName,
      openPanel: (_event$openPanel = event.openPanel) !== null && _event$openPanel !== void 0 ? _event$openPanel : !context.panel.openPanel,
      showMessage: (_event$showMessage = event.showMessage) !== null && _event$showMessage !== void 0 ? _event$showMessage : context.panel.showMessage,
      values: event.values,
      variant: event.variant,
      message: event.message
    }
  };
};
var setPrice = _ref67 => {
  var _context$servicePrice2;
  let {
    context,
    event
  } = _ref67;
  const servicePrice = context.selectedService && ((_context$servicePrice2 = context.servicePrices) === null || _context$servicePrice2 === void 0 ? void 0 : _context$servicePrice2[context.selectedService]) || void 0;
  return {
    price: event.price,
    originalTotalPrice: getTotalPrice(event.originalPrice, servicePrice),
    totalPrice: getTotalPrice(event.price, servicePrice),
    priceAttributes: event.priceAttributes
  };
};
var setQuantity = _ref68 => {
  let {
    context,
    event
  } = _ref68;
  return {
    totalQuantity: Number(event.quantity),
    touchedAttributes: [...context.touchedAttributes, "Quantity"]
  };
};
var setCustomQuantity = _ref69 => {
  var _context$product$cust2, _context$product$cust3, _context$product$cust4;
  let {
    context,
    event
  } = _ref69;
  if (!context.product) {
    return {
      product: context.product,
      touchedAttributes: context.touchedAttributes
    };
  }
  return {
    product: _objectSpread(_objectSpread({}, context.product), {}, {
      customProductQuantities: context.customQuantity ? [...((_context$product$cust2 = (_context$product$cust3 = context.product.customProductQuantities) === null || _context$product$cust3 === void 0 ? void 0 : _context$product$cust3.slice(0, -1)) !== null && _context$product$cust2 !== void 0 ? _context$product$cust2 : []), event.customQuantity] : (_context$product$cust4 = context.product.customProductQuantities) === null || _context$product$cust4 === void 0 ? void 0 : _context$product$cust4.concat(event.customQuantity)
    }),
    totalQuantity: event.customQuantity,
    customQuantity: event.customQuantity,
    touchedAttributes: [...context.touchedAttributes, "Quantity"]
  };
};
var setDeliveryOption = _ref70 => {
  let {
    context,
    event
  } = _ref70;
  return {
    selectedDeliveryOption: event.deliveryOption,
    touchedAttributes: [...context.touchedAttributes, "Delivery Option"]
  };
};
var shouldLogViolationError = () => {
  try {
    return configurationProvider.getValueAsBoolean("PRODUCT_SELECTOR_LOG_VIOLATION_ERRORS");
  } catch (_error) {
    return true;
  }
};
var logViolationError = _ref71 => {
  let {
    context,
    event
  } = _ref71;
  if (!shouldLogViolationError()) {
    return;
  }
  const {
    selection,
    attributes
  } = context;
  const lockedAttributes = event.output.map(validation => getLockedAttributes(selection, attributes, validation.result.violatedAttributes));
  Sentry.exception({
    exception: "Attribute-revalidation expects unsetting locked attributes, but cannot.",
    tags: {
      component: "printdeal-selector",
      eventName: "FailedLockedAttributeRevalidation",
      fileLocation: "SelectorActions",
      featureFunction: "correctProductConfigToValid"
    },
    extra: {
      userSelection: JSON.stringify(selection),
      violatedAttributes: JSON.stringify(event.output.map(validation => validation.result.violatedAttributes)),
      correctionFailureLockedAttributes: JSON.stringify(lockedAttributes)
    },
    fingerprint: ["printdeal-selector-correct-product-config-to-valid-failed-locked-attribute-revalidation"]
  });
};
var logError = (data, selection, featureFunction, extra, error, fileLocation, fingerprint) => Sentry.exception({
  exception: error || ("error" in data && data.error instanceof Error ? data.error : "An error occurred in the selector machine"),
  tags: {
    component: "printdeal-selector",
    fileLocation: fileLocation || "SelectorActions",
    featureFunction
  },
  extra: _objectSpread({
    userSelection: JSON.stringify(selection),
    data: JSON.stringify(data)
  }, extra),
  fingerprint: [fingerprint || featureFunction]
});
var storeInventory = _ref72 => {
  let {
    event,
    context
  } = _ref72;
  if (event.output.length === 0) {
    return {
      inventory: context.inventory
    };
  }
  const inventory = event.output.reduce((inventoryInfo, deliveryInfo) => {
    var _deliveryInfo$invento;
    return [...inventoryInfo, _objectSpread(_objectSpread({}, deliveryInfo.inventory), {}, {
      deliveryOption: deliveryInfo.name,
      maxAvailableInventory: (_deliveryInfo$invento = deliveryInfo.inventory) === null || _deliveryInfo$invento === void 0 || (_deliveryInfo$invento = _deliveryInfo$invento.availability) === null || _deliveryInfo$invento === void 0 || (_deliveryInfo$invento = _deliveryInfo$invento.nextAvailable) === null || _deliveryInfo$invento === void 0 ? void 0 : _deliveryInfo$invento.inventory
    })];
  }, []);
  return {
    inventory
  };
};

// src/statemachines/actors/selectorActors.ts
import { fromPromise } from "xstate";

// src/http-clients/contentfulClient.ts
import axios from "axios";
import { configurationProvider as configurationProvider2 } from "@printdeal/configuration";
var getProductContentQuery = storeKey => "\n  query GetProductContent($productPageId: String!, $locale: String!) {\n    productContent(id: $productPageId, locale: $locale) {\n      ".concat(storeKey !== "drukwerkdeal-nl" ? "sharedSelector { sys { urn } }" : "", "\n      selectorCollection(limit: 1) {\n        items {\n          ... on ProductSelector {\n            productSelector: sys {\n              id\n            }\n          }\n        }\n      }\n      selectorExperiment {\n        ... on Experiment {\n          experiment: sys {\n              id\n          }\n          experimentId\n        }\n      }\n    }\n  }\n");
var productFragments = "\nfragment AttributeValue on AttributeValue {\n    sys {\n      id\n    }\n    pimAttributeValue\n    attributeValueAlias\n    attributeValueImage {\n      sys {\n        id\n      }\n      title\n      url\n      width\n      height\n    }\n    supportArticle {\n      sys {\n        id\n      }\n    }\n  }\n\n  fragment Attribute on Attribute {\n    sys {\n      id\n    }\n    attributeAlias\n    pimAttributeName\n    attributeValueCollection(limit: 140) {\n      items {\n        ...AttributeValue\n      }\n    }\n    supportArticle {\n      sys {\n        id\n      }\n    }\n  }\n\n  fragment Product on Product {\n    sys {\n      id\n    }\n    key\n    mcpSku\n    productName\n    isPimProduct\n    customProductQuantities\n    productVersion\n    attributesCollection(limit: 25) {\n      items {\n        ...Attribute\n      }\n    }\n  }\n";
var fragments = "\n  ".concat(productFragments, "\n  fragment ProductSelector on ProductSelector {\n    sys {\n      id\n    }\n    product {\n      ...Product\n    }\n    selectionMode\n    configuration\n  }\n\n  fragment SelectorOverrides on SelectorOverrides {\n    sys {\n      id\n    }\n    title\n    overrides\n  }\n");
var productSelectorQuery = "\n  ".concat(fragments, "\n\n  query Selector($selectorId: String!, $locale: String!) {\n    productSelector(id: $selectorId, locale: $locale) {\n      ...ProductSelector\n    }\n    selectorOverridesCollection {\n      items {\n        ...SelectorOverrides\n      }\n    }\n  }\n");
var supportArticleContentQuery = "\n  query($id: String!, $locale: String!) {\n    supportArticlePage(id: $id, locale: $locale) {\n      sys {\n        id\n      }\n      slug\n      title\n      category {\n        slug\n      }\n      gallery {\n        sys {\n          id\n        }\n        title\n        imagesCollection {\n          items {\n            sys {\n              id\n            }\n            title\n            url\n            width\n            height\n          }\n        }\n      }\n      heroImage {\n        sys {\n          id\n        }\n        title\n        url\n        width\n        height\n      }\n      summary\n      content\n      faqsCollection {\n        items {\n          sys {\n            id\n          }\n          title\n          content\n        }\n      }\n    }\n  }\n";
var systemPageContentQuery = "\n  query($pageSystemType: String!, $locale: String!) {\n    pageSystemCollection(\n      where: { pageSytemType: $pageSystemType }\n      locale: $locale\n    ) {\n      items {\n        slug\n      }\n    }\n  }\n";
var sizeTableContentQuery = "\n  query($productPageId: String!, $locale: String!) {\n    productContent(id: $productPageId, locale: $locale) {\n      productTabsCollection(where: { type: \"size-table\" }) {\n        items {\n          sys {\n            id\n          }\n          displayTitle\n          content\n        }\n      }\n    }\n  }\n";
var getExperimentContentQuery = variation => "\n  query($experimentContentId: String!, $locale: String!) {\n    experiment(id: $experimentContentId, locale: $locale) {\n      ".concat(variation, " {\n        ... on ProductSelector {\n          productSelector: sys {\n            id\n          }\n        }\n      }\n    }\n  }\n");
var useNewSelectorQuery = "\n  query($productPageId: String!, $locale: String!) {\n    productContent(id: $productPageId, locale: $locale) {\n      useNewSelector\n    }\n  }\n";
var ExperimentContentQuery = "\n  query($productPageId: String!, $locale: String!) {\n    productContent(id: $productPageId, locale: $locale) {\n      selectorExperiment {\n        ... on Experiment {\n          experiment: sys {\n              id\n          }\n          experimentId\n        }\n      }\n    }\n  }\n";
var productQuery = "\n  ".concat(productFragments, "\n\n  query Product($productKey: String!, $locale: String!) {\n    product (id: $productKey, locale: $locale) {\n      ...Product\n    }\n  }\n");
var mapConfigurationValueToAttribute = value => ({
  id: value.id,
  name: value.name,
  enabled: value.enabled,
  conditionalAttributeValueRules: value.conditionalAttributeValueRules
});
var mapProductAttributeValues = value => ({
  id: value.sys.id,
  pimAttributeValue: value.pimAttributeValue,
  attributeValueAlias: value.attributeValueAlias,
  attributeValueImage: value.attributeValueImage ? {
    id: value.attributeValueImage.sys.id,
    url: value.attributeValueImage.url,
    title: value.attributeValueImage.title,
    width: value.attributeValueImage.width,
    height: value.attributeValueImage.height
  } : void 0,
  supportArticle: value.supportArticle ? {
    id: value.supportArticle.sys.id
  } : void 0
});
var filterAndMapAttributeValues = (attributeValues, selectorOverrides, attributeName, mapFunction, getValueName) => {
  const attributeValuesOverrideArray = selectorOverrides.find(override => typeof override.overrides.disabledOptions[attributeName] !== "undefined");
  const attributeValuesToOverride = attributeValuesOverrideArray === null || attributeValuesOverrideArray === void 0 ? void 0 : attributeValuesOverrideArray.overrides.disabledOptions[attributeName];
  return attributeValues.filter(value => !(attributeValuesToOverride !== null && attributeValuesToOverride !== void 0 && attributeValuesToOverride.includes(getValueName(value)))).map(mapFunction);
};
var convertToSelectorContent = (contentfulSelector, selectorOverrides) => {
  var _contentfulSelector$p;
  return {
    id: contentfulSelector.sys.id,
    product: {
      id: contentfulSelector.product.sys.id,
      key: contentfulSelector.product.key,
      mcpSku: contentfulSelector.product.mcpSku,
      productName: contentfulSelector.product.productName,
      isPimProduct: contentfulSelector.product.isPimProduct,
      customProductQuantities: (_contentfulSelector$p = contentfulSelector.product.customProductQuantities) === null || _contentfulSelector$p === void 0 ? void 0 : _contentfulSelector$p.map(quantity => Number(quantity)),
      productVersion: contentfulSelector.product.productVersion,
      attributes: contentfulSelector.product.attributesCollection.items.map(item => ({
        id: item.sys.id,
        attributeAlias: item.attributeAlias,
        pimAttributeName: item.pimAttributeName,
        supportArticle: item.supportArticle ? {
          id: item.supportArticle.sys.id
        } : void 0,
        values: filterAndMapAttributeValues(item.attributeValueCollection.items, selectorOverrides, item.pimAttributeName, mapProductAttributeValues, value => value.pimAttributeValue)
      }))
    },
    selectionMode: contentfulSelector.selectionMode,
    configuration: {
      // @ts-expect-error - TODO: Fix prior to merge
      attributes: contentfulSelector.configuration.attributes.map(attribute => {
        var _attribute$values5, _attribute$grid$colum, _attribute$grid$row$v;
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          id: attribute.id,
          name: attribute.name,
          type: attribute.type,
          pimName: attribute.pimName,
          template: attribute.template,
          defaultValue: attribute.defaultValue,
          disablePopularOptions: attribute.disablePopularOptions,
          invalidValuesVisibility: attribute.invalidValuesVisibility
        }, attribute.onReviewPage && {
          onReviewPage: attribute.onReviewPage
        }), attribute.hasSizesDiffer && {
          hasSizesDiffer: attribute.hasSizesDiffer
        }), ((_attribute$values5 = attribute.values) === null || _attribute$values5 === void 0 ? void 0 : _attribute$values5.length) && {
          values: filterAndMapAttributeValues(attribute.values, selectorOverrides, attribute.name, mapConfigurationValueToAttribute, value => value.name)
        }), attribute.groupTitle && {
          groupTitle: attribute.groupTitle
        }), attribute.isConditionalAttribute && {
          isConditionalAttribute: attribute.isConditionalAttribute
        }), attribute.conditionalAttributeRules && {
          conditionalAttributeRules: attribute.conditionalAttributeRules
        }), attribute.type === "group" && {
          attributes: attribute.attributes
        }), attribute.grid && {
          grid: {
            invalidValuesVisibility: attribute.grid.invalidValuesVisibility,
            column: {
              id: attribute.grid.column.id,
              name: attribute.grid.column.name,
              type: attribute.grid.column.type,
              pimName: attribute.grid.column.pimName,
              template: attribute.grid.column.template,
              defaultValue: attribute.grid.column.defaultValue,
              invalidValuesVisibility: attribute.grid.column.invalidValuesVisibility,
              values: (_attribute$grid$colum = attribute.grid.column.values) === null || _attribute$grid$colum === void 0 ? void 0 : _attribute$grid$colum.map(value => ({
                id: value.id,
                name: value.name,
                enabled: value.enabled
              }))
            },
            row: {
              id: attribute.grid.row.id,
              name: attribute.grid.row.name,
              type: attribute.grid.row.type,
              pimName: attribute.grid.row.pimName,
              template: attribute.grid.row.template,
              defaultValue: attribute.grid.row.defaultValue,
              invalidValuesVisibility: attribute.grid.row.invalidValuesVisibility,
              values: (_attribute$grid$row$v = attribute.grid.row.values) === null || _attribute$grid$row$v === void 0 ? void 0 : _attribute$grid$row$v.map(value => ({
                id: value.id,
                name: value.name,
                enabled: value.enabled
              }))
            }
          }
        });
      }),
      variantSku: contentfulSelector.configuration.variantSku
    }
  };
};
var convertToSupportArticleContent = contentfulSupportArticle => {
  var _contentfulSupportArt;
  return {
    id: contentfulSupportArticle.sys.id,
    slug: contentfulSupportArticle.slug,
    title: contentfulSupportArticle.title,
    categorySlug: (_contentfulSupportArt = contentfulSupportArticle.category) === null || _contentfulSupportArt === void 0 ? void 0 : _contentfulSupportArt.slug,
    gallery: contentfulSupportArticle.gallery && {
      id: contentfulSupportArticle.gallery.sys.id,
      title: contentfulSupportArticle.gallery.title,
      images: contentfulSupportArticle.gallery.imagesCollection.items.map(item => ({
        id: item.sys.id,
        title: item.title,
        url: item.url,
        width: item.width,
        height: item.height
      }))
    },
    heroImage: contentfulSupportArticle.heroImage && {
      id: contentfulSupportArticle.heroImage.sys.id,
      title: contentfulSupportArticle.heroImage.title,
      url: contentfulSupportArticle.heroImage.url,
      width: contentfulSupportArticle.heroImage.width,
      height: contentfulSupportArticle.heroImage.height
    },
    summary: contentfulSupportArticle.summary,
    content: contentfulSupportArticle.content,
    faqs: contentfulSupportArticle.faqsCollection.items.map(item => ({
      id: item.sys.id,
      title: item.title,
      content: item.content
    }))
  };
};
var convertToSystemPage = systemPageData => ({
  slug: systemPageData.pageSystemCollection.items[0].slug
});
var convertToSizeTableContent = contentfulSizeTable => {
  if (!contentfulSizeTable.productContent.productTabsCollection.items.length) {
    return null;
  }
  const item = contentfulSizeTable.productContent.productTabsCollection.items[0];
  return {
    id: item.sys.id,
    title: item.displayTitle,
    content: item.content
  };
};
var getProductData = async (productKey, locale) => {
  const spaceId = configurationProvider2.getValue("CONTENTFUL_SPACE_ID");
  const accessToken = configurationProvider2.getValue("CONTENTFUL_ACCESS_TOKEN");
  const environment = configurationProvider2.getValue("CONTENTFUL_ENVIRONMENT");
  const client = axios.create({
    baseURL: "https://graphql.contentful.com/content/v1/spaces/".concat(spaceId, "/environments/").concat(environment),
    headers: {
      Authorization: "Bearer ".concat(accessToken)
    }
  });
  const {
    data
  } = await client.post("/", {
    query: productQuery,
    variables: {
      productKey,
      locale
    }
  });
  return data.data;
};
var getSharedSelectorContent = async (selectorId, locale) => {
  if (!selectorId || !locale) {
    throw new Error("No selector id or locale provided");
  }
  try {
    const spaceId = configurationProvider2.getValue("CONTENTFUL_DWD_SPACE_ID");
    const accessToken = configurationProvider2.getValue("CONTENTFUL_DWD_ACCESS_TOKEN");
    const client = axios.create({
      baseURL: "https://graphql.contentful.com/content/v1/spaces/".concat(spaceId, "/environments/master"),
      headers: {
        Authorization: "Bearer ".concat(accessToken)
      }
    });
    const {
      data
    } = await client.post("/", {
      query: productSelectorQuery,
      variables: {
        selectorId,
        locale: "nl-NL"
      }
    });
    const productKey = data.data.productSelector.product.key;
    const productData = await getProductData(productKey, locale);
    data.data.productSelector.product = productData.product;
    return convertToSelectorContent(data.data.productSelector, data.data.selectorOverridesCollection.items);
  } catch (error) {
    Sentry.exception({
      exception: error,
      tags: {
        fileLocation: "contentfulClient",
        featureFunction: "getSharedSelectorContent"
      },
      fingerprint: ["get-shared-selector-content"]
    });
    throw new Error("Something went wrong while fetching the shared selector content from Contentful", {
      cause: error
    });
  }
};
var ContentfulClient = class ContentfulClient {
  constructor() {
    _defineProperty(this, "httpClient", void 0);
  }
  get client() {
    if (!this.httpClient) {
      const spaceId = configurationProvider2.getValue("CONTENTFUL_SPACE_ID");
      const environment = configurationProvider2.getValue("CONTENTFUL_ENVIRONMENT");
      const accessToken = configurationProvider2.getValue("CONTENTFUL_ACCESS_TOKEN");
      this.httpClient = axios.create({
        baseURL: "https://graphql.contentful.com/content/v1/spaces/".concat(spaceId, "/environments/").concat(environment),
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        }
      });
    }
    return this.httpClient;
  }
  async getProductPageContent(_ref73) {
    let {
      productPageId,
      locale,
      getExperiment
    } = _ref73;
    if (!productPageId || !locale) {
      throw new Error("No product page id or locale provided");
    }
    const storeKey = configurationProvider2.getValue("STORE_KEY");
    try {
      const {
        data
      } = await this.client.post("/", {
        query: getProductContentQuery(storeKey),
        variables: {
          productPageId,
          locale
        }
      });
      const productDetailPage = data.data.productContent;
      if (productDetailPage.sharedSelector) {
        const sharedSelectorUrn = productDetailPage.sharedSelector.sys.urn;
        const splitUrn = sharedSelectorUrn.split("/");
        const sharedSelectorId = splitUrn[splitUrn.length - 1];
        const sharedSelector = await getSharedSelectorContent(sharedSelectorId, locale);
        return sharedSelector;
      }
      const {
        selectorExperiment,
        selectorCollection
      } = data.data.productContent;
      if (selectorExperiment) {
        const {
          experimentId,
          experiment: {
            id: experimentContentId
          }
        } = selectorExperiment;
        const {
          experiment
        } = getExperiment(experimentId);
        if (!experiment.variation) {
          const productSelectorId2 = selectorCollection.items[0].productSelector.id;
          const selector3 = await this.getSelectorContent(productSelectorId2, locale);
          return selector3;
        }
        const selectorId = await this.getExperimentSelector(experimentContentId, locale, experiment.variation);
        if (!selectorId) {
          throw new Error("No selector configured for experiment ".concat(experimentId, " on ").concat(experiment.variation));
        }
        const selector2 = await this.getSelectorContent(selectorId, locale);
        return selector2;
      }
      const productSelectorId = selectorCollection.items[0].productSelector.id;
      const selector = await this.getSelectorContent(productSelectorId, locale);
      return selector;
    } catch (error) {
      Sentry.exception({
        exception: error,
        tags: {
          fileLocation: "contentfulClient",
          featureFunction: "getProductPageContent"
        },
        fingerprint: ["get-product-page-content"]
      });
      throw new Error("Something went wrong while fetching the product content from Contentful", {
        cause: error
      });
    }
  }
  async getSelectorContent(selectorId, locale) {
    if (!selectorId || !locale) {
      throw new Error("No selector id or locale provided");
    }
    try {
      const {
        data
      } = await this.client.post("/", {
        query: productSelectorQuery,
        variables: {
          selectorId,
          locale
        }
      });
      return convertToSelectorContent(data.data.productSelector, data.data.selectorOverridesCollection.items);
    } catch (error) {
      Sentry.exception({
        exception: error,
        tags: {
          fileLocation: "contentfulClient",
          featureFunction: "getSelectorContent"
        },
        fingerprint: ["get-selector-content"]
      });
      throw new Error("Something went wrong while fetching the selector content from Contentful", {
        cause: error
      });
    }
  }
  async getSupportArticleContent(supportArticleId, locale) {
    if (!supportArticleId || !locale) {
      throw new Error("No article id or locale provided");
    }
    try {
      const {
        data
      } = await this.client.post("/", {
        query: supportArticleContentQuery,
        variables: {
          id: supportArticleId,
          locale
        }
      });
      return convertToSupportArticleContent(data.data.supportArticlePage);
    } catch (error) {
      Sentry.exception({
        exception: error,
        tags: {
          fileLocation: "contentfulClient",
          featureFunction: "getSupportArticleContent"
        },
        fingerprint: ["get-support-article-content"]
      });
      throw new Error("Something went wrong while fetching a support article from Contentful", {
        cause: error
      });
    }
  }
  async getSystemPageContent(pageSystemType, locale) {
    if (!pageSystemType || !locale) {
      throw new Error("No system page type or locale provided");
    }
    try {
      const {
        data
      } = await this.client.post("/", {
        query: systemPageContentQuery,
        variables: {
          pageSystemType,
          locale
        }
      });
      return convertToSystemPage(data.data);
    } catch (error) {
      Sentry.exception({
        exception: error,
        tags: {
          fileLocation: "contentfulClient",
          featureFunction: "getSystemPageContent"
        },
        fingerprint: ["get-system-page-content"]
      });
      throw new Error("Something went wrong while fetching a system page from Contentful", {
        cause: error
      });
    }
  }
  /**
   * The size table is read from a product tab of a product page in Contentful.
   * TODO: Make the size table a separate content type in Contentful
   */
  async getSizeTableContent(productPageId, locale) {
    if (!productPageId || !locale) {
      throw new Error("No product page id or locale provided");
    }
    try {
      const {
        data
      } = await this.client.post("/", {
        query: sizeTableContentQuery,
        variables: {
          productPageId,
          locale
        }
      });
      return convertToSizeTableContent(data.data);
    } catch (error) {
      Sentry.exception({
        exception: error,
        tags: {
          fileLocation: "contentfulClient",
          featureFunction: "getSizeTableContent"
        },
        fingerprint: ["get-size-table-content"]
      });
      throw new Error("Something went wrong while fetching a size table from Contentful", {
        cause: error
      });
    }
  }
  /**
   * Retrieves the value of the "useNewSelector" property from Contentful for a given product page ID and locale.
   *
   * @param productPageId - The ID of the product page.
   * @param locale - The locale of the content.
   * @returns A Promise that resolves to a boolean indicating whether to use the new selector or not,
   * defaulting to false if no value is found.
   * @throws An error if no product page ID or locale is provided when fetching the "useNewSelector" value.
   */
  async getUseNewSelector(productPageId, locale) {
    if (!productPageId || !locale) {
      throw new Error("No product page id or locale provided when fetching useNewSelector");
    }
    try {
      var _data$data$productCon, _data$data$productCon2;
      const {
        data
      } = await this.client.post("/", {
        query: useNewSelectorQuery,
        variables: {
          productPageId,
          locale
        }
      });
      return (_data$data$productCon = (_data$data$productCon2 = data.data.productContent) === null || _data$data$productCon2 === void 0 ? void 0 : _data$data$productCon2.useNewSelector) !== null && _data$data$productCon !== void 0 ? _data$data$productCon : false;
    } catch (error) {
      Sentry.exception({
        exception: error,
        tags: {
          fileLocation: "contentfulClient",
          featureFunction: "getUseNewSelector"
        },
        fingerprint: ["get-use-new-selector"]
      });
      throw new Error("Something went wrong while fetching the useNewSelector value from Contentful", {
        cause: error
      });
    }
  }
  /**
   * Retrieves the value of the "selectorExperiment" property from Contentful for a given product page ID and locale.
   *
   * @param productPageId - The ID of the product page.
   * @param locale - The locale of the content.
   * @returns A Promise that resolves to a boolean indicating whether to selectorExperiment or not,
   * defaulting to false if no value is found.
   * @throws An error if no product page ID or locale is provided when fetching the "useSelectorExperiment" value.
   */
  async getExperimentContent(productPageId, locale) {
    if (!productPageId || !locale) {
      throw new Error("No product page id or locale provided when fetching useSelectorExperiment");
    }
    try {
      var _data$data$productCon3, _data$data$productCon4;
      const {
        data
      } = await this.client.post("/", {
        query: ExperimentContentQuery,
        variables: {
          productPageId,
          locale
        }
      });
      return (_data$data$productCon3 = (_data$data$productCon4 = data.data.productContent) === null || _data$data$productCon4 === void 0 ? void 0 : _data$data$productCon4.selectorExperiment) !== null && _data$data$productCon3 !== void 0 ? _data$data$productCon3 : null;
    } catch (error) {
      Sentry.exception({
        exception: error,
        tags: {
          fileLocation: "contentfulClient",
          featureFunction: "getExperimentContent"
        },
        fingerprint: ["get-experiment-content"]
      });
      throw new Error("Something went wrong while fetching the useSelectorExperiment value from Contentful", {
        cause: error
      });
    }
  }
  async getExperimentSelector(experimentContentId, locale, variation) {
    if (!experimentContentId || !locale || !variation) {
      throw new Error("No experiment id or locale or variation provided");
    }
    try {
      const {
        data
      } = await this.client.post("/", {
        query: getExperimentContentQuery(variation),
        variables: {
          experimentContentId,
          locale
        }
      });
      return data.data.experiment[variation].productSelector.id;
    } catch (error) {
      Sentry.exception({
        exception: error,
        tags: {
          fileLocation: "contentfulClient",
          featureFunction: "getExperimentSelector"
        },
        fingerprint: ["get-experiment-selector"]
      });
      throw new Error("Something went wrong while fetching the get experiment selector value from Contentful", {
        cause: error
      });
    }
  }
};
var contentfulClient = new ContentfulClient();

// src/http-clients/productClient.ts
import axios3 from "axios";
import { authenticateHttpRequestInterceptor as authenticateHttpRequestInterceptor2 } from "@printdeal/authentication";
import { configurationProvider as configurationProvider4 } from "@printdeal/configuration";

// src/http-clients/businessRulesAppClient.ts
import { authenticateHttpRequestInterceptor } from "@printdeal/authentication";
import { configurationProvider as configurationProvider3 } from "@printdeal/configuration";
import axios2 from "axios";

// src/helpers/businessRules.ts
var splitByTargetType = data => {
  const deliveryTool = {};
  const artworkService = {};
  Object.keys(data).forEach(key => {
    const value = data[key];
    if (value.targetType === "delivery-tool") {
      var _value$outcomes$find, _value$outcomes$find2;
      const isServiceEnabled = value.outcomes.some(outcome => outcome.outcomeKey === "isServiceEnabled" && outcome.value);
      const deliveryToolMode = (_value$outcomes$find = value.outcomes.find(outcome => outcome.outcomeKey === "deliveryToolMode")) === null || _value$outcomes$find === void 0 ? void 0 : _value$outcomes$find.value;
      const multipleDesigns = (_value$outcomes$find2 = value.outcomes.find(outcome => outcome.outcomeKey === "multipleDesigns")) === null || _value$outcomes$find2 === void 0 ? void 0 : _value$outcomes$find2.value;
      if (isServiceEnabled) {
        deliveryTool[value.targetName] = deliveryToolMode || "enabled";
        if (multipleDesigns) {
          deliveryTool.multipledesigns = multipleDesigns;
        }
      }
    } else if (value.targetType === "artwork-service") {
      const isServiceEnabled = value.outcomes.some(outcome => outcome.outcomeKey === "isServiceEnabled" && outcome.value);
      if (isServiceEnabled) {
        artworkService[key] = key;
      }
    }
  });
  return {
    deliveryTool,
    artworkService
  };
};

// src/http-clients/businessRulesAppClient.ts
var BusinessRulesAppClient = class BusinessRulesAppClient {
  constructor() {
    _defineProperty(this, "businessRulesClient", void 0);
  }
  get client() {
    if (!this.businessRulesClient) {
      const baseURL = configurationProvider3.getValue("BUSINESS_RULES_BASE_URL");
      if (!baseURL) throw new Error("BUSINESS_RULES_BASE_URL is not configured");
      this.businessRulesClient = axios2.create({
        baseURL
      });
      this.businessRulesClient.interceptors.request.use(authenticateHttpRequestInterceptor);
    }
    return this.businessRulesClient;
  }
  /**
   * Evaluate business rules app with the given facts
   * @param {string} productKey - product key to match the rules against
   * @param {Record<string, string>} facts - user selection object,
   * @returns {Promise<BusinessRulesOutcome | null>}
   */
  async evaluateBusinessRules(productKey, facts) {
    try {
      const {
        data: {
          targets
        }
      } = await this.client.get("/v2/rules/product/".concat(productKey, "/evaluate"), {
        params: {
          facts: JSON.stringify(facts)
        }
      });
      return targets;
    } catch (_error) {
      Sentry.exception({
        exception: "Failed to evaluate business rules",
        tags: {
          fileLocation: "businessRulesAppClient",
          featureFunction: "evaluateBusinessRules"
        }
      });
      return null;
    }
  }
};
var businessRulesAppClient = new BusinessRulesAppClient();
async function getBusinessRules(productKey, facts) {
  const defaults = {
    checkmate: "off",
    editor: "off",
    altuploadbeforeorder: "off"
  };
  try {
    var _defaultRules$outcome;
    const businessRules = await businessRulesAppClient.evaluateBusinessRules(productKey, facts);
    const defaultRules = businessRules === null || businessRules === void 0 ? void 0 : businessRules.default;
    const serviceRules = businessRules ? Object.entries(businessRules).filter(_ref74 => {
      let [key] = _ref74;
      return key !== "default";
    }).reduce((acc, _ref75) => {
      let [key, value] = _ref75;
      acc[key] = value;
      return acc;
    }, {}) : {};
    const {
      deliveryTool,
      artworkService
    } = splitByTargetType(serviceRules);
    const serviceKeys = Object.keys(artworkService).join(",").toLowerCase();
    const cutofftime = defaultRules === null || defaultRules === void 0 || (_defaultRules$outcome = defaultRules.outcomes.find(outcome => outcome.outcomeKey === "cutoffTime")) === null || _defaultRules$outcome === void 0 ? void 0 : _defaultRules$outcome.value;
    return _objectSpread({
      deliveryTool: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaults), serviceKeys && {
        servicekeys: serviceKeys
      }), {}, {
        editor: deliveryTool.Editor ? "on" : "off"
      }, deliveryTool.Editor && {
        editormode: deliveryTool.Editor
      }), {}, {
        checkmate: deliveryTool.Uploader ? "on" : "off"
      }, deliveryTool.Uploader && {
        checkmatemode: deliveryTool.Uploader
      }), {}, {
        altuploadbeforeorder: deliveryTool.altUploadBeforeOrder ? "on" : "off"
      }, deliveryTool.directUpload && {
        directupload: true
      }), deliveryTool.multipledesigns && {
        multipledesigns: true
      })
    }, cutofftime && {
      cutofftime
    });
  } catch (error) {
    Sentry.exception({
      exception: error,
      tags: {
        fileLocation: "businessRulesAppClient",
        featureFunction: "getBusinessRules"
      }
    });
    return {
      deliveryTool: defaults
    };
  }
}

// src/http-clients/productClient.ts
var getAttributes = function (selection) {
  let ignoreAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : pricePivotAttributes;
  return Object.entries(selection).reduce((priceAttributes, _ref76) => {
    let [name, value] = _ref76;
    const ignore = ignoreAttributes.includes(name || "");
    if (ignore) {
      return priceAttributes;
    }
    return [...priceAttributes, {
      name,
      value
    }];
  }, []);
};
var getRemainingValue = (key, remainingOption) => {
  if ((remainingOption === null || remainingOption === void 0 ? void 0 : remainingOption.type) !== "string") {
    return false;
  }
  return remainingOption.values.find(_ref77 => {
    let {
      stringLiteral
    } = _ref77;
    return stringLiteral === key;
  });
};
var ProductClient = class ProductClient {
  constructor() {
    _defineProperty(this, "httpClient", void 0);
    _defineProperty(this, "getPrices", async _ref78 => {
      let {
        productKey,
        variableAttributes,
        address,
        quantity,
        mcpSku,
        customerGroupId,
        sort,
        group = [],
        customHeaders
      } = _ref78;
      const params = new URLSearchParams();
      params.append("storeKey", configurationProvider4.getValue("STORE_KEY"));
      params.append("address", JSON.stringify(address));
      params.append("productKey", productKey);
      params.append("variableAttributes", JSON.stringify(variableAttributes));
      params.append("quantityList", JSON.stringify(quantity));
      params.append("mcpSku", mcpSku);
      params.append("sort", JSON.stringify(sort));
      params.append("group", JSON.stringify(group));
      params.append("shouldCombineServicePrice", "true");
      if (customerGroupId) {
        params.append("customerGroupId", customerGroupId);
      }
      const path = sort.find(_ref79 => {
        let {
          pivotAttribute
        } = _ref79;
        return ["Printing Process", "Printing", "PrintingProcess"].includes(pivotAttribute);
      }) ? "getPrices" : "prices";
      const {
        data
      } = await this.client.get("/".concat(path, "?").concat(params), {
        headers: _objectSpread({
          "x-filename": "productClient.ts (@printdeal/product-selector)",
          "x-href": getCurrentUrl()
        }, customHeaders)
      });
      return data || [];
    });
    _defineProperty(this, "getServicesPrice", async _ref80 => {
      let {
        serviceKeys,
        productKey,
        variableAttributes,
        customerGroupId,
        currencyCode = "EUR",
        country,
        postalCode
      } = _ref80;
      const filteredVariableAttributes = variableAttributes.filter(attribute => attribute.value);
      const params = new URLSearchParams();
      params.append("storeKey", configurationProvider4.getValue("STORE_KEY"));
      params.append("serviceKeys", JSON.stringify(serviceKeys));
      params.append("productKey", productKey);
      params.append("variableAttributes", JSON.stringify(filteredVariableAttributes));
      params.append("currencyCode", currencyCode);
      params.append("country", country);
      params.append("postalCode", postalCode);
      if (customerGroupId) {
        params.append("customerGroupId", customerGroupId);
      }
      const {
        data
      } = await this.client.get("/getServicesPrice", {
        params
      });
      return data;
    });
    _defineProperty(this, "getAllPrices", async _ref81 => {
      var _attributes$find, _printingProcess$valu, _printingProcess$valu2;
      let {
        productKey,
        variableAttributes,
        address,
        quantity,
        mcpSku,
        customerGroupId,
        attributes,
        remainingOptions,
        group = [],
        customHeaders = {}
      } = _ref81;
      const conflictingAttribute = (_attributes$find = attributes.find(attribute => !attribute.defaultValue)) === null || _attributes$find === void 0 ? void 0 : _attributes$find.name;
      const {
        sort,
        priceAttributes
      } = getPricePivot(attributes);
      const [printingProcess] = priceAttributes;
      const enabledOptions = (_printingProcess$valu = printingProcess.values) !== null && _printingProcess$valu !== void 0 && _printingProcess$valu.filter(value => value.enabled).length ? printingProcess.values.filter(value => value.enabled) : printingProcess.values;
      const remainingOption = getResolvedAttributeFromGroup(remainingOptions, printingProcess.name);
      const disabledOptions = (_printingProcess$valu2 = printingProcess.values) === null || _printingProcess$valu2 === void 0 ? void 0 : _printingProcess$valu2.filter(value => !value.conditionalAttributeValueRules && !value.enabled);
      const hasOneRemainingOption = (remainingOption === null || remainingOption === void 0 ? void 0 : remainingOption.values.length) === 1;
      const remainingOptionIsDisabled = disabledOptions === null || disabledOptions === void 0 ? void 0 : disabledOptions.some(option => {
        if ((remainingOption === null || remainingOption === void 0 ? void 0 : remainingOption.type) === "string") {
          var _remainingOption$valu;
          return option.id === ((_remainingOption$valu = remainingOption.values[0]) === null || _remainingOption$valu === void 0 ? void 0 : _remainingOption$valu.stringLiteral);
        }
        return false;
      });
      if (hasOneRemainingOption && remainingOptionIsDisabled) {
        return Promise.all([this.getPrices({
          productKey,
          variableAttributes: getAttributes(variableAttributes),
          address,
          quantity,
          group,
          customerGroupId,
          sort,
          mcpSku
        })]);
      }
      const hasOneOptionEnabled = (enabledOptions === null || enabledOptions === void 0 ? void 0 : enabledOptions.length) === 1;
      const promises = enabledOptions === null || enabledOptions === void 0 ? void 0 : enabledOptions.map(async attributeValue => {
        if (hasOneRemainingOption && hasOneOptionEnabled) {
          return this.getPrices({
            productKey,
            variableAttributes: getAttributes(variableAttributes),
            address,
            quantity,
            group,
            customerGroupId,
            sort,
            mcpSku,
            customHeaders: {
              "x-filename": "productClient.ts (@printdeal/product-selector)",
              "x-href": getCurrentUrl()
            }
          });
        }
        const selection = _objectSpread({}, variableAttributes);
        if (conflictingAttribute) {
          const remainingConflictOption = getResolvedAttributeFromGroup(remainingOptions, conflictingAttribute);
          try {
            delete selection[conflictingAttribute];
            const params = new URLSearchParams();
            params.append("variableAttributes", JSON.stringify(_objectSpread(_objectSpread({}, selection), {}, {
              [printingProcess.name]: attributeValue.id
            })));
            const {
              attributes: convertedAttributes
            } = await this.convertProduct(productKey, _objectSpread(_objectSpread({}, selection), {}, {
              [printingProcess.name]: attributeValue.id
            }), customHeaders);
            selection[conflictingAttribute] = getRemainingValue(variableAttributes[conflictingAttribute], remainingConflictOption) && getRemainingValue(convertedAttributes[conflictingAttribute], remainingConflictOption) ? variableAttributes[conflictingAttribute] : convertedAttributes[conflictingAttribute];
          } catch (_error) {
            selection[conflictingAttribute] = variableAttributes[conflictingAttribute];
          }
        }
        return this.getPrices({
          productKey,
          variableAttributes: getAttributes(selection),
          address,
          quantity,
          group,
          customerGroupId,
          sort,
          mcpSku,
          customHeaders: {
            "x-filename": "productClient.ts (@printdeal/product-selector)",
            "x-href": getCurrentUrl()
          }
        });
      });
      return Promise.all(promises || []);
    });
    _defineProperty(this, "getExpectedDeliveryDate", async _ref82 => {
      let {
        productKey,
        variableAttributes,
        shippingAddress,
        quantity,
        group = [],
        cutoffTime,
        hasServicePrice
      } = _ref82;
      const now = /* @__PURE__ */new Date();
      const formatter = new Intl.DateTimeFormat("nl-NL", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
      const currentTime = formatter.format(now);
      const params = new URLSearchParams();
      params.append("storeKey", configurationProvider4.getValue("STORE_KEY"));
      params.append("address", JSON.stringify(shippingAddress));
      params.append("productKey", productKey);
      params.append("quantity", String(quantity));
      params.append("variableAttributes", JSON.stringify(variableAttributes));
      if (cutoffTime) {
        params.append("cutoffTimeExpired", "".concat(currentTime > cutoffTime));
      }
      if (group.length > 0) {
        params.append("group", JSON.stringify(group));
      }
      if (hasServicePrice) {
        params.append("hasServicePrice", String(hasServicePrice));
      }
      const {
        data: date
      } = await this.client.get("/expectedDeliveryDate?".concat(params));
      return date;
    });
    /**
     * Get the arrival dates based on the selection and given attribute
     */
    _defineProperty(this, "getArrivalDates", async _ref83 => {
      let {
        quantity,
        productKey,
        selection,
        shippingAddress,
        groupSelection,
        configurationAttribute,
        remainingOptionsPerGroup,
        cutoffTime
      } = _ref83;
      const resolvedAttribute = getResolvedAttributeFromGroup(remainingOptionsPerGroup, configurationAttribute.name);
      const serviceKey = getResolvedAttributeFromGroup(remainingOptionsPerGroup, "Service Key");
      if ((resolvedAttribute === null || resolvedAttribute === void 0 ? void 0 : resolvedAttribute.type) !== "string") {
        return [];
      }
      const dateRequests = resolvedAttribute.values.map(async attributeValue => {
        try {
          const variableAttributes = Object.entries(selection).map(_ref84 => {
            let [name, value] = _ref84;
            if (name === configurationAttribute.name) {
              return {
                name,
                value: attributeValue.stringLiteral
              };
            }
            return {
              name,
              value
            };
          });
          const date = await this.getExpectedDeliveryDate({
            productKey,
            variableAttributes,
            shippingAddress,
            quantity,
            group: getPriceGroups(groupSelection),
            cutoffTime,
            hasServicePrice: Boolean((serviceKey === null || serviceKey === void 0 ? void 0 : serviceKey.values[0].type) === "stringLiteral" && serviceKey.values[0].stringLiteral)
          });
          return {
            deliveryType: attributeValue.stringLiteral,
            date
          };
        } catch (_error) {
          return {
            deliveryType: attributeValue.stringLiteral,
            date: void 0
          };
        }
      });
      const dates = await Promise.all(dateRequests);
      return dates;
    });
    _defineProperty(this, "getInventory", async _ref85 => {
      let {
        productKey,
        selection,
        shippingAddress,
        quantity,
        group = []
      } = _ref85;
      const variableAttributes = Object.entries(selection).map(_ref86 => {
        let [name, value] = _ref86;
        return {
          name,
          value
        };
      });
      const params = new URLSearchParams();
      params.append("address", JSON.stringify(shippingAddress));
      params.append("productKey", productKey);
      params.append("quantity", String(quantity));
      params.append("variableAttributes", JSON.stringify(variableAttributes));
      if (group.length > 0) {
        params.append("group", JSON.stringify(group));
      }
      const {
        data
      } = await this.client.get("/inventory?".concat(params));
      return data;
    });
    /**
     * Get a list of the first available delivery dates for a product-selection per printing process and delivery type
     */
    _defineProperty(this, "getExpectedDeliveryDates", async _ref87 => {
      let {
        prices,
        productKey,
        singleAttributes,
        shippingAddress,
        group,
        remainingOptionsPerPrintingProcess
      } = _ref87;
      const firstQuantities = prices.flatMap(_ref88 => {
        let {
          quantities,
          name
        } = _ref88;
        const [firstQuantity] = quantities;
        return firstQuantity.deliveryTypes.map(deliveryType => ({
          deliveryType: deliveryType.name,
          printingProcess: name,
          quantity: firstQuantity.quantity
        }));
      });
      const promises = firstQuantities.map(async priceAttributes => {
        const {
          printingProcess,
          deliveryType,
          quantity
        } = priceAttributes;
        const remainingOptions = printingProcess && remainingOptionsPerPrintingProcess[printingProcess] || [];
        const serviceKey = getResolvedAttributeFromGroup(remainingOptions, "Service Key");
        const extraAttributes = printingProcess ? [{
          name: "Printing Process",
          value: printingProcess
        }, {
          name: "Delivery Type",
          value: deliveryType
        }] : [{
          name: "Delivery Type",
          value: deliveryType
        }];
        const variableAttributes = singleAttributes.concat(extraAttributes);
        const {
          cutofftime
        } = await getBusinessRules(productKey, Object.fromEntries(variableAttributes.map(_ref89 => {
          let {
            name,
            value
          } = _ref89;
          return [name, value];
        })));
        const date = await this.getExpectedDeliveryDate({
          productKey,
          variableAttributes,
          shippingAddress,
          quantity,
          group,
          cutoffTime: cutofftime,
          hasServicePrice: Boolean((serviceKey === null || serviceKey === void 0 ? void 0 : serviceKey.values[0].type) === "stringLiteral" && serviceKey.values[0].stringLiteral)
        });
        return _objectSpread(_objectSpread({}, priceAttributes), {}, {
          date
        });
      });
      const dates = await Promise.all(promises);
      return dates;
    });
    _defineProperty(this, "convertProduct", async (productKey, variableAttributes, customHeaders) => {
      const params = new URLSearchParams();
      params.append("variableAttributes", JSON.stringify(variableAttributes));
      const {
        data: mcpProduct
      } = await this.client.get("/product/convert/".concat(productKey), {
        params,
        headers: customHeaders || {}
      });
      return Promise.resolve(mcpProduct);
    });
    _defineProperty(this, "fetchPricing", async _ref90 => {
      let {
        productKey,
        selection,
        quantityList,
        version,
        country,
        postalCode,
        customerGroupId,
        group = []
      } = _ref90;
      const params = new URLSearchParams(_objectSpread(_objectSpread({
        productKey,
        selection: JSON.stringify(selection),
        quantityList: JSON.stringify(quantityList),
        version: String(version),
        country,
        postalCode
      }, group.length && {
        group: JSON.stringify(group)
      }), customerGroupId && {
        customerGroupId
      }));
      const {
        data
      } = await this.client.get("/pricing", {
        headers: {
          "x-filename": "productClient.ts (@printdeal/product-selector)",
          "x-href": getCurrentUrl()
        },
        params
      });
      return Promise.resolve(data);
    });
    _defineProperty(this, "fetchPivotPrices", async _ref91 => {
      let {
        productKey,
        selection,
        quantity,
        version,
        deliveryOptionId,
        attributes,
        group = [],
        country,
        postalCode,
        customerGroupId
      } = _ref91;
      const pivotSelections = attributes.reduce((acc, attribute) => {
        var _attribute$values6;
        const attributeName = attribute.name;
        const selectedValue = selection[attributeName];
        const filteredValues = (_attribute$values6 = attribute.values) === null || _attribute$values6 === void 0 ? void 0 : _attribute$values6.map(value => value.name).filter(value => value !== selectedValue).join(",");
        if (filteredValues) {
          acc[attributeName] = filteredValues;
        }
        return acc;
      }, {});
      const params = new URLSearchParams(_objectSpread(_objectSpread(_objectSpread({
        productKey,
        selection: JSON.stringify(selection),
        pivotSelections: JSON.stringify(pivotSelections),
        quantity: String(quantity),
        version: String(version),
        country,
        postalCode
      }, deliveryOptionId && {
        deliveryOptionId
      }), group.length && {
        group: JSON.stringify(group)
      }), customerGroupId && {
        customerGroupId
      }));
      const {
        data
      } = await this.client.get("/pivotPrices", {
        headers: {
          "x-filename": "productClient.ts (@printdeal/product-selector)",
          "x-href": getCurrentUrl()
        },
        params
      });
      return Promise.resolve(data);
    });
    _defineProperty(this, "fetchDeliveryDates", async _ref92 => {
      let {
        selection,
        quantity,
        country,
        version,
        productKey,
        postalCode,
        sort,
        groupSelection = []
      } = _ref92;
      const params = new URLSearchParams(_objectSpread(_objectSpread({
        selection: JSON.stringify(selection),
        quantity: quantity.toString(),
        country,
        version: version.toString(),
        productKey,
        postalCode
      }, sort && {
        sort
      }), {}, {
        groupSelection: JSON.stringify(getPriceGroups(groupSelection))
      }));
      const {
        data
      } = await this.client.get("/eCommerceDeliveryOptions", {
        headers: {
          "x-filename": "productClient.ts (@printdeal/product-selector)",
          "x-href": getCurrentUrl()
        },
        params
      });
      return Promise.resolve(data);
    });
  }
  get client() {
    if (!this.httpClient) {
      const baseURL = configurationProvider4.getValue("PRODUCT_API_BASE_URL");
      this.httpClient = axios3.create({
        baseURL
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor2);
    }
    return this.httpClient;
  }
};
var productClient = new ProductClient();

// src/http-clients/validationClient.ts
import axios4 from "axios";
import { configurationProvider as configurationProvider5 } from "@printdeal/configuration";
import { dequal as dequal2 } from "dequal";
import { authenticationHttpClient } from "@printdeal/authentication";
import { jwtDecode } from "jwt-decode";
var STORAGE_KEY = "anonCoamIdentity";
var anonymousCoamIdentity;
var isDecodedTokenExpired = decodedToken => {
  if (!decodedToken.exp) {
    return true;
  }
  return Boolean(decodedToken.exp <= Math.floor(( /* @__PURE__ */new Date()).getTime() / 1e3));
};
var createAnonymousCOAMIdentity = async identity => {
  const {
    data: {
      token: printdealAuthToken
    }
  } = await authenticationHttpClient.createToken();
  const {
    data
  } = await axios4.post("".concat(configurationProvider5.getValue("AUTH_LAYER_API_BASE_URL"), "/anon-coam-identity"), identity, {
    headers: {
      Authorization: printdealAuthToken
    }
  });
  return data;
};
var loadAnonymousCoamIdentity = () => {
  if (anonymousCoamIdentity) {
    return anonymousCoamIdentity;
  }
  const identityFromStorage = getFromLocalStorage(STORAGE_KEY);
  if (identityFromStorage) {
    return JSON.parse(identityFromStorage);
  }
  return void 0;
};
var getAnonymousCOAMToken = async () => {
  const storedIdentity = loadAnonymousCoamIdentity();
  if (storedIdentity !== null && storedIdentity !== void 0 && storedIdentity.anonymousToken) {
    const decodedToken = jwtDecode(storedIdentity.anonymousToken);
    if (!isDecodedTokenExpired(decodedToken)) {
      return storedIdentity.anonymousToken;
    }
  }
  anonymousCoamIdentity = await createAnonymousCOAMIdentity(storedIdentity);
  saveToLocalStorage(STORAGE_KEY, JSON.stringify(anonymousCoamIdentity));
  return anonymousCoamIdentity.anonymousToken;
};
async function authenticateHttpRequestInterceptor3(config) {
  const token = await getAnonymousCOAMToken();
  const updatedConfig = config;
  if (!updatedConfig.headers) {
    updatedConfig.headers = {};
  }
  updatedConfig.headers.Authorization = token;
  return updatedConfig;
}
var ValidationClient = class ValidationClient {
  constructor() {
    var _this = this;
    _defineProperty(this, "httpClient", void 0);
    _defineProperty(this, "validate", async function (productKey, selections, invalidSelections, customHeaders) {
      let isPimProduct = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      let productVersion = arguments.length > 5 ? arguments[5] : undefined;
      let country = arguments.length > 6 ? arguments[6] : undefined;
      const environment = configurationProvider5.getValue("PRODUCT_VALIDATION_ENV");
      const isPimVersionedProduct = Boolean(isPimProduct && productVersion);
      const validationUrl = isPimVersionedProduct ? "/v2/products/".concat(productKey, "/versions/").concat(productVersion, ":validate") : "/v1/products/Printdeal_".concat(environment, "_").concat(productKey, ":validate");
      const data = await _this.client.post(validationUrl, _objectSpread({
        selections,
        invalidSelections,
        includeBuckets: ["option", "property"]
      }, isPimVersionedProduct && {
        context: {
          Country: country || "NL",
          Merchant: "Printdeal"
        },
        includeConstraintTypes: ["TEMPORARILY_UNAVAILABLE"]
      }), {
        headers: customHeaders || {}
      });
      if (data.data.state === "unresolvable" && isPimVersionedProduct) {
        const validationData = {
          result: data.data
        };
        logError(validationData, selections, "validate", {
          productKey,
          productVersion,
          country
        }, "Selection is Unresolvable", "validationClient.ts", "selector-v2-api-unresolvable");
      }
      return data;
    });
    _defineProperty(this, "validateSelection", async function (productKey, selections, groupAttributes, invalidSelections, customHeaders, group) {
      let isPimProduct = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      let productVersion = arguments.length > 7 ? arguments[7] : undefined;
      let country = arguments.length > 8 ? arguments[8] : undefined;
      let quantity = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 1;
      const selection = _objectSpread({}, selections);
      Object.keys(invalidSelections).map(attributeName => delete selection[attributeName]);
      if (groupAttributes.length) {
        return Promise.all(groupAttributes.map(async groupAttribute => {
          const selectedGroup = group === null || group === void 0 ? void 0 : group.find(_ref93 => {
            let {
              attributes
            } = _ref93;
            return dequal2(attributes, groupAttribute);
          });
          const {
            data: data2
          } = await _this.validate(productKey, _objectSpread(_objectSpread(_objectSpread({}, selection), groupAttribute), {}, {
            Quantity: selectedGroup ? String(selectedGroup.quantity) : String(quantity)
          }), invalidSelections, customHeaders, isPimProduct, productVersion, country);
          return {
            groupAttribute,
            result: data2
          };
        }));
      }
      const updatedSelection = _objectSpread(_objectSpread({}, selections), isPimProduct && quantity && {
        Quantity: String(quantity)
      });
      const {
        data
      } = await _this.validate(productKey, updatedSelection, invalidSelections, customHeaders, isPimProduct, productVersion, country);
      return [{
        result: data
      }];
    });
    _defineProperty(this, "getRemainingOptionsPerPrintingProcess", async (productKey, attributes, prices) => {
      const printingProcesses = prices.map(_ref94 => {
        let {
          name
        } = _ref94;
        return {
          printingProcess: name
        };
      });
      const results = await Promise.all(printingProcesses.map(async _ref95 => {
        let {
          printingProcess
        } = _ref95;
        const selection = attributes.reduce((selectorSelection, attribute) => _objectSpread(_objectSpread({}, selectorSelection), {}, {
          [attribute.name]: attribute.value
        }, printingProcess && {
          "Printing Process": printingProcess
        }), {});
        const {
          data: validationResult
        } = await this.validate(productKey, selection, {});
        const remainingOptions = [{
          state: validationResult.state,
          options: validationResult.remainingOptions
        }];
        if (printingProcess) {
          return {
            [printingProcess]: remainingOptions
          };
        }
        return {};
      }));
      return results.reduce((acc, result) => _objectSpread(_objectSpread({}, acc), result), {});
    });
  }
  get client() {
    if (!this.httpClient) {
      const baseURL = configurationProvider5.getValue("PRODUCT_VALIDATION_BASE_URL");
      this.httpClient = axios4.create({
        baseURL
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor3);
    }
    return this.httpClient;
  }
};
var validationClient = new ValidationClient();

// src/helpers/groupAttributes.ts
import { configurationProvider as configurationProvider6 } from "@printdeal/configuration";
var getGroupAttributes = attributes => {
  const gridAttributes = attributes.find(attribute => Boolean(attribute.grid));
  if (!gridAttributes) {
    return [];
  }
  const {
    grid
  } = gridAttributes;
  const row = grid === null || grid === void 0 ? void 0 : grid.row;
  const column = grid === null || grid === void 0 ? void 0 : grid.column;
  const rowValues = (row === null || row === void 0 ? void 0 : row.values) || [];
  const columnValues = (column === null || column === void 0 ? void 0 : column.values) || [];
  if (!row || !column) {
    return [];
  }
  if (rowValues.length === 0 || columnValues.length === 0) {
    return [];
  }
  return rowValues.flatMap(rowValue => columnValues.map(columnValue => ({
    [row.name]: rowValue.name,
    [column.name]: columnValue.name
  })));
};
var getDefaultGroup = function (attributes, quantity, isUnprinted, remainingOptionsPerGroup) {
  var _row$values, _defaultGroup$filter;
  let fullGroup = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  let target = arguments.length > 5 ? arguments[5] : undefined;
  const gridAttributes = attributes.find(attribute => Boolean(attribute.grid));
  if (!gridAttributes) {
    return [];
  }
  const {
    grid
  } = gridAttributes;
  const row = grid === null || grid === void 0 ? void 0 : grid.row;
  const column = grid === null || grid === void 0 ? void 0 : grid.column;
  const maximum = isUnprinted ? 1 : getRangeMaximum(remainingOptionsPerGroup, "groupedQuantity");
  let printIndex = 0;
  const isImpressto = configurationProvider6.getValue("STORE_KEY") === "impressto-fr";
  const defaultGroup = row === null || row === void 0 || (_row$values = row.values) === null || _row$values === void 0 ? void 0 : _row$values.flatMap((rowValue, index) => {
    var _column$values;
    const needToAddDefaultLine = isUnprinted ? index < quantity : true;
    return needToAddDefaultLine ? column === null || column === void 0 || (_column$values = column.values) === null || _column$values === void 0 ? void 0 : _column$values.map(columnValue => {
      const valid = isGridCellValid({
        name: row.name,
        value: rowValue.name
      }, {
        name: column.name,
        value: columnValue.name
      }, remainingOptionsPerGroup);
      if (!valid) {
        return false;
      }
      if (fullGroup) {
        return {
          attributes: {
            [row.name]: rowValue.name,
            [column.name]: columnValue.name
          },
          quantity: isUnprinted ? 1 : quantity
        };
      }
      const remainingQuantity = quantity - (printIndex + 1) * maximum;
      const currentQuantity = remainingQuantity > 0 ? maximum : quantity - printIndex * maximum;
      printIndex += 1;
      return currentQuantity > 0 && {
        attributes: {
          [row.name]: rowValue.name,
          [column.name]: columnValue.name
        },
        quantity: isUnprinted ? 1 : currentQuantity
      };
    }) : [];
  }).filter(currentValue => currentValue !== false);
  const targetGroup = (_defaultGroup$filter = defaultGroup === null || defaultGroup === void 0 ? void 0 : defaultGroup.filter(group => {
    if (!group) return false;
    if (isImpressto && target && row !== null && row !== void 0 && row.name) {
      const groupAttribute = group.attributes[row.name];
      return groupAttribute === target;
    }
    return false;
  })) !== null && _defaultGroup$filter !== void 0 ? _defaultGroup$filter : [];
  const targetGroupSelection = targetGroup.length === 0 ? [defaultGroup === null || defaultGroup === void 0 ? void 0 : defaultGroup[0]] : [targetGroup[0]];
  return targetGroup.length === 0 && !target ? defaultGroup : targetGroupSelection;
};

// src/statemachines/actors/selectorActors.ts
var validateSelection = fromPromise(async _ref96 => {
  let {
    input
  } = _ref96;
  return validationClient.validateSelection(input.productKey, input.selection, input.groupAttributes, input.invalidSelection, {
    "x-filename": "selectorActors.ts"
  }, input.group, input.isPimProduct, input.productVersion, input.country, input.quantity);
});
var getServicePrices = fromPromise(async _ref97 => {
  let {
    input
  } = _ref97;
  return productClient.getServicesPrice({
    variableAttributes: Object.entries(input.selection).map(_ref98 => {
      let [name, value] = _ref98;
      return {
        name,
        value
      };
    }),
    customerGroupId: input.customerGroupId,
    serviceKeys: input.serviceKeys,
    productKey: input.productKey,
    country: input.countryCode,
    postalCode: input.postalCode
  });
});
var fetchPricing = fromPromise(async _ref99 => {
  var _input$group;
  let {
    input
  } = _ref99;
  const customProductQuantities = input.quantityList;
  const quantitySet = new Set(customProductQuantities);
  if (input.customQuantity) {
    quantitySet.add(input.customQuantity);
  }
  if (input.totalQuantity && input.totalQuantity !== input.customQuantity) {
    quantitySet.add(input.totalQuantity);
  }
  const allQuantities = Array.from(quantitySet);
  const defaultGroup = getDefaultGroup(input.attributes, input.totalQuantity, !input.artworkRequired, input.remainingOptionsPerGroup);
  return productClient.fetchPricing(_objectSpread(_objectSpread({
    selection: input.selection,
    productKey: input.productKey,
    quantityList: allQuantities,
    version: input.version,
    country: input.country,
    postalCode: input.postalCode
  }, (_input$group = input.group) !== null && _input$group !== void 0 && _input$group.length ? {
    group: input.group
  } : {
    group: defaultGroup
  }), {}, {
    customerGroupId: input.customerGroupId
  }));
});
var fetchPivotPrices = fromPromise(async _ref100 => {
  var _input$group2;
  let {
    input
  } = _ref100;
  const defaultGroup = getDefaultGroup(input.attributes, input.totalQuantity, !input.artworkRequired, input.remainingOptionsPerGroup);
  return productClient.fetchPivotPrices(_objectSpread(_objectSpread({
    selection: input.selection,
    attributes: input.attributes,
    productKey: input.productKey,
    quantity: input.quantity,
    version: input.version
  }, (_input$group2 = input.group) !== null && _input$group2 !== void 0 && _input$group2.length ? {
    group: input.group
  } : {
    group: defaultGroup
  }), {}, {
    country: input.country,
    postalCode: input.postalCode,
    deliveryOptionId: input.deliveryOptionId,
    customerGroupId: input.customerGroupId
  }));
});
var fetchDeliveryDates = fromPromise(async _ref101 => {
  let {
    input
  } = _ref101;
  return productClient.fetchDeliveryDates({
    selection: input.selection,
    quantity: input.quantity,
    country: input.country,
    version: input.version,
    productKey: input.productKey,
    postalCode: input.postalCode,
    groupSelection: input.groupSelection,
    sort: input.sort
  });
});
var getPrices = fromPromise(async _ref102 => {
  let {
    input
  } = _ref102;
  if (!input.shippingAddress) return Promise.reject(new Error("No shipping address found"));
  const priceGroups = getPriceGroups(input.group);
  const defaultGroup = getDefaultGroup(input.attributes, input.totalQuantity, !input.artworkRequired, input.remainingOptionsPerGroup);
  const groupQuantity = hasGroupedQuantity(input.attributes) && input.totalQuantity ? [input.totalQuantity] : [];
  const quantity = priceGroups.length > 0 || input.totalQuantity === 0 ? [] : groupQuantity;
  return productClient.getAllPrices(_objectSpread(_objectSpread({
    // selection and alternative prices
    variableAttributes: input.selection,
    customerGroupId: input.customerGroupId,
    quantity,
    productKey: input.productKey,
    mcpSku: input.mcpSku,
    address: input.shippingAddress,
    attributes: input.attributes,
    remainingOptions: input.remainingOptionsPerGroup
  }, priceGroups.length ? {
    group: priceGroups
  } : {
    group: getPriceGroups(defaultGroup)
  }), {}, {
    customHeaders: {
      "x-filename": "selectorActors.ts",
      "x-href": window.location.href
    }
  }));
});
var getArrivalDates = fromPromise(async _ref103 => {
  let {
    input
  } = _ref103;
  const deliveryType = input.attributes.find(attribute => attribute.name === "Delivery Type");
  const quantity = getResolvedAttributeFromGroup(input.remainingOptionsPerGroup, "Quantity");
  const value = quantity === null || quantity === void 0 ? void 0 : quantity.values[0];
  const isRange = (value === null || value === void 0 ? void 0 : value.type) === "range";
  const isStringLiteral = (value === null || value === void 0 ? void 0 : value.type) === "stringLiteral";
  const isNumberLiteral = (value === null || value === void 0 ? void 0 : value.type) === "numberLiteral";
  const totalQuantity = !input.totalQuantity && isRange && value.range.minimum || !input.totalQuantity && isStringLiteral && parseInt(value.stringLiteral, 10) || !input.totalQuantity && isNumberLiteral && parseInt(value.numberLiteral, 10) || input.totalQuantity;
  if (!input.shippingAddress || !deliveryType || !totalQuantity) {
    return Promise.reject(new Error("No shipping address, quantity or delivery type found"));
  }
  const isUnprinted = !input.artworkRequired;
  const defaultGroup = getDefaultGroup(input.attributes, input.totalQuantity, isUnprinted, input.remainingOptionsPerGroup);
  return productClient.getArrivalDates({
    quantity: totalQuantity,
    productKey: input.productKey,
    selection: input.selection,
    groupSelection: input.group.length > 0 ? input.group : defaultGroup,
    shippingAddress: input.shippingAddress,
    configurationAttribute: deliveryType,
    remainingOptionsPerGroup: input.remainingOptionsPerGroup,
    cutoffTime: input.merchantRules.cutofftime
  });
});
var getInventory = fromPromise(async _ref104 => {
  let {
    input
  } = _ref104;
  if (!input.shippingAddress || !input.totalQuantity) {
    return Promise.reject(new Error("No shipping address or quantity found"));
  }
  const defaultGroup = getDefaultGroup(input.attributes, getRangeMaximum(input.remainingOptionsPerGroup, "groupedQuantity"), !input.artworkRequired, input.remainingOptionsPerGroup, true);
  return productClient.getInventory({
    quantity: input.totalQuantity,
    productKey: input.productKey,
    selection: input.selection,
    group: getPriceGroups(defaultGroup),
    shippingAddress: input.shippingAddress
  });
});
var getBusinessRules2 = fromPromise(async _ref105 => {
  let {
    input
  } = _ref105;
  return getBusinessRules(input.productKey, input.selection);
});
var convertProduct = fromPromise(async _ref106 => {
  let {
    input
  } = _ref106;
  return productClient.convertProduct(input.productKey, input.selection);
});

// src/statemachines/selector/selector.machine.ts
var initialContext = {
  attributes: [],
  selection: {},
  attributesCount: 0,
  productKey: "",
  serviceKeys: [],
  selectedService: void 0,
  mcpSku: "",
  prices: [],
  pivotPrices: {},
  servicePrices: void 0,
  alternativePrices: [],
  pricesPerQuantity: [],
  group: [],
  groupAttributes: [],
  customerGroupId: "",
  invalidSelection: {},
  remainingOptionsPerGroup: [],
  priceAttributes: {},
  totalQuantity: 0,
  arrivalDates: [],
  selectedDeliveryOption: {
    name: "Normal"
  },
  panel: {
    openPanel: false,
    showMessage: false,
    panelName: ""
  },
  touchedAttributes: [],
  device: "mobile",
  merchantRules: {
    deliveryTool: {}
  },
  productAttributes: [],
  artworkRequired: true,
  isReviewPage: false,
  selectionMode: "default-values",
  inventory: [],
  product: void 0,
  deliveryDates: [],
  productRouteClicked: false
};
var selectorMachine = setup({
  types: {
    context: {},
    events: {}
  },
  actors: {
    validateSelection,
    getServicePrices,
    getBusinessRules: getBusinessRules2,
    getPrices,
    getArrivalDates,
    getInventory,
    convertProduct
  },
  actions: {},
  guards: {
    shouldValidate: _ref107 => {
      let {
        event
      } = _ref107;
      assertEvent(event, "Select attribute value");
      return event.shouldValidate;
    },
    shouldNotValidate: _ref108 => {
      let {
        event
      } = _ref108;
      assertEvent(event, "Select attribute value");
      return !event.shouldValidate;
    },
    isSelectionInvalid: _ref109 => {
      let {
        context,
        event
      } = _ref109;
      assertEvent(event, "Select attribute value");
      return isSelectionInvalid({
        context,
        event
      });
    },
    isConfigurationInvalid,
    isUnresolvable,
    canPreselectAttribute,
    canUnset,
    cannotUnset,
    areAllRequiredAttributesSelected,
    shouldFetchServicePrices,
    insufficientInventory,
    hasInsufficientInventoryWithoutGroup,
    isStepByStep
  }
}).createMachine({
  context: initialContext,
  id: "SelectorMachine",
  initial: "WAITING TO START",
  states: {
    "WAITING TO START": {
      on: {
        "Start machine": {
          actions: [assign(_ref110 => {
            let {
              event
            } = _ref110;
            return initializeContext({
              event
            });
          })],
          target: "STARTING"
        }
      }
    },
    STARTING: {
      always: {
        target: "STARTED"
      }
    },
    STARTED: {
      initial: "VALIDATING",
      states: {
        VALIDATING: {
          invoke: {
            src: "validateSelection",
            input: _ref111 => {
              var _context$product2, _context$product3;
              let {
                context
              } = _ref111;
              return {
                productKey: context.productKey,
                selection: context.selection,
                group: context.group,
                invalidSelection: context.invalidSelection,
                groupAttributes: context.groupAttributes,
                isPimProduct: Boolean((_context$product2 = context.product) === null || _context$product2 === void 0 ? void 0 : _context$product2.isPimProduct),
                productVersion: (_context$product3 = context.product) === null || _context$product3 === void 0 ? void 0 : _context$product3.productVersion
              };
            },
            onDone: [{
              actions: [_ref112 => {
                let {
                  context,
                  event
                } = _ref112;
                return logError(event.output, context.selection, "getAttributeConfiguration");
              }, assign(() => ({
                error: "ConfigurationError"
              }))],
              guard: "isConfigurationInvalid",
              target: "ERRORING"
            }, {
              guard: {
                type: "isUnresolvable",
                params: _ref113 => {
                  let {
                    event
                  } = _ref113;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              actions: [_ref114 => {
                let {
                  context,
                  event
                } = _ref114;
                return logViolationError({
                  context,
                  event
                });
              }, assign(() => ({
                error: "UnresolvedValidationError"
              }))],
              target: "ERRORING"
            }, {
              guard: {
                type: "canPreselectAttribute",
                params: _ref115 => {
                  let {
                    event
                  } = _ref115;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              actions: [assign(_ref116 => {
                let {
                  context,
                  event
                } = _ref116;
                return preselectAttribute({
                  context,
                  event
                });
              })],
              target: "VALIDATING",
              reenter: true
            }, {
              actions: [assign(_ref117 => {
                let {
                  context,
                  event
                } = _ref117;
                return unsetAttribute({
                  context,
                  event
                });
              })],
              guard: {
                type: "canUnset",
                params: _ref118 => {
                  let {
                    event
                  } = _ref118;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              target: "VALIDATING",
              reenter: true
            }, {
              actions: [_ref119 => {
                let {
                  context,
                  event
                } = _ref119;
                return logViolationError({
                  context,
                  event
                });
              }, assign(() => ({
                error: "UnresolvedValidationError"
              }))],
              guard: {
                type: "cannotUnset",
                params: _ref120 => {
                  let {
                    event
                  } = _ref120;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              target: "ERRORING"
            }, {
              guard: "isStepByStep",
              actions: [assign(_ref121 => {
                let {
                  context,
                  event
                } = _ref121;
                return storeRemainingOptions({
                  context,
                  event
                });
              })],
              target: "STEP BY STEP IDLE"
            }, {
              actions: [assign(_ref122 => {
                let {
                  context,
                  event
                } = _ref122;
                return storeRemainingOptions({
                  context,
                  event
                });
              })],
              target: "FETCHING MERCHANT RULES"
            }],
            onError: [{
              actions: [_ref123 => {
                let {
                  context,
                  event
                } = _ref123;
                return logError(event, context.selection, "validateSelection");
              }, assign(() => ({
                error: "UnknownValidationError"
              }))],
              target: "ERRORING"
            }]
          }
        },
        "WAIT FOR USER CONFIRMATION": {
          on: {
            "Select attribute value": [{
              guard: "shouldValidate",
              actions: [assign(_ref124 => {
                let {
                  context,
                  event
                } = _ref124;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }, {
              guard: "shouldNotValidate",
              actions: [assign(_ref125 => {
                let {
                  context,
                  event
                } = _ref125;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "FETCHING MERCHANT RULES"
            }],
            "Cancel unset": [{
              guard: "isStepByStep",
              target: "STEP BY STEP IDLE"
            }, {
              target: "VALIDATING"
            }]
          }
        },
        "STEP BY STEP IDLE": {
          always: {
            guard: "areAllRequiredAttributesSelected",
            target: "FETCHING MERCHANT RULES"
          },
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign(_ref126 => {
                let {
                  event
                } = _ref126;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign(_ref127 => {
                let {
                  context,
                  event
                } = _ref127;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }]
          }
        },
        "SELECTION COMPLETE": {
          always: {
            guard: "shouldFetchServicePrices",
            target: "FETCHING SERVICE PRICES"
          },
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign(_ref128 => {
                let {
                  event
                } = _ref128;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign(_ref129 => {
                let {
                  context,
                  event
                } = _ref129;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }, {
              guard: "shouldNotValidate",
              actions: [assign(_ref130 => {
                let {
                  context,
                  event
                } = _ref130;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "FETCHING MERCHANT RULES"
            }]
          }
        },
        "FETCHING SERVICE PRICES": {
          exit: assign(() => ({
            serviceError: void 0
          })),
          invoke: {
            src: "getServicePrices",
            input: _ref131 => {
              var _context$shippingAddr, _context$shippingAddr2;
              let {
                context
              } = _ref131;
              return {
                productKey: context.productKey,
                selection: context.selection,
                customerGroupId: context.customerGroupId || "",
                serviceKeys: context.serviceKeys,
                countryCode: ((_context$shippingAddr = context.shippingAddress) === null || _context$shippingAddr === void 0 ? void 0 : _context$shippingAddr.CountryCode) || "",
                postalCode: ((_context$shippingAddr2 = context.shippingAddress) === null || _context$shippingAddr2 === void 0 ? void 0 : _context$shippingAddr2.PostalCode) || ""
              };
            },
            onDone: [{
              actions: [assign(_ref132 => {
                let {
                  event
                } = _ref132;
                return {
                  servicePrices: event.output
                };
              })],
              target: "SELECTION COMPLETE"
            }],
            onError: [{
              actions: [_ref133 => {
                let {
                  context,
                  event
                } = _ref133;
                return logError(event, context.selection, "getServicePrices", {
                  serviceKeys: context.serviceKeys
                });
              }, assign(() => ({
                servicePrices: void 0
              })), assign(() => ({
                serviceError: "ServicePricingError"
              }))],
              target: "SELECTION COMPLETE"
            }]
          },
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign(_ref134 => {
                let {
                  event
                } = _ref134;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign(_ref135 => {
                let {
                  context,
                  event
                } = _ref135;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }]
          }
        },
        ERRORING: {
          exit: assign(() => ({
            error: void 0
          })),
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign(_ref136 => {
                let {
                  event
                } = _ref136;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign(_ref137 => {
                let {
                  context,
                  event
                } = _ref137;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }, {
              guard: "shouldNotValidate",
              actions: [assign(_ref138 => {
                let {
                  context,
                  event
                } = _ref138;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "FETCHING MERCHANT RULES"
            }]
          }
        },
        "FETCHING MERCHANT RULES": {
          invoke: {
            src: "getBusinessRules",
            input: _ref139 => {
              let {
                context
              } = _ref139;
              return {
                productKey: context.productKey,
                selection: context.selection
              };
            },
            onDone: [{
              guard: "isStepByStep",
              actions: [assign(_ref140 => {
                let {
                  event
                } = _ref140;
                return {
                  merchantRules: event.output
                };
              })],
              target: "SELECTION COMPLETE"
            }, {
              actions: [assign(_ref141 => {
                let {
                  event
                } = _ref141;
                return {
                  merchantRules: event.output
                };
              })],
              target: "FETCHING DATA"
            }],
            onError: [{
              actions: [_ref142 => {
                let {
                  context,
                  event
                } = _ref142;
                return logError(event, context.selection, "getBusinessRules");
              }, assign(() => ({
                error: "MerchantRulesError"
              }))],
              target: "ERRORING"
            }]
          },
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign(_ref143 => {
                let {
                  event
                } = _ref143;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign(_ref144 => {
                let {
                  context,
                  event
                } = _ref144;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }, {
              guard: "shouldNotValidate",
              actions: [assign(_ref145 => {
                let {
                  context,
                  event
                } = _ref145;
                return updateSelection({
                  context,
                  event
                });
              })]
            }]
          }
        },
        "FETCHING DATA": {
          type: "parallel",
          states: {
            PRICES: {
              initial: "FETCHING PRICES",
              states: {
                "FETCHING PRICES": {
                  invoke: {
                    src: "getPrices",
                    input: _ref146 => {
                      let {
                        context
                      } = _ref146;
                      return {
                        productKey: context.productKey,
                        selection: context.selection,
                        attributes: context.attributes,
                        totalQuantity: context.totalQuantity,
                        shippingAddress: context.shippingAddress,
                        remainingOptionsPerGroup: context.remainingOptionsPerGroup,
                        customerGroupId: context.customerGroupId,
                        mcpSku: context.mcpSku,
                        artworkRequired: context.artworkRequired,
                        group: context.group
                      };
                    },
                    onDone: [{
                      actions: [assign(_ref147 => {
                        let {
                          context,
                          event
                        } = _ref147;
                        return storePrices({
                          context,
                          event
                        });
                      })],
                      target: "IDLE"
                    }],
                    onError: [{
                      actions: [_ref148 => {
                        let {
                          context,
                          event
                        } = _ref148;
                        return logError(event, context.selection, "getPrices", {
                          selectedService: context.selectedService
                        });
                      }, assign(() => ({
                        error: "PricingError"
                      })), assign(() => ({
                        prices: [],
                        price: void 0,
                        alternativePrices: []
                      }))],
                      target: "ERRORING"
                    }]
                  }
                },
                IDLE: {},
                ERRORING: {}
              }
            },
            "SERVICE PRICES": {
              initial: "STARTING",
              states: {
                STARTING: {
                  always: [{
                    guard: "shouldFetchServicePrices",
                    target: "FETCHING SERVICE PRICES"
                  }, {
                    target: "IDLE"
                  }]
                },
                "FETCHING SERVICE PRICES": {
                  exit: assign(() => ({
                    serviceError: void 0
                  })),
                  invoke: {
                    src: "getServicePrices",
                    input: _ref149 => {
                      var _context$shippingAddr3, _context$shippingAddr4;
                      let {
                        context
                      } = _ref149;
                      return {
                        productKey: context.productKey,
                        selection: context.selection,
                        customerGroupId: context.customerGroupId || "",
                        serviceKeys: context.serviceKeys,
                        countryCode: ((_context$shippingAddr3 = context.shippingAddress) === null || _context$shippingAddr3 === void 0 ? void 0 : _context$shippingAddr3.CountryCode) || "",
                        postalCode: ((_context$shippingAddr4 = context.shippingAddress) === null || _context$shippingAddr4 === void 0 ? void 0 : _context$shippingAddr4.PostalCode) || ""
                      };
                    },
                    onDone: [{
                      actions: [assign(_ref150 => {
                        let {
                          event
                        } = _ref150;
                        return {
                          servicePrices: event.output
                        };
                      })],
                      target: "IDLE"
                    }],
                    onError: [{
                      actions: [_ref151 => {
                        let {
                          context,
                          event
                        } = _ref151;
                        return logError(event, context.selection, "getServicePrices", {
                          serviceKeys: context.serviceKeys
                        });
                      }, assign(() => ({
                        servicePrices: void 0
                      })), assign(() => ({
                        serviceError: "ServicePricingError"
                      }))],
                      target: "IDLE"
                    }]
                  }
                },
                IDLE: {},
                ERRORING: {}
              }
            },
            "ARRIVAL DATES": {
              initial: "FETCHING ARRIVAL DATES",
              states: {
                IDLE: {},
                "FETCHING ARRIVAL DATES": {
                  invoke: {
                    src: "getArrivalDates",
                    input: _ref152 => {
                      let {
                        context
                      } = _ref152;
                      return {
                        productKey: context.productKey,
                        selection: context.selection,
                        customerGroupId: context.customerGroupId || "",
                        group: context.group,
                        totalQuantity: context.totalQuantity,
                        artworkRequired: context.artworkRequired,
                        remainingOptionsPerGroup: context.remainingOptionsPerGroup,
                        shippingAddress: context.shippingAddress,
                        attributes: context.attributes,
                        mcpSku: context.mcpSku,
                        merchantRules: context.merchantRules
                      };
                    },
                    onDone: [{
                      guard: {
                        type: "hasInsufficientInventoryWithoutGroup",
                        params: _ref153 => {
                          let {
                            event
                          } = _ref153;
                          return {
                            arrivalDates: event.output
                          };
                        }
                      },
                      actions: [assign(() => ({
                        panel: {
                          panelName: "Delivery Type",
                          openPanel: false,
                          showMessage: true,
                          variant: "warning",
                          message: translations.missingDeliveryType
                        },
                        arrivalDates: []
                      }))],
                      target: "IDLE"
                    }, {
                      guard: {
                        type: "insufficientInventory",
                        params: _ref154 => {
                          let {
                            event
                          } = _ref154;
                          return {
                            arrivalDates: event.output
                          };
                        }
                      },
                      target: "INSUFFICIENT INVENTORY"
                    }, {
                      actions: [assign(_ref155 => {
                        let {
                          context,
                          event
                        } = _ref155;
                        return {
                          arrivalDates: event.output,
                          panel: {
                            openPanel: context.isReviewPage,
                            showMessage: false,
                            panelName: ""
                          }
                          // remove missing delivery date message if it was shown
                        };
                      })],
                      target: "IDLE"
                    }],
                    onError: [{
                      actions: [_ref156 => {
                        let {
                          context,
                          event
                        } = _ref156;
                        return logError(event, context.selection, "getArrivalDates");
                      }, assign(() => ({
                        error: "ArrivalDateError"
                      }))],
                      target: "ERRORING"
                    }]
                  }
                },
                ERRORING: {},
                "INSUFFICIENT INVENTORY": {}
              }
            },
            INVENTORY: {
              initial: "FETCHING INVENTORY",
              states: {
                IDLE: {},
                "FETCHING INVENTORY": {
                  invoke: {
                    src: "getInventory",
                    input: _ref157 => {
                      let {
                        context
                      } = _ref157;
                      return {
                        productKey: context.productKey,
                        selection: context.selection,
                        totalQuantity: context.totalQuantity,
                        artworkRequired: context.artworkRequired,
                        remainingOptionsPerGroup: context.remainingOptionsPerGroup,
                        shippingAddress: context.shippingAddress,
                        attributes: context.attributes
                      };
                    },
                    onDone: [{
                      actions: [assign(_ref158 => {
                        let {
                          event
                        } = _ref158;
                        return {
                          inventory: event.output
                        };
                      })],
                      target: "IDLE"
                    }],
                    onError: [{
                      actions: [_ref159 => {
                        let {
                          context,
                          event
                        } = _ref159;
                        return logError(event, context.selection, "getInventory", {
                          group: JSON.stringify(context.group)
                        });
                      }, assign(() => ({
                        error: "InventoryError"
                      }))],
                      target: "IDLE"
                    }]
                  }
                }
              }
            }
          },
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign(_ref160 => {
                let {
                  event
                } = _ref160;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign(_ref161 => {
                let {
                  context,
                  event
                } = _ref161;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }, {
              guard: "shouldNotValidate",
              actions: [assign(_ref162 => {
                let {
                  context,
                  event
                } = _ref162;
                return updateSelection({
                  context,
                  event
                });
              })]
            }]
          }
        }
      },
      on: {
        "Reset machine": {
          actions: [assign(_ref163 => {
            let {
              context,
              event
            } = _ref163;
            return restoreDefaults({
              context,
              event
            });
          })],
          target: "STARTING"
        },
        "Select product route": {
          actions: [assign(_ref164 => {
            let {
              context,
              event
            } = _ref164;
            return replaceSelection({
              context,
              event
            });
          })],
          target: "STARTING"
        },
        "Select service": {
          actions: [assign(_ref165 => {
            let {
              context,
              event
            } = _ref165;
            return selectService({
              context,
              event
            });
          })]
        },
        "Set device": {
          actions: [assign(_ref166 => {
            let {
              event
            } = _ref166;
            return {
              device: event.device
            };
          })]
        },
        "Toggle panel": {
          actions: [assign(_ref167 => {
            let {
              context,
              event
            } = _ref167;
            return togglePanel({
              context,
              event
            });
          })]
        },
        "Set price": {
          actions: [assign(_ref168 => {
            let {
              context,
              event
            } = _ref168;
            return setPrice({
              context,
              event
            });
          })]
        }
      }
    }
  }
});

// src/statemachines/selector/productSelector.machine.ts
import { assertEvent as assertEvent2, assign as assign2, setup as setup2 } from "xstate";
var initialContext2 = {
  attributes: [],
  selection: {},
  attributesCount: 0,
  productKey: "",
  serviceKeys: [],
  selectedService: void 0,
  mcpSku: "",
  prices: [],
  pivotPrices: {},
  servicePrices: void 0,
  alternativePrices: [],
  pricesPerQuantity: [],
  group: [],
  groupAttributes: [],
  customerGroupId: "",
  invalidSelection: {},
  remainingOptionsPerGroup: [],
  priceAttributes: {},
  totalQuantity: 0,
  selectedDeliveryOption: {
    name: "Normal"
  },
  arrivalDates: [],
  panel: {
    openPanel: false,
    showMessage: false,
    panelName: ""
  },
  touchedAttributes: [],
  device: "mobile",
  merchantRules: {
    deliveryTool: {}
  },
  productAttributes: [],
  artworkRequired: true,
  isReviewPage: false,
  selectionMode: "default-values",
  product: void 0,
  deliveryDates: [{
    name: "Normal"
  }],
  inventory: []
};
var productSelectorMachine = setup2({
  types: {
    context: {},
    events: {}
  },
  actors: {
    validateSelection,
    getServicePrices,
    fetchPricing,
    fetchPivotPrices,
    fetchDeliveryDates,
    getBusinessRules: getBusinessRules2,
    getInventory
  },
  actions: {},
  guards: {
    shouldValidate: _ref169 => {
      let {
        event
      } = _ref169;
      assertEvent2(event, "Select attribute value");
      return event.shouldValidate;
    },
    shouldNotValidate: _ref170 => {
      let {
        event
      } = _ref170;
      assertEvent2(event, "Select attribute value");
      return !event.shouldValidate;
    },
    isSelectionInvalid: _ref171 => {
      let {
        context,
        event
      } = _ref171;
      assertEvent2(event, "Select attribute value");
      return isSelectionInvalid({
        context,
        event
      });
    },
    isConfigurationInvalid,
    isInventoryInsufficient,
    isStepByStep,
    isUnresolvable,
    canPreselectAttribute,
    canUnset,
    cannotUnset,
    areAllRequiredAttributesSelected,
    shouldFetchServicePrices
  }
}).createMachine({
  context: initialContext2,
  id: "SelectorMachine",
  initial: "WAITING TO START",
  states: {
    "WAITING TO START": {
      on: {
        "Start machine": {
          actions: [assign2(_ref172 => {
            let {
              event
            } = _ref172;
            return initializeContext({
              event
            });
          })],
          target: "STARTING"
        }
      }
    },
    STARTING: {
      always: {
        target: "STARTED"
      }
    },
    STARTED: {
      initial: "VALIDATING",
      states: {
        VALIDATING: {
          invoke: {
            src: "validateSelection",
            input: _ref173 => {
              var _context$product4, _context$product5, _context$shippingAddr5;
              let {
                context
              } = _ref173;
              return {
                productKey: context.productKey,
                selection: context.selection,
                group: context.group,
                invalidSelection: context.invalidSelection,
                groupAttributes: context.groupAttributes,
                isPimProduct: Boolean((_context$product4 = context.product) === null || _context$product4 === void 0 ? void 0 : _context$product4.isPimProduct),
                productVersion: (_context$product5 = context.product) === null || _context$product5 === void 0 ? void 0 : _context$product5.productVersion,
                country: ((_context$shippingAddr5 = context.shippingAddress) === null || _context$shippingAddr5 === void 0 ? void 0 : _context$shippingAddr5.CountryCode) || "NL",
                quantity: context.customQuantity || context.totalQuantity
              };
            },
            onDone: [{
              actions: [_ref174 => {
                let {
                  context,
                  event
                } = _ref174;
                return logError(event.output, context.selection, "getAttributeConfiguration");
              }, assign2(() => ({
                error: "ConfigurationError"
              }))],
              guard: "isConfigurationInvalid",
              target: "ERRORING"
            }, {
              guard: {
                type: "isUnresolvable",
                params: _ref175 => {
                  let {
                    event
                  } = _ref175;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              actions: [_ref176 => {
                let {
                  context,
                  event
                } = _ref176;
                return logViolationError({
                  context,
                  event
                });
              }, assign2(() => ({
                error: "UnresolvedValidationError"
              }))],
              target: "ERRORING"
            }, {
              guard: {
                type: "canPreselectAttribute",
                params: _ref177 => {
                  let {
                    event
                  } = _ref177;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              actions: [assign2(_ref178 => {
                let {
                  context,
                  event
                } = _ref178;
                return preselectAttribute({
                  context,
                  event
                });
              })],
              target: "VALIDATING",
              reenter: true
            }, {
              actions: [assign2(_ref179 => {
                let {
                  context,
                  event
                } = _ref179;
                return unsetAttribute({
                  context,
                  event
                });
              })],
              guard: {
                type: "canUnset",
                params: _ref180 => {
                  let {
                    event
                  } = _ref180;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              target: "VALIDATING",
              reenter: true
            }, {
              actions: [_ref181 => {
                let {
                  context,
                  event
                } = _ref181;
                return logViolationError({
                  context,
                  event
                });
              }, assign2(() => ({
                error: "UnresolvedValidationError"
              }))],
              guard: {
                type: "cannotUnset",
                params: _ref182 => {
                  let {
                    event
                  } = _ref182;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              target: "ERRORING"
            }, {
              actions: [assign2(_ref183 => {
                let {
                  context,
                  event
                } = _ref183;
                return storeRemainingOptions({
                  context,
                  event
                });
              })],
              target: "IDLE"
            }],
            onError: [{
              actions: [_ref184 => {
                let {
                  context,
                  event
                } = _ref184;
                return logError(event, context.selection, "validateSelection");
              }, assign2(() => ({
                error: "UnknownValidationError"
              }))],
              target: "ERRORING"
            }]
          }
        },
        IDLE: {
          always: {
            guard: "areAllRequiredAttributesSelected",
            target: "FETCHING DATA"
          },
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign2(_ref185 => {
                let {
                  event
                } = _ref185;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign2(_ref186 => {
                let {
                  context,
                  event
                } = _ref186;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }]
          }
        },
        "SELECTION COMPLETE": {
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign2(_ref187 => {
                let {
                  event
                } = _ref187;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign2(_ref188 => {
                let {
                  context,
                  event
                } = _ref188;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }, {
              guard: "shouldNotValidate",
              actions: [assign2(_ref189 => {
                let {
                  context,
                  event
                } = _ref189;
                return updateSelection({
                  context,
                  event
                });
              })]
            }]
          }
        },
        "FETCHING DATA": {
          type: "parallel",
          states: {
            PRICES: {
              initial: "FETCHING PRICES",
              states: {
                "FETCHING PRICES": {
                  invoke: {
                    src: "fetchPricing",
                    input: _ref190 => {
                      var _context$product6, _context$product7, _context$shippingAddr6, _context$shippingAddr7;
                      let {
                        context
                      } = _ref190;
                      return {
                        productKey: context.productKey,
                        selection: context.selection,
                        quantityList: ((_context$product6 = context.product) === null || _context$product6 === void 0 ? void 0 : _context$product6.customProductQuantities) || [],
                        version: Number((_context$product7 = context.product) === null || _context$product7 === void 0 ? void 0 : _context$product7.productVersion),
                        group: context.group,
                        country: ((_context$shippingAddr6 = context.shippingAddress) === null || _context$shippingAddr6 === void 0 ? void 0 : _context$shippingAddr6.CountryCode) || "",
                        postalCode: ((_context$shippingAddr7 = context.shippingAddress) === null || _context$shippingAddr7 === void 0 ? void 0 : _context$shippingAddr7.PostalCode) || "",
                        attributes: context.attributes,
                        totalQuantity: context.totalQuantity,
                        customQuantity: context.customQuantity || 0,
                        artworkRequired: context.artworkRequired,
                        remainingOptionsPerGroup: context.remainingOptionsPerGroup,
                        customerGroupId: context.customerGroupId
                      };
                    },
                    onDone: [{
                      actions: [assign2(_ref191 => {
                        let {
                          context,
                          event
                        } = _ref191;
                        return storePricing({
                          context,
                          event
                        });
                      })],
                      target: "DONE"
                    }],
                    onError: [{
                      actions: [_ref192 => {
                        let {
                          context,
                          event
                        } = _ref192;
                        return logError(event, context.selection, "pricing", {
                          selectedService: context.selectedService
                        });
                      }, assign2(() => ({
                        error: "PricingError"
                      })), assign2(() => ({
                        prices: [],
                        price: void 0
                      }))],
                      target: "ERRORING"
                    }]
                  }
                },
                DONE: {
                  type: "final"
                },
                ERRORING: {}
              }
            },
            "MERCHANT RULES": {
              initial: "FETCHING MERCHANT RULES",
              states: {
                "FETCHING MERCHANT RULES": {
                  invoke: {
                    src: "getBusinessRules",
                    input: _ref193 => {
                      let {
                        context
                      } = _ref193;
                      return {
                        productKey: context.productKey,
                        selection: context.selection
                      };
                    },
                    onDone: [{
                      actions: [assign2(_ref194 => {
                        let {
                          event
                        } = _ref194;
                        return {
                          merchantRules: event.output
                        };
                      })],
                      target: "DONE"
                    }],
                    onError: [{
                      actions: [_ref195 => {
                        let {
                          context,
                          event
                        } = _ref195;
                        return logError(event, context.selection, "getBusinessRules");
                      }, assign2(() => ({
                        error: "MerchantRulesError"
                      }))],
                      target: "ERRORING"
                    }]
                  }
                },
                DONE: {
                  type: "final"
                },
                ERRORING: {}
              }
            },
            "PIVOT PRICES": {
              initial: "START",
              states: {
                START: {
                  always: [{
                    guard: "isStepByStep",
                    target: "DONE"
                  }, {
                    target: "FETCHING PIVOT PRICES"
                  }]
                },
                "FETCHING PIVOT PRICES": {
                  invoke: {
                    src: "fetchPivotPrices",
                    input: _ref196 => {
                      var _context$product8, _context$product9, _context$shippingAddr8, _context$shippingAddr9;
                      let {
                        context
                      } = _ref196;
                      return {
                        productKey: context.productKey,
                        selection: context.selection,
                        quantity: context.totalQuantity || ((_context$product8 = context.product) === null || _context$product8 === void 0 || (_context$product8 = _context$product8.customProductQuantities) === null || _context$product8 === void 0 ? void 0 : _context$product8[0]) || 1,
                        version: Number((_context$product9 = context.product) === null || _context$product9 === void 0 ? void 0 : _context$product9.productVersion),
                        country: ((_context$shippingAddr8 = context.shippingAddress) === null || _context$shippingAddr8 === void 0 ? void 0 : _context$shippingAddr8.CountryCode) || "",
                        postalCode: ((_context$shippingAddr9 = context.shippingAddress) === null || _context$shippingAddr9 === void 0 ? void 0 : _context$shippingAddr9.PostalCode) || "",
                        attributes: context.attributes,
                        group: context.group,
                        totalQuantity: context.totalQuantity,
                        artworkRequired: context.artworkRequired,
                        remainingOptionsPerGroup: context.remainingOptionsPerGroup,
                        deliveryOptionId: context.selectedDeliveryOption.id,
                        customerGroupId: context.customerGroupId
                      };
                    },
                    onDone: [{
                      actions: [assign2(_ref197 => {
                        let {
                          event
                        } = _ref197;
                        return storePivotPrices({
                          event
                        });
                      })],
                      target: "DONE"
                    }],
                    onError: [{
                      actions: [_ref198 => {
                        let {
                          context,
                          event
                        } = _ref198;
                        return logError(event, context.selection, "pivotPrices");
                      }, assign2(() => ({
                        error: "PivotPricesError"
                      })), assign2(() => ({
                        pivotPrices: {}
                      }))],
                      target: "ERRORING"
                    }]
                  }
                },
                DONE: {
                  type: "final"
                },
                ERRORING: {
                  type: "final"
                }
              }
            },
            "SERVICE PRICES": {
              initial: "STARTING",
              states: {
                STARTING: {
                  always: [{
                    guard: "shouldFetchServicePrices",
                    target: "FETCHING SERVICE PRICES"
                  }, {
                    target: "DONE"
                  }]
                },
                "FETCHING SERVICE PRICES": {
                  exit: assign2(() => ({
                    serviceError: void 0
                  })),
                  invoke: {
                    src: "getServicePrices",
                    input: _ref199 => {
                      var _context$shippingAddr10, _context$shippingAddr11;
                      let {
                        context
                      } = _ref199;
                      return {
                        productKey: context.productKey,
                        selection: context.selection,
                        customerGroupId: context.customerGroupId || "",
                        serviceKeys: context.serviceKeys,
                        countryCode: ((_context$shippingAddr10 = context.shippingAddress) === null || _context$shippingAddr10 === void 0 ? void 0 : _context$shippingAddr10.CountryCode) || "",
                        postalCode: ((_context$shippingAddr11 = context.shippingAddress) === null || _context$shippingAddr11 === void 0 ? void 0 : _context$shippingAddr11.PostalCode) || ""
                      };
                    },
                    onDone: [{
                      actions: [assign2(_ref200 => {
                        let {
                          event
                        } = _ref200;
                        return {
                          servicePrices: event.output
                        };
                      })],
                      target: "DONE"
                    }],
                    onError: [{
                      actions: [_ref201 => {
                        let {
                          context,
                          event
                        } = _ref201;
                        return logError(event, context.selection, "getServicePrices", {
                          serviceKeys: context.serviceKeys
                        });
                      }, assign2(() => ({
                        servicePrices: void 0
                      })), assign2(() => ({
                        serviceError: "ServicePricingError"
                      }))],
                      target: "DONE"
                    }]
                  }
                },
                DONE: {
                  type: "final"
                },
                ERRORING: {}
              }
            },
            "FETCH DELIVERY DATES": {
              initial: "FETCHING DELIVERY DATES",
              states: {
                "FETCHING DELIVERY DATES": {
                  invoke: {
                    src: "fetchDeliveryDates",
                    input: _ref202 => {
                      var _context$product10, _context$shippingAddr12, _context$product11, _context$shippingAddr13;
                      let {
                        context
                      } = _ref202;
                      return {
                        selection: context.selection,
                        quantity: context.totalQuantity || ((_context$product10 = context.product) === null || _context$product10 === void 0 || (_context$product10 = _context$product10.customProductQuantities) === null || _context$product10 === void 0 ? void 0 : _context$product10[0]) || 1,
                        country: ((_context$shippingAddr12 = context.shippingAddress) === null || _context$shippingAddr12 === void 0 ? void 0 : _context$shippingAddr12.CountryCode) || "",
                        version: Number((_context$product11 = context.product) === null || _context$product11 === void 0 ? void 0 : _context$product11.productVersion),
                        productKey: context.productKey,
                        postalCode: ((_context$shippingAddr13 = context.shippingAddress) === null || _context$shippingAddr13 === void 0 ? void 0 : _context$shippingAddr13.PostalCode) || "",
                        groupSelection: context.group
                      };
                    },
                    onDone: [{
                      actions: [assign2(_ref203 => {
                        let {
                          context,
                          event
                        } = _ref203;
                        return storeDeliveryDates({
                          context,
                          event
                        });
                      })],
                      target: "DONE"
                    }],
                    onError: [{
                      actions: [_ref204 => {
                        let {
                          context,
                          event
                        } = _ref204;
                        return logError(event, context.selection, "deliveryDates");
                      }, assign2(() => ({
                        error: "DeliveryDateError"
                      }))],
                      target: "ERRORING"
                    }]
                  }
                },
                DONE: {
                  type: "final"
                },
                ERRORING: {}
              }
            },
            INVENTORY: {
              initial: "FETCHING INVENTORY",
              states: {
                "FETCHING INVENTORY": {
                  invoke: {
                    src: "fetchDeliveryDates",
                    input: _ref205 => {
                      var _context$product12, _context$shippingAddr14, _context$product13, _context$shippingAddr15;
                      let {
                        context
                      } = _ref205;
                      return {
                        selection: context.selection,
                        quantity: context.totalQuantity || ((_context$product12 = context.product) === null || _context$product12 === void 0 || (_context$product12 = _context$product12.customProductQuantities) === null || _context$product12 === void 0 ? void 0 : _context$product12[0]) || 1,
                        country: ((_context$shippingAddr14 = context.shippingAddress) === null || _context$shippingAddr14 === void 0 ? void 0 : _context$shippingAddr14.CountryCode) || "",
                        version: Number((_context$product13 = context.product) === null || _context$product13 === void 0 ? void 0 : _context$product13.productVersion),
                        productKey: context.productKey,
                        postalCode: ((_context$shippingAddr15 = context.shippingAddress) === null || _context$shippingAddr15 === void 0 ? void 0 : _context$shippingAddr15.PostalCode) || "",
                        groupSelection: getDefaultGroup(context.attributes, context.totalQuantity, !context.artworkRequired, context.remainingOptionsPerGroup, true),
                        sort: "none"
                      };
                    },
                    onDone: [{
                      guard: {
                        type: "isInventoryInsufficient",
                        params: _ref206 => {
                          let {
                            event
                          } = _ref206;
                          return {
                            inventory: event.output
                          };
                        }
                      },
                      target: "INSUFFICIENT INVENTORY",
                      actions: [assign2(_ref207 => {
                        let {
                          context,
                          event
                        } = _ref207;
                        return storeInventory({
                          context,
                          event
                        });
                      })]
                    }, {
                      actions: [assign2(_ref208 => {
                        let {
                          event,
                          context
                        } = _ref208;
                        return storeInventory({
                          event,
                          context
                        });
                      })],
                      target: "DONE"
                    }],
                    onError: [{
                      actions: [_ref209 => {
                        let {
                          context,
                          event
                        } = _ref209;
                        return logError(event, context.selection, "inventory");
                      }],
                      target: "DONE"
                    }]
                  }
                },
                "INSUFFICIENT INVENTORY": {},
                DONE: {
                  type: "final"
                }
              }
            }
          },
          onDone: "SELECTION COMPLETE",
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign2(_ref210 => {
                let {
                  event
                } = _ref210;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign2(_ref211 => {
                let {
                  context,
                  event
                } = _ref211;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }, {
              guard: "shouldNotValidate",
              actions: [assign2(_ref212 => {
                let {
                  context,
                  event
                } = _ref212;
                return updateSelection({
                  context,
                  event
                });
              })]
            }]
          }
        },
        "WAIT FOR USER CONFIRMATION": {
          on: {
            "Select attribute value": [{
              guard: "shouldValidate",
              actions: [assign2(_ref213 => {
                let {
                  context,
                  event
                } = _ref213;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }],
            "Cancel unset": [{
              target: "IDLE"
            }]
          }
        },
        ERRORING: {
          exit: assign2(() => ({
            error: void 0
          })),
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign2(_ref214 => {
                let {
                  event
                } = _ref214;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign2(_ref215 => {
                let {
                  context,
                  event
                } = _ref215;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }]
          }
        }
      },
      on: {
        "Reset machine": {
          actions: [assign2(_ref216 => {
            let {
              context,
              event
            } = _ref216;
            return restoreDefaults({
              context,
              event
            });
          })],
          target: "STARTING"
        },
        "Select product route": {
          actions: [assign2(_ref217 => {
            let {
              context,
              event
            } = _ref217;
            return replaceSelection({
              context,
              event
            });
          })],
          target: "STARTING"
        },
        "Select service": {
          actions: [assign2(_ref218 => {
            let {
              context,
              event
            } = _ref218;
            return selectService({
              context,
              event
            });
          })]
        },
        "Set device": {
          actions: [assign2(_ref219 => {
            let {
              event
            } = _ref219;
            return {
              device: event.device
            };
          })]
        },
        "Set price": {
          actions: [assign2(_ref220 => {
            let {
              context,
              event
            } = _ref220;
            return setPrice({
              context,
              event
            });
          })]
        },
        "Toggle panel": {
          actions: [assign2(_ref221 => {
            let {
              context,
              event
            } = _ref221;
            return togglePanel({
              context,
              event
            });
          })]
        },
        "Set quantity": [{
          guard: "isStepByStep",
          actions: [assign2(_ref222 => {
            let {
              context,
              event
            } = _ref222;
            return setQuantity({
              context,
              event
            });
          })]
        }, {
          actions: [assign2(_ref223 => {
            let {
              context,
              event
            } = _ref223;
            return setQuantity({
              context,
              event
            });
          })],
          target: "STARTED.FETCHING DATA.PIVOT PRICES.FETCHING PIVOT PRICES"
          // Transition to the fetching state for pivot prices
        }],
        "Set delivery option": [{
          guard: "isStepByStep",
          actions: [assign2(_ref224 => {
            let {
              context,
              event
            } = _ref224;
            return setDeliveryOption({
              context,
              event
            });
          })]
        }, {
          actions: [assign2(_ref225 => {
            let {
              context,
              event
            } = _ref225;
            return setDeliveryOption({
              context,
              event
            });
          })],
          target: "STARTED.FETCHING DATA.PIVOT PRICES.FETCHING PIVOT PRICES"
          // Transition to the fetching state for pivot prices
        }],
        "Set custom quantity": {
          actions: [assign2(_ref226 => {
            let {
              context,
              event
            } = _ref226;
            return setCustomQuantity({
              context,
              event
            });
          })],
          target: "STARTED.FETCHING DATA.PRICES.FETCHING PRICES"
          // Transition to the fetching state for prices
        }
      }
    }
  }
});

// src/contexts/SelectorContext.tsx
import { jsx } from "react/jsx-runtime";
var SelectorContext = createContext(null);
var SelectorContextProvider = _ref227 => {
  let {
    children,
    isPimProduct = false
  } = _ref227;
  const ActorContext = React.useMemo(() => isPimProduct ? createActorContext(productSelectorMachine) : createActorContext(selectorMachine), [isPimProduct]);
  return /* @__PURE__ */jsx(ActorContext.Provider, {
    children: /* @__PURE__ */jsx(SelectorContext.Provider, {
      value: ActorContext,
      children
    })
  });
};

// src/contexts/PricesContext.tsx
import { createActorContext as createActorContext2 } from "@xstate/react";

// src/statemachines/prices/prices.machine.ts
import { assertEvent as assertEvent3, assign as assign3, setup as setup3 } from "xstate";

// src/statemachines/actors/priceActors.ts
import { fromPromise as fromPromise2 } from "xstate";

// src/components/prices/table/exp1849Config.ts
var defineExperiment = config => config;
var EXP1849 = defineExperiment({
  id: "exp1849_custom_quantities_for_posters_brochures_and_stickers_small_format_products",
  productKeys: ["PRD-HZLEQOOY", "PRD-XESPOIQX", "PRD-GUDQLU1E", "PRD-YCHQLQRC"],
  merchantRulesConfiguration: {
    "PRD-HZLEQOOY": [{
      state: "fullyResolved",
      options: [{
        key: "Quantity",
        type: "numeric",
        values: [{
          type: "range",
          range: {
            minimum: 25,
            maximum: 250,
            increment: 25
          }
        }],
        buckets: ["option"]
      }]
    }],
    "PRD-XESPOIQX": [{
      state: "fullyResolved",
      options: [{
        key: "Quantity",
        type: "numeric",
        values: [{
          type: "numberLiteral",
          numberLiteral: "100"
        }, {
          type: "range",
          range: {
            minimum: 250,
            maximum: 1e3,
            increment: 250
          }
        }, {
          type: "range",
          range: {
            minimum: 1e3,
            maximum: 1e4,
            increment: 1e3
          }
        }],
        buckets: ["option"]
      }]
    }],
    "PRD-GUDQLU1E": [{
      state: "fullyResolved",
      options: [{
        key: "Quantity",
        type: "numeric",
        values: [{
          type: "numberLiteral",
          numberLiteral: "10"
        }, {
          type: "range",
          range: {
            minimum: 500,
            maximum: 500,
            increment: 1
          }
        }, {
          type: "range",
          range: {
            minimum: 25,
            maximum: 100,
            increment: 25
          }
        }, {
          type: "range",
          range: {
            minimum: 100,
            maximum: 100,
            increment: 1
          }
        }, {
          type: "range",
          range: {
            minimum: 100,
            maximum: 500,
            increment: 50
          }
        }],
        buckets: ["option"]
      }]
    }],
    "PRD-YCHQLQRC": [{
      state: "fullyResolved",
      options: [{
        key: "Quantity",
        type: "numeric",
        values: [{
          type: "range",
          range: {
            minimum: 1,
            maximum: 5,
            increment: 1
          }
        }, {
          type: "range",
          range: {
            minimum: 10,
            maximum: 50,
            increment: 5
          }
        }, {
          type: "range",
          range: {
            minimum: 100,
            maximum: 250,
            increment: 50
          }
        }, {
          type: "range",
          range: {
            minimum: 500,
            maximum: 1e3,
            increment: 250
          }
        }],
        buckets: ["option"]
      }]
    }]
  }
});
var isExp1849Product = (productKey, printingProcess) => {
  const isProductInExperiment = EXP1849.productKeys.includes(productKey);
  const isDigitalPrinting = printingProcess === "Digital";
  return Boolean(isProductInExperiment && isDigitalPrinting);
};

// src/helpers/customQuantities.ts
var getAllPossibleQuantities = remainingQuantityOption => {
  const rangeValues = remainingQuantityOption.values.filter(value => value.type === "range");
  const quantities = rangeValues.reduce((allQuantities, rangeValue) => {
    const {
      minimum,
      maximum,
      increment
    } = rangeValue.range;
    if (!minimum || !maximum) return allQuantities;
    if (!increment) {
      return [...allQuantities, minimum];
    }
    const rangeQuantities = createNumberArrayFromRange(rangeValue.range);
    return [...allQuantities, ...rangeQuantities];
  }, []);
  const set = new Set(quantities);
  const quantitiesArray = [...set];
  quantitiesArray.sort((a, b) => a - b);
  return quantitiesArray;
};
var getCustomQuantities = (prices, productMerchandisedQuantities, remainingOptionsPerPrintingProcess) => {
  return prices.reduce((acc, price) => {
    var _remainingOptionsForP;
    const printingProcess = price.name;
    if (!printingProcess) {
      return acc;
    }
    const remainingOptionsForPrintingProcess = remainingOptionsPerPrintingProcess === null || remainingOptionsPerPrintingProcess === void 0 ? void 0 : remainingOptionsPerPrintingProcess[printingProcess];
    if (!remainingOptionsForPrintingProcess || remainingOptionsForPrintingProcess.length === 0) {
      return acc;
    }
    const remainingOptions = ((_remainingOptionsForP = remainingOptionsForPrintingProcess[0]) === null || _remainingOptionsForP === void 0 ? void 0 : _remainingOptionsForP.options) || [];
    const remainingQuantityOption = remainingOptions.find(_ref228 => {
      let {
        key,
        type
      } = _ref228;
      return key === "Quantity" && type === "numeric";
    });
    if (!remainingQuantityOption) {
      return acc;
    }
    const allQuantities = getAllPossibleQuantities(remainingQuantityOption);
    const merchandisedQuantitiesForProcess = price.quantities.map(_ref229 => {
      let {
        quantity
      } = _ref229;
      return quantity;
    });
    const merchandisedQuantities = productMerchandisedQuantities && productMerchandisedQuantities.length > 0 ? productMerchandisedQuantities : merchandisedQuantitiesForProcess;
    const uniqueMerchandisedQuantities = new Set(merchandisedQuantities);
    const customQuantities = allQuantities.filter(quantity => !uniqueMerchandisedQuantities.has(quantity)).slice(0, 100);
    return _objectSpread(_objectSpread({}, acc), {}, {
      [printingProcess]: customQuantities
    });
  }, {});
};
var getExp1849CustomQuantityAmounts = function (productKey) {
  let prices = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const remainingQuantityOption = EXP1849.merchantRulesConfiguration[productKey][0].options.find(_ref230 => {
    let {
      key,
      type
    } = _ref230;
    return key === "Quantity" && type === "numeric";
  });
  if (remainingQuantityOption) {
    const allQuantities = getAllPossibleQuantities(remainingQuantityOption);
    const merchandisedQuantities = prices.reduce((quantities, price) => {
      const merchandised = price.quantities.map(_ref231 => {
        let {
          quantity
        } = _ref231;
        return quantity;
      });
      return [...quantities, ...merchandised];
    }, []);
    const uniqueMerchandisedQuantities = new Set(merchandisedQuantities);
    const customQuantities = allQuantities.filter(quantity => !uniqueMerchandisedQuantities.has(quantity));
    return customQuantities.slice(0, 100);
  }
};

// src/statemachines/actors/priceActors.ts
var fetchPrices = fromPromise2(async _ref232 => {
  let {
    input
  } = _ref232;
  if (!input.shippingAddress) {
    return Promise.reject(new Error("No shipping address while fetching prices"));
  }
  return productClient.getPrices({
    variableAttributes: input.selectionAttributes,
    quantity: input.quantity,
    productKey: input.productKey,
    mcpSku: input.mcpSku,
    address: input.shippingAddress,
    group: input.group,
    customerGroupId: input.customerGroupId,
    sort: input.sort,
    customHeaders: {
      "x-filename": "priceGuards.ts",
      "x-href": getCurrentUrl()
    }
  });
});
var fetchArrivalDates = fromPromise2(async _ref233 => {
  let {
    input
  } = _ref233;
  if (!input.selectionAttributes || !input.shippingAddress || !input.group || !input.prices || !input.remainingOptionsPerPrintingProcess) {
    return Promise.reject(new Error("Missing data while fetching arrival dates"));
  }
  return productClient.getExpectedDeliveryDates({
    prices: input.prices,
    productKey: input.productKey,
    singleAttributes: input.selectionAttributes,
    shippingAddress: input.shippingAddress,
    group: input.group,
    remainingOptionsPerPrintingProcess: input.remainingOptionsPerPrintingProcess
  });
});
var fetchRemainingOptions = fromPromise2(async _ref234 => {
  let {
    input
  } = _ref234;
  if (!input.selectionAttributes || !input.prices) {
    return Promise.reject(new Error("No selection attributes or prices while fetching remaining options"));
  }
  return validationClient.getRemainingOptionsPerPrintingProcess(input.productKey, input.selectionAttributes, input.prices);
});
var fetchCustomQuantities = fromPromise2(_ref235 => {
  let {
    input
  } = _ref235;
  if (!input.prices) {
    return Promise.reject(new Error("No prices while fetching custom quantities"));
  }
  return Promise.resolve(getCustomQuantities(input.prices, input.merchandisedQuantities, input.remainingOptionsPerPrintingProcess));
});
var fetchCustomQuantitiesPrices = fromPromise2(_ref236 => {
  let {
    input
  } = _ref236;
  if (!input.selectionAttributes || !input.shippingAddress) {
    return Promise.reject(new Error("No selection attribute or shipping address while fetching custom quantity prices"));
  }
  return productClient.getPrices({
    productKey: input.productKey,
    mcpSku: input.mcpSku,
    customerGroupId: input.customerGroupId,
    sort: input.sort,
    group: input.group,
    variableAttributes: input.selectionAttributes,
    quantity: input.quantity,
    address: input.shippingAddress,
    customHeaders: {
      "x-filename": "priceGuards.ts",
      "x-href": getCurrentUrl()
    }
  });
});

// src/statemachines/actions/priceActions.ts
var initializeContext2 = _ref237 => {
  let {
    event
  } = _ref237;
  return {
    quantity: event.quantity,
    productKey: event.productKey,
    mcpSku: event.mcpSku,
    selectionAttributes: event.selectionAttributes,
    shippingAddress: event.shippingAddress,
    group: event.group,
    sort: event.sort,
    customerGroupId: event.customerGroupId,
    selectedPriceAttributes: event.preselectedPriceAttributes,
    inventoryCheckEnabled: event.inventoryCheckEnabled,
    merchandisedQuantities: event.merchandisedQuantities,
    remainingOptions: event.remainingOptions
  };
};
var storePrices2 = _ref238 => {
  let {
    context,
    event
  } = _ref238;
  if (context.selectedPriceAttributes) {
    const preselectedPrice = getPriceByAttributes(event.output, context.selectedPriceAttributes);
    return {
      prices: event.output,
      selectedPrice: preselectedPrice
    };
  }
  return {
    prices: event.output
  };
};
var storeArrivalDates = _ref239 => {
  let {
    context,
    event
  } = _ref239;
  if (context.selectedPriceAttributes) {
    const deliveryType = getSelectedPriceAttributeValue(context.selectedPriceAttributes, "Delivery Type");
    const printingProcess = getSelectedPriceAttributeValue(context.selectedPriceAttributes, "Printing");
    const selectedArrivalDate = getArrivalDate(event.output, deliveryType, printingProcess);
    return {
      arrivalDates: event.output,
      selectedArrivalDate
    };
  }
  return {
    arrivalDates: event.output
  };
};
var storeRemainingOptions2 = _ref240 => {
  let {
    event
  } = _ref240;
  return {
    remainingOptions: event.output
  };
};
var storeCustomQuantities = _ref241 => {
  let {
    event
  } = _ref241;
  return {
    customQuantities: event.output
  };
};
var storeCustomQuantityPrices = _ref242 => {
  let {
    context,
    event
  } = _ref242;
  if (context.selectedPriceAttributes) {
    const selectedPrice = getPriceByAttributes(event.output, context.selectedPriceAttributes);
    return {
      customQuantityPrices: event.output,
      selectedPrice
    };
  }
  return {
    customQuantityPrices: event.output
  };
};
var storeSelectedPriceAndAttributes = _ref243 => {
  let {
    context,
    event
  } = _ref243;
  const deliveryType = getSelectedPriceAttributeValue(event.selectedPriceAttributes, "Delivery Type");
  const printingProcess = getSelectedPriceAttributeValue(event.selectedPriceAttributes, "Printing");
  const selectedArrivalDate = getArrivalDate(context.arrivalDates, deliveryType, printingProcess);
  return {
    selectedPrice: event.selectedPrice,
    selectedPriceAttributes: event.selectedPriceAttributes,
    selectedArrivalDate
  };
};
var logError2 = _ref244 => {
  let {
    context,
    event
  } = _ref244;
  Sentry.exception({
    exception: event.error instanceof Error ? event.error : "An error occurred in the prices machine",
    extra: {
      mcpSku: context.mcpSku,
      productKey: context.productKey,
      selectedAttributes: JSON.stringify(context.selectionAttributes),
      arrivalDates: JSON.stringify(context.arrivalDates),
      selectedArrivalDate: context.selectedArrivalDate,
      selectedPriceAttributes: JSON.stringify(context.selectedPriceAttributes),
      selectedPrice: JSON.stringify(context.selectedPrice),
      customQuantities: JSON.stringify(context.customQuantities),
      inventoryCheckEnabled: context.inventoryCheckEnabled,
      group: JSON.stringify(context.group),
      response: JSON.stringify(event)
    },
    tags: {
      fileLocation: "pricesMachine",
      productKey: context.productKey,
      mcpSku: context.mcpSku
    },
    // Group the errors by the originating state
    fingerprint: ["pricesMachine", event.actorId]
  });
};
var logEmptyPricesError = _ref245 => {
  let {
    context,
    event
  } = _ref245;
  Sentry.exception({
    exception: "Attributes Resulted in Empty Price Table",
    extra: {
      mcpSku: context.mcpSku,
      productKey: context.productKey,
      selectedAttributes: JSON.stringify(context.selectionAttributes),
      response: JSON.stringify(event)
    },
    tags: {
      eventName: "EmptyPriceTable",
      fileLocation: "pricesMachine",
      productKey: context.productKey,
      mcpSku: context.mcpSku
    },
    fingerprint: ["printdeal-selector-show-prices"]
  });
};
var InsufficientInventoryError = _ref246 => {
  let {
    context,
    event
  } = _ref246;
  Sentry.exception({
    exception: "InsufficientInventoryError",
    extra: {
      mcpSku: context.mcpSku,
      productKey: context.productKey,
      selectedAttributes: JSON.stringify(context.selectionAttributes),
      response: JSON.stringify(event)
    },
    tags: {
      eventName: "InsufficientInventoryError",
      fileLocation: "pricesMachine",
      productKey: context.productKey,
      mcpSku: context.mcpSku
    },
    fingerprint: ["printdeal-selector-Insufficient-inventory"]
  });
};

// src/statemachines/guards/priceGuards.ts
var hasPrices = (_, params) => params.prices.length > 0;
var hasNoPrices = (_, params) => {
  if (Array.isArray(params.data)) {
    return true;
  }
  if (params.data && "response" in params.data) {
    return params.data.response.data.message === "No prices found";
  }
  return false;
};
var hasInsufficientInventoryResponse = (_ref247, params) => {
  let {
    context
  } = _ref247;
  return Boolean(hasInsufficientInventory(params.arrivalDates) && context.inventoryCheckEnabled);
};

// src/statemachines/prices/prices.machine.ts
var initialContext3 = {
  productKey: "",
  mcpSku: "",
  prices: [],
  arrivalDates: [],
  quantity: [],
  sort: [],
  inventoryCheckEnabled: true,
  merchandisedQuantities: [],
  remainingOptions: {}
};
var pricesMachine = setup3({
  types: {},
  actors: {
    fetchPrices,
    fetchArrivalDates,
    fetchCustomQuantities,
    fetchCustomQuantitiesPrices,
    fetchRemainingOptions
  },
  actions: {
    "Store selection": assign3(_ref248 => {
      let {
        event
      } = _ref248;
      assertEvent3(event, "Get prices");
      return {
        selectionAttributes: event.selectionAttributes
      };
    }),
    "Clear prices": assign3({
      prices: [],
      arrivalDates: [],
      customQuantities: void 0,
      customQuantityPrices: [],
      selectedPrice: void 0,
      selectedPriceAttributes: void 0
    }),
    "Deselect price": assign3({
      selectedPrice: void 0,
      selectedPriceAttributes: void 0
    }),
    "Reset custom quantity prices": assign3({
      customQuantityPrices: []
    })
  },
  guards: {
    hasPrices,
    hasNoPrices,
    hasInsufficientInventoryResponse
  }
}).createMachine({
  context: initialContext3,
  id: "Prices Machine",
  initial: "Initial",
  states: {
    "Showing Prices": {
      type: "parallel",
      states: {
        "Custom quantities": {
          initial: "Loading custom quantities",
          states: {
            "Loading custom quantities": {
              invoke: {
                src: "fetchCustomQuantities",
                input: _ref249 => {
                  let {
                    context
                  } = _ref249;
                  return {
                    prices: context.prices,
                    merchandisedQuantities: context.merchandisedQuantities,
                    remainingOptionsPerPrintingProcess: context.remainingOptions
                  };
                },
                onDone: [{
                  actions: [assign3(_ref250 => {
                    let {
                      event
                    } = _ref250;
                    return storeCustomQuantities({
                      event
                    });
                  })],
                  target: "#Prices Machine.Showing Prices.Custom quantities.Showing custom quantities"
                }],
                onError: [{
                  actions: [_ref251 => {
                    let {
                      context,
                      event
                    } = _ref251;
                    return logError2({
                      context,
                      event
                    });
                  }],
                  target: "#Prices Machine.Showing Prices.Custom quantities.Hiding custom quantities"
                }]
              }
            },
            "Showing custom quantities": {
              exit: "Reset custom quantity prices",
              initial: "Waiting for quantity selection",
              states: {
                "Loading custom quantity prices": {
                  invoke: {
                    src: "fetchCustomQuantitiesPrices",
                    input: _ref252 => {
                      let {
                        context,
                        event
                      } = _ref252;
                      assertEvent3(event, "Select custom quantity");
                      return {
                        shippingAddress: context.shippingAddress,
                        selectionAttributes: context.selectionAttributes,
                        quantity: event.quantity,
                        productKey: context.productKey,
                        mcpSku: context.mcpSku,
                        customerGroupId: context.customerGroupId,
                        group: context.group,
                        sort: context.sort
                      };
                    },
                    onDone: [{
                      actions: [assign3(_ref253 => {
                        let {
                          context,
                          event
                        } = _ref253;
                        return storeCustomQuantityPrices({
                          context,
                          event
                        });
                      })],
                      target: "#Prices Machine.Showing Prices.Custom quantities.Showing custom quantities.Showing custom quantity prices"
                    }],
                    onError: [{
                      actions: [_ref254 => {
                        let {
                          context,
                          event
                        } = _ref254;
                        return logError2({
                          context,
                          event
                        });
                      }],
                      target: "#Prices Machine.Showing Prices.Custom quantities.Showing custom quantities.Hiding custom quantity prices"
                    }]
                  }
                },
                "Showing custom quantity prices": {
                  on: {
                    "Select custom quantity": {
                      target: "#Prices Machine.Showing Prices.Custom quantities.Showing custom quantities.Loading custom quantity prices"
                    }
                  }
                },
                "Hiding custom quantity prices": {
                  on: {
                    "Select custom quantity": {
                      target: "#Prices Machine.Showing Prices.Custom quantities.Showing custom quantities.Loading custom quantity prices"
                    }
                  }
                },
                "Waiting for quantity selection": {
                  on: {
                    "Select custom quantity": {
                      target: "#Prices Machine.Showing Prices.Custom quantities.Showing custom quantities.Loading custom quantity prices"
                    }
                  }
                }
              }
            },
            "Hiding custom quantities": {}
          }
        },
        "Arrival dates": {
          initial: "Loading arrival dates",
          states: {
            "Loading arrival dates": {
              invoke: {
                src: "fetchArrivalDates",
                input: _ref255 => {
                  let {
                    context
                  } = _ref255;
                  return {
                    prices: context.prices,
                    productKey: context.productKey,
                    selectionAttributes: context.selectionAttributes,
                    shippingAddress: context.shippingAddress,
                    group: context.group,
                    remainingOptionsPerPrintingProcess: context.remainingOptions || {}
                  };
                },
                onDone: [{
                  guard: {
                    type: "hasInsufficientInventoryResponse",
                    params: _ref256 => {
                      let {
                        event
                      } = _ref256;
                      return {
                        arrivalDates: event.output
                      };
                    }
                  },
                  actions: [assign3(_ref257 => {
                    let {
                      context,
                      event
                    } = _ref257;
                    return storeArrivalDates({
                      context,
                      event
                    });
                  }), _ref258 => {
                    let {
                      context,
                      event
                    } = _ref258;
                    return InsufficientInventoryError({
                      context,
                      event
                    });
                  }],
                  target: "#Prices Machine.Showing request quote"
                }, {
                  actions: [assign3(_ref259 => {
                    let {
                      context,
                      event
                    } = _ref259;
                    return storeArrivalDates({
                      context,
                      event
                    });
                  })],
                  target: "#Prices Machine.Showing Prices.Arrival dates.Showing arrival dates"
                }],
                onError: [{
                  actions: [_ref260 => {
                    let {
                      context,
                      event
                    } = _ref260;
                    return logError2({
                      context,
                      event
                    });
                  }],
                  target: "#Prices Machine.Showing Prices.Arrival dates.Hiding arrival dates"
                }]
              }
            },
            "Showing arrival dates": {},
            "Hiding arrival dates": {}
          }
        },
        "Waiting for price selection": {
          on: {
            "Select price": {
              actions: [assign3(_ref261 => {
                let {
                  context,
                  event
                } = _ref261;
                return storeSelectedPriceAndAttributes({
                  context,
                  event
                });
              })],
              target: "#Prices Machine.Showing Prices.Waiting for price selection"
            }
          }
        }
      },
      on: {
        Reset: {
          actions: "Clear prices",
          target: "#Prices Machine.Initial"
        },
        "Get prices": {
          target: "#Prices Machine.Loading prices"
        },
        "Clear selected price": {
          actions: "Deselect price"
        }
      }
    },
    "Loading prices": {
      entry: "Store selection",
      invoke: {
        src: "fetchPrices",
        input: _ref262 => {
          let {
            context,
            event
          } = _ref262;
          assertEvent3(event, "Get prices");
          return {
            shippingAddress: context.shippingAddress,
            selectionAttributes: event.selectionAttributes,
            quantity: event.quantity,
            productKey: context.productKey,
            mcpSku: context.mcpSku,
            customerGroupId: event.customerGroupId,
            group: event.group,
            sort: context.sort
          };
        },
        onDone: [{
          actions: [assign3(_ref263 => {
            let {
              context,
              event
            } = _ref263;
            return storePrices2({
              context,
              event
            });
          })],
          guard: {
            type: "hasPrices",
            params: _ref264 => {
              let {
                event
              } = _ref264;
              return {
                prices: event.output
              };
            }
          },
          target: "#Prices Machine.Get remaining options"
        }, {
          guard: {
            type: "hasNoPrices",
            params: _ref265 => {
              let {
                event
              } = _ref265;
              return {
                data: event.output
              };
            }
          },
          target: "#Prices Machine.Erroring"
        }],
        onError: [{
          actions: [_ref266 => {
            let {
              context,
              event
            } = _ref266;
            return logEmptyPricesError({
              context,
              event
            });
          }],
          guard: {
            type: "hasNoPrices",
            params: _ref267 => {
              let {
                event
              } = _ref267;
              return {
                data: event
              };
            }
          },
          target: "#Prices Machine.Erroring"
        }, {
          actions: [_ref268 => {
            let {
              context,
              event
            } = _ref268;
            return logError2({
              context,
              event
            });
          }],
          target: "#Prices Machine.Erroring"
        }]
      }
    },
    "Get remaining options": {
      invoke: {
        src: "fetchRemainingOptions",
        input: _ref269 => {
          let {
            context
          } = _ref269;
          return {
            productKey: context.productKey,
            selectionAttributes: context.selectionAttributes,
            prices: context.prices
          };
        },
        onDone: [{
          actions: [assign3(_ref270 => {
            let {
              event
            } = _ref270;
            return storeRemainingOptions2({
              event
            });
          })],
          target: "#Prices Machine.Showing Prices"
        }],
        onError: [{
          actions: [_ref271 => {
            let {
              context,
              event
            } = _ref271;
            return logError2({
              context,
              event
            });
          }],
          target: "#Prices Machine.Showing Prices"
        }]
      }
    },
    "Hiding prices": {
      on: {
        "Get prices": {
          target: "#Prices Machine.Loading prices"
        }
      }
    },
    Erroring: {
      on: {
        "Get prices": {
          target: "#Prices Machine.Loading prices"
        }
      }
    },
    Initial: {
      on: {
        "Start machine": {
          actions: [assign3(_ref272 => {
            let {
              event
            } = _ref272;
            return initializeContext2({
              event
            });
          })],
          target: "#Prices Machine.Hiding prices"
        }
      }
    },
    "Showing request quote": {
      exit: "Clear prices",
      on: {
        Reset: {
          target: "#Prices Machine.Initial"
        },
        "Get prices": {
          target: "#Prices Machine.Loading prices"
        }
      }
    }
  }
});

// src/contexts/PricesContext.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var PricesContext = createActorContext2(pricesMachine);
var PricesContextProvider = _ref273 => {
  let {
    children
  } = _ref273;
  return /* @__PURE__ */jsx2(PricesContext.Provider, {
    children
  });
};

// src/hooks/useMachine.ts
var useSelectorMachineContext = selector => {
  const selectorContext = useContext(SelectorContext);
  if (!selectorContext) {
    throw new Error("useSelectorMachineContext must be used within a SelectorContextProvider");
  }
  return selectorContext.useSelector(selector);
};
var usePricesMachineContext = selector => PricesContext.useSelector(selector);
var useSelectorMachineSend = () => {
  const selectorContext = useContext(SelectorContext);
  if (!selectorContext) {
    throw new Error("useSelectorMachineSend must be used within a SelectorContextProvider");
  }
  const actor = selectorContext.useActorRef();
  return actor.send;
};
var usePricesMachineSend = () => {
  const actor = PricesContext.useActorRef();
  return actor.send;
};

// src/hooks/useCollapseLogic.ts
var useCollapseLogic = _ref274 => {
  let {
    filteredAttributes,
    attributeName,
    attributeIndex,
    selectedValue
  } = _ref274;
  const {
    isInitialized,
    experiment
  } = useExperiment("exp1916_stay_at_the_top_of_selector_instead_of_jump_to_bottom");
  const device = useSelectorMachineContext(state => state.context.device);
  const productRouteClicked = useSelectorMachineContext(state => state.context.productRouteClicked);
  const isReviewPage = useSelectorMachineContext(state => state.context.isReviewPage);
  const {
    panelName,
    openPanel
  } = useSelectorMachineContext(state => state.context.panel);
  const touchedAttributes = useSelectorMachineContext(state => state.context.touchedAttributes);
  const selection = useSelectorMachineContext(state => state.context.selection);
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  const touched = touchedAttributes.includes(attributeName);
  const [open, setOpen] = useState(selectionMode === "default-values");
  const groupAttribute = filteredAttributes.find(attribute => attribute.type === attributeName);
  const isExp1916Enabled = Boolean(isInitialized && experiment.variation === "variant");
  useEffect(() => {
    if (isExp1916Enabled && productRouteClicked && selectionMode === "step-by-step" && device === "desktop") {
      setOpen(true);
      return;
    }
    if (isReviewPage) {
      setOpen(true);
    } else if (touched && !selectedValue) {
      setOpen(true);
    } else if (attributeName === panelName && openPanel) {
      setOpen(true);
    } else if ((groupAttribute === null || groupAttribute === void 0 ? void 0 : groupAttribute.type) === "group" && groupAttribute.attributes.some(_ref275 => {
      let {
        name
      } = _ref275;
      return !selection[name];
    })) {
      setOpen(true);
    } else if (device === "mobile" && touched) {
      setOpen(false);
    } else if (selectionMode === "default-values" && device === "mobile" && !touched) {
      setOpen(true);
    } else if (selectionMode === "step-by-step") {
      const firstUntouchedIndex = filteredAttributes.findIndex(_ref276 => {
        let {
          name,
          defaultValue
        } = _ref276;
        return !touchedAttributes.includes(name) && !defaultValue;
      });
      const nextToOpen = attributeIndex === firstUntouchedIndex;
      if ((groupAttribute === null || groupAttribute === void 0 ? void 0 : groupAttribute.type) === "group") {
        if (nextToOpen) {
          setOpen(true);
        } else if (!groupAttribute.attributes.every(_ref277 => {
          let {
            name
          } = _ref277;
          return selection[name];
        }) && touched) {
          setOpen(true);
        } else {
          setOpen(false);
        }
      } else {
        setOpen(nextToOpen);
      }
    }
  }, [JSON.stringify(touchedAttributes), touched, device, panelName, openPanel, attributeIndex]);
  return {
    open,
    setOpen
  };
};

// src/hooks/useSelectorAttribute.ts
import { useContext as useContext2 } from "react";

// src/contexts/VatModeContext.tsx
import { createContext as createContext2, useEffect as useEffect2, useMemo, useState as useState2 } from "react";
import { useConsent } from "@printdeal/consent-management/react";
import { jsx as jsx3 } from "react/jsx-runtime";
var STORAGE_KEY2 = "vatMode";
var VatModeContext = createContext2({
  vatMode: "totalNet",
  vatModeFromUrl: void 0,
  setVatMode: () => {}
});
var getVatModeFromUrl = () => {
  if (typeof window === "undefined") return void 0;
  const url = window.location.href;
  const location = new URL(url);
  const vatUrlValue = location.searchParams.get("vat");
  if (vatUrlValue === "excl") return "totalNet";
  if (vatUrlValue === "incl") return "totalGross";
  return void 0;
};
var VatModeProvider = _ref278 => {
  let {
    children
  } = _ref278;
  const vatModeFromUrl = getVatModeFromUrl();
  const consent = useConsent();
  const vatModeFromLocalStorage = getFromLocalStorage(STORAGE_KEY2);
  const [vatMode, setVatMode] = useState2(vatModeFromUrl || vatModeFromLocalStorage || "totalNet");
  useEffect2(() => {
    if (consent.preferences) {
      saveToLocalStorage(STORAGE_KEY2, vatMode);
    }
  }, [vatMode, consent.preferences]);
  const vatModeContext = useMemo(() => ({
    vatMode,
    vatModeFromUrl,
    setVatMode
  }), [vatMode]);
  return /* @__PURE__ */jsx3(VatModeContext.Provider, {
    value: vatModeContext,
    children
  });
};

// src/helpers/range.ts
var calculateRange = (attributeKey, remainingOptionsPerGroup, configurationAttribute) => {
  const resolvedNumericAttribute = getResolvedNumericAttributeFromGroup(remainingOptionsPerGroup, attributeKey);
  const ranges = (resolvedNumericAttribute === null || resolvedNumericAttribute === void 0 ? void 0 : resolvedNumericAttribute.values.reduce((items, item) => {
    if (item.type === "range") {
      items.push(item.range);
    } else {
      items.push({
        minimum: Number(item.numberLiteral),
        maximum: Number(item.numberLiteral),
        increment: Number(item.numberLiteral)
      });
    }
    return items;
  }, [])) || (configurationAttribute === null || configurationAttribute === void 0 ? void 0 : configurationAttribute.range);
  return ranges === null || ranges === void 0 ? void 0 : ranges.reduce((activeRange, currentRange) => {
    if (!Object.keys(activeRange).length) {
      return currentRange;
    }
    if (activeRange.minimum > currentRange.minimum) {
      return _objectSpread(_objectSpread({}, activeRange), {}, {
        minimum: currentRange.minimum
      });
    }
    if (activeRange.maximum < currentRange.maximum) {
      return _objectSpread(_objectSpread({}, activeRange), {}, {
        maximum: currentRange.maximum
      });
    }
    return activeRange;
  }, {});
};
var isRangeValid = (attributeKey, remainingOptionsPerGroup, value) => {
  const resolvedNumericAttribute = getResolvedNumericAttributeFromGroup(remainingOptionsPerGroup, attributeKey);
  if (!(resolvedNumericAttribute !== null && resolvedNumericAttribute !== void 0 && resolvedNumericAttribute.values)) {
    return true;
  }
  return resolvedNumericAttribute.values.some(item => {
    if (value && item.type === "range") {
      const allowDecimals = item.range.increment - Math.floor(item.range.increment) !== 0;
      const isDecimalValue = value - Math.floor(value) !== 0;
      const {
        increment,
        maximum,
        minimum
      } = item.range;
      const isIncrementInteger = increment === Math.floor(increment);
      const isValueInValidRange = value >= minimum && value <= maximum;
      const isDecimalAllowed = allowDecimals || !isDecimalValue;
      const isIncrementValid = !isIncrementInteger || value % increment === 0;
      return isValueInValidRange && isIncrementValid && isDecimalAllowed;
    }
    if (value && item.type === "numberLiteral") {
      return Number(item.numberLiteral) === value;
    }
    return true;
  });
};

// src/hooks/useSelectorAttribute.ts
var useSelectorAttribute = (configurationAttribute, contentAttribute) => {
  const {
    vatMode
  } = useContext2(VatModeContext);
  const remainingOptionsPerGroup = useSelectorMachineContext(state => state.context.remainingOptionsPerGroup);
  const alternativePrices = useSelectorMachineContext(state => state.context.alternativePrices);
  const pivotPrices = useSelectorMachineContext(state => state.context.pivotPrices);
  const currentSelection = useSelectorMachineContext(state => state.context.selection);
  const send = useSelectorMachineSend();
  const getGrid = () => {
    const {
      grid
    } = configurationAttribute;
    if (grid && grid.invalidValuesVisibility === "hidden") {
      var _grid$row$values, _grid$column$values;
      return _objectSpread(_objectSpread({}, grid), {}, {
        row: _objectSpread(_objectSpread({}, grid.row), {}, {
          values: (_grid$row$values = grid.row.values) === null || _grid$row$values === void 0 ? void 0 : _grid$row$values.filter(rowValue => hasResolvedValue(remainingOptionsPerGroup, grid.row.name, rowValue.name))
        }),
        column: _objectSpread(_objectSpread({}, grid.column), {}, {
          values: (_grid$column$values = grid.column.values) === null || _grid$column$values === void 0 ? void 0 : _grid$column$values.filter(columnValue => hasResolvedValue(remainingOptionsPerGroup, grid.column.name, columnValue.name))
        })
      });
    }
    return grid;
  };
  const generateValues = function () {
    let attributeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : configurationAttribute.name;
    const resolvedNumericAttribute = getResolvedNumericAttributeFromGroup(remainingOptionsPerGroup, attributeKey);
    if (!(resolvedNumericAttribute !== null && resolvedNumericAttribute !== void 0 && resolvedNumericAttribute.values)) {
      return void 0;
    }
    const values = resolvedNumericAttribute.values.flatMap(item => {
      if (item.type === "range") {
        return createNumberArrayFromRange(item.range);
      }
      return [Number(item.numberLiteral)];
    });
    const deduplicateValues = [...new Set(values)];
    const sortedValues = deduplicateValues.sort((a, b) => a - b);
    return sortedValues;
  };
  const calculateRangeWrapper = function () {
    let attributeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : configurationAttribute.name;
    return calculateRange(attributeKey, remainingOptionsPerGroup, configurationAttribute);
  };
  const isRangeValidWrapper = function () {
    let attributeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : configurationAttribute.name;
    let value = arguments.length > 1 ? arguments[1] : undefined;
    return isRangeValid(attributeKey, remainingOptionsPerGroup, value);
  };
  const isValid = function (attributeName, valueName) {
    let type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "lov";
    let currentAttributeOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : remainingOptionsPerGroup;
    if (!currentAttributeOptions.length) {
      return true;
    }
    if (type === "lor") {
      return isRangeValidWrapper(attributeName, Number(valueName));
    }
    const valid = hasResolvedValue(currentAttributeOptions, attributeName, valueName);
    return valid;
  };
  const selectAttribute = params => {
    if (params.selectionType === "attribute") {
      var _params$shouldValidat;
      send({
        type: "Select attribute value",
        attributeSelection: {
          name: configurationAttribute.name,
          value: params.attributeValueName
        },
        shouldValidate: (_params$shouldValidat = params.shouldValidate) !== null && _params$shouldValidat !== void 0 ? _params$shouldValidat : true,
        valid: isValid(configurationAttribute.name, params.attributeValueName, params.type)
      });
      dispatchDataLayerEntry("selector", "click", {
        "element-type": configurationAttribute.template,
        "element-content": "attribute_value",
        "attribute-name": configurationAttribute.name,
        "attribute-value": params.attributeValueName
      });
    }
    if (params.selectionType === "attributeGroup") {
      var _params$shouldValidat2;
      send({
        type: "Select attribute value",
        groupedAttributes: params.groupedAttributes,
        shouldValidate: (_params$shouldValidat2 = params.shouldValidate) !== null && _params$shouldValidat2 !== void 0 ? _params$shouldValidat2 : true,
        valid: true,
        groupName: params.groupName
      });
      dispatchDataLayerEntry("grouped_attribute_confirm", "click", {
        "element-type": "button",
        "element-content": "grouped_attribute_confirm_click",
        "attribute-name": configurationAttribute.name,
        "attribute-value": Object.keys(params.groupedAttributes)
      });
    }
    if (params.selectionType === "group") {
      send({
        type: "Select attribute value",
        groupSelection: params.groupSelection,
        shouldValidate: params.shouldValidate || true,
        valid: true
      });
    }
  };
  const getExtraCosts = attributeValue => {
    if (Object.keys(pivotPrices).length) {
      var _pivotPrices$attribut, _price$vatMode$centAm;
      const attributeKey = configurationAttribute.name === "Delivery Type" ? "EdoId" : configurationAttribute.name;
      const pivot = attributeValue.name;
      const price = (_pivotPrices$attribut = pivotPrices[attributeKey]) === null || _pivotPrices$attribut === void 0 ? void 0 : _pivotPrices$attribut[pivot];
      return Number((_price$vatMode$centAm = price === null || price === void 0 ? void 0 : price[vatMode].centAmount) !== null && _price$vatMode$centAm !== void 0 ? _price$vatMode$centAm : 0);
    }
    const prices = alternativePrices.filter(price => Object.keys(price).find(key => {
      var _configurationAttribu;
      return (_configurationAttribu = configurationAttribute.values) === null || _configurationAttribu === void 0 ? void 0 : _configurationAttribu.find(value => value.name === key);
    }));
    const alternativePriceLength = prices.flatMap(price => Object.values(price).filter(value => value !== void 0)).length;
    if (alternativePriceLength < 2) {
      return void 0;
    }
    const extraCostPrice = alternativePrices.find(price => price[attributeValue.name]);
    if (extraCostPrice !== void 0) {
      return extraCostPrice[attributeValue.name];
    }
    return 0;
  };
  const getAttributeValue3 = attributeValue => {
    var _contentAttribute$val;
    return {
      attributeValue: contentAttribute === null || contentAttribute === void 0 || (_contentAttribute$val = contentAttribute.values) === null || _contentAttribute$val === void 0 ? void 0 : _contentAttribute$val.find(_ref279 => {
        let {
          pimAttributeValue
        } = _ref279;
        return pimAttributeValue === attributeValue.name;
      }),
      valid: isValid(configurationAttribute.name, attributeValue.name),
      extraCosts: getExtraCosts(attributeValue)
    };
  };
  const getAttributeValues = () => {
    var _configurationAttribu2;
    const mappedValues = (_configurationAttribu2 = configurationAttribute.values) === null || _configurationAttribu2 === void 0 ? void 0 : _configurationAttribu2.map(selectorAttributeValue => {
      const {
        valid,
        extraCosts,
        attributeValue
      } = getAttributeValue3(selectorAttributeValue);
      return {
        selectorAttributeValue,
        productAttributeValue: attributeValue,
        valid,
        extraCosts
      };
    });
    const attributeValues2 = mappedValues === null || mappedValues === void 0 ? void 0 : mappedValues.filter(value => {
      const rule = value.selectorAttributeValue.conditionalAttributeValueRules ? JSON.parse(value.selectorAttributeValue.conditionalAttributeValueRules) : "";
      const hasAppliedRule = applyLogic(rule, currentSelection);
      if (!value.selectorAttributeValue.enabled && !hasAppliedRule) {
        return false;
      }
      if (configurationAttribute.invalidValuesVisibility === "hidden" && !value.valid) {
        return false;
      }
      return true;
    });
    return attributeValues2 !== null && attributeValues2 !== void 0 ? attributeValues2 : [];
  };
  const isPricePivot = pricePivotAttributes.includes(configurationAttribute.name);
  const attributeValues = getAttributeValues();
  const selectedValue = currentSelection[configurationAttribute.name];
  return {
    generateValues,
    calculateRange: calculateRangeWrapper,
    isRangeValid: isRangeValidWrapper,
    selectAttribute,
    getAttributeValue: getAttributeValue3,
    isPricePivot,
    attributeValues,
    selectedValue,
    getGrid,
    contentAttribute
  };
};

// src/helpers/slug.ts
var slugify = string => string.toString().trim().toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/_+/g, "-").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");

// src/components/selector/attribute-templates/QuantityGrid.tsx
import { useEffect as useEffect7, useState as useState7 } from "react";
import { dequal as isEqual2 } from "dequal/lite";
import { FormattedMessage as FormattedMessage4 } from "react-intl";
import { Button, LinkAsButton, Table as Table2, Alert as Alert2 } from "@printdeal/ui-library";
import { addDataLayerEntry as addDataLayerEntry2 } from "@printdeal/data-layer-manager";
import { configurationProvider as configurationProvider9 } from "@printdeal/configuration";

// src/components/selector/SizeTableModal.tsx
import { FormattedMessage, useIntl } from "react-intl";
import { Alert, Modal, RichText, Spinner } from "@printdeal/ui-library";
import { Suspense, lazy, useState as useState3 } from "react";

// src/hooks/content/useSizeTableContent.ts
import { useQuery } from "@tanstack/react-query";
var useSizeTableContent = settings => {
  const {
    productPageId,
    locale,
    enabled = true
  } = settings;
  return useQuery({
    queryKey: ["supportArticle", productPageId, locale],
    queryFn: async () => contentfulClient.getSizeTableContent(productPageId, locale),
    enabled: enabled && Boolean(productPageId)
  });
};

// src/components/selector/SizeTableModal.tsx
import { Fragment, jsx as jsx4, jsxs } from "react/jsx-runtime";
var Markdown = lazy(() => import("@printdeal/markdown/react").then(module => ({
  default: module.Markdown
})));
var SizeTableFormId = "size-table-form";
var SizeTableModal = _ref280 => {
  let {
    productPageId
  } = _ref280;
  const intl = useIntl();
  const {
    locale
  } = intl;
  const [show, setShow] = useState3(false);
  const {
    data: sizeTable,
    status
  } = useSizeTableContent({
    productPageId,
    locale,
    enabled: show
  });
  const onSubmit = event => {
    event.preventDefault();
    setShow(true);
  };
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx4("form", {
      id: SizeTableFormId,
      "data-testid": SizeTableFormId,
      onSubmit
    }), /* @__PURE__ */jsxs(Modal, {
      title: intl.formatMessage({
        id: "selector.product.sizetable.modal.title",
        defaultMessage: "Size table"
      }),
      isOpen: show,
      onClose: () => setShow(false),
      size: "lg",
      dismissLabel: intl.formatMessage({
        id: "general.alert.dismiss",
        defaultMessage: "Dismiss"
      }),
      children: [status === "pending" && /* @__PURE__ */jsx4(Modal.Content, {
        "data-testid": "spinner",
        className: "pd:flex pd:h-96 pd:items-center pd:justify-center",
        children: /* @__PURE__ */jsx4(Spinner, {
          screenReaderLabel: intl.formatMessage({
            id: "selector.sizetable.modal.content.loading",
            defaultMessage: "Loading..."
          })
        })
      }), status === "success" && /* @__PURE__ */jsx4(Modal.Content, {
        className: "pd:p-4",
        children: sizeTable !== null && sizeTable !== void 0 && sizeTable.content ? /* @__PURE__ */jsx4(Suspense, {
          fallback: /* @__PURE__ */jsx4(Spinner, {
            screenReaderLabel: intl.formatMessage({
              id: "selector.sizetable.modal.content.loading",
              defaultMessage: "Loading..."
            })
          }),
          children: /* @__PURE__ */jsx4(RichText, {
            as: Markdown,
            children: sizeTable.content
          })
        }) : /* @__PURE__ */jsx4(Alert, {
          variant: "warning",
          children: /* @__PURE__ */jsx4(FormattedMessage, {
            id: "selector.product.sizetable.not.found",
            defaultMessage: "The does not seem to be a size table available for this product"
          })
        })
      })]
    })]
  });
};
var SizeTableModal_default = SizeTableModal;

// src/components/selector/attribute-templates/GridInput.tsx
import { useEffect as useEffect5, useState as useState5 } from "react";
import { Table, TextField, TextInput } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage3, useIntl as useIntl2 } from "react-intl";
import { dequal as isEqual } from "dequal/lite";
import { klona as cloneDeep } from "klona/lite";
import cx, { clsx } from "clsx";
import { configurationProvider as configurationProvider7 } from "@printdeal/configuration";

// src/components/selector/InventoryInfo.tsx
import { FormattedDate, FormattedMessage as FormattedMessage2 } from "react-intl";
import { Fragment as Fragment2, jsx as jsx5, jsxs as jsxs2 } from "react/jsx-runtime";
var InventoryInfo = _ref281 => {
  let {
    availability,
    range
  } = _ref281;
  return /* @__PURE__ */jsxs2(Fragment2, {
    children: [availability && range && availability.firstAvailable.inventory > range.maximum && /* @__PURE__ */jsx5("div", {
      className: "pd:mt-2 pd:text-xs pd:text-dim-600",
      children: /* @__PURE__ */jsx5(FormattedMessage2, {
        id: "selector.quantityGrid.firstavailable",
        values: {
          quantity: range.maximum
        },
        defaultMessage: "{quantity} pcs directly available"
      })
    }), availability && range && availability.firstAvailable.inventory < range.maximum && /* @__PURE__ */jsxs2(Fragment2, {
      children: [/* @__PURE__ */jsx5("div", {
        className: "pd:mt-2 pd:text-xs pd:text-dim-600",
        children: /* @__PURE__ */jsx5(FormattedMessage2, {
          id: "selector.quantityGrid.firstavailable",
          values: {
            quantity: availability.firstAvailable.inventory
          },
          defaultMessage: "{quantity} pcs directly available"
        })
      }), availability.nextAvailable && /* @__PURE__ */jsx5("div", {
        className: "pd:text-xs pd:text-dim-600",
        children: /* @__PURE__ */jsx5(FormattedMessage2, {
          id: "selector.quantityGrid.nextavailable",
          values: {
            quantity: availability.nextAvailable.inventory > range.maximum ? range.maximum : availability.nextAvailable.inventory,
            date: /* @__PURE__ */jsx5(FormattedDate, {
              value: availability.nextAvailable.date
            })
          },
          defaultMessage: "{quantity} pcs available on {date}"
        })
      })]
    })]
  });
};
var InventoryInfo_default = InventoryInfo;

// src/hooks/content/useSelectorContentById.ts
import { useQuery as useQuery2 } from "@tanstack/react-query";
var useSelectorContentById = settings => {
  const {
    selectorId,
    locale,
    enabled = true
  } = settings;
  return useQuery2({
    queryKey: ["selectorContent", selectorId, locale],
    queryFn: async () => contentfulClient.getSelectorContent(selectorId, locale),
    enabled: enabled && Boolean(selectorId)
  });
};

// src/hooks/content/useSelectorContentByPageId.ts
import { useQuery as useQuery3 } from "@tanstack/react-query";
import { useGetExperiment } from "@printdeal/feature-management/react";
var useSelectorContentByPageId = settings => {
  const {
    productPageId,
    locale,
    enabled = true
  } = settings;
  const getExperiment = useGetExperiment();
  return useQuery3({
    queryKey: ["productContent", productPageId, locale],
    queryFn: () => contentfulClient.getProductPageContent({
      productPageId,
      locale,
      getExperiment
    }),
    enabled: enabled && Boolean(productPageId)
  });
};

// src/hooks/content/useNewSelector.ts
import { useQuery as useQuery4 } from "@tanstack/react-query";
var useNewSelector = settings => {
  const {
    productPageId,
    locale,
    enabled = true
  } = settings;
  return useQuery4({
    queryKey: ["useNewSelector", productPageId, locale],
    queryFn: async () => contentfulClient.getUseNewSelector(productPageId, locale),
    enabled: enabled && Boolean(productPageId)
  });
};

// src/hooks/useSelectorState.ts
import { useEffect as useEffect3, useState as useState4 } from "react";
var useSelectorState = () => {
  const [status, setStatus] = useState4("loading");
  const isMachineErroring = useSelectorMachineContext(state => state.matches({
    STARTED: "ERRORING"
  }));
  const isPricesErroring = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "ERRORING"
      }
    }
  }));
  const isServicePricesErroring = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        "SERVICE PRICES": "ERRORING"
      }
    }
  }));
  const isErroring = isMachineErroring || isPricesErroring || isServicePricesErroring;
  const isLoadingPrices = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "FETCHING PRICES"
      }
    }
  }));
  const isLoadingPivotPrices = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        "PIVOT PRICES": "FETCHING PIVOT PRICES"
      }
    }
  }));
  const isLoadingServicePrices = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        "SERVICE PRICES": "FETCHING SERVICE PRICES"
      }
    }
  }));
  const isLoadingArrivalDates = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        "ARRIVAL DATES": "FETCHING ARRIVAL DATES"
      }
    }
  }));
  const isLoadingMerchantRules = useSelectorMachineContext(state => state.matches({
    STARTED: "FETCHING MERCHANT RULES"
  }));
  const isValidating = useSelectorMachineContext(state => state.matches({
    STARTED: "VALIDATING"
  }));
  const isLoading = isLoadingPrices || isLoadingPivotPrices || isLoadingServicePrices || isLoadingArrivalDates || isLoadingMerchantRules || isValidating;
  const isIdle = !isErroring && !isLoading;
  useEffect3(() => {
    if (isIdle) {
      setStatus("idle");
    } else if (isLoading) {
      setStatus("loading");
    } else if (isErroring) {
      setStatus("error");
    }
  }, [isErroring, isLoading, isIdle]);
  return status;
};
var useMatchesState = condition => useSelectorMachineContext(state => state.matches(condition));

// src/hooks/useSyncSelectionToUrl.ts
import { useEffect as useEffect4 } from "react";
import { selectionToQueryParameter } from "@printdeal/product-code";
var useSyncSelectionToUrl = () => {
  const url = getCurrentUrl();
  const touchedAttributes = useSelectorMachineContext(state => state.context.touchedAttributes);
  const selection = useSelectorMachineContext(state => state.context.selection);
  const totalQuantity = useSelectorMachineContext(state => state.context.totalQuantity);
  const selectedDeliveryOption = useSelectorMachineContext(state => state.context.selectedDeliveryOption);
  const groupSelection = useSelectorMachineContext(state => state.context.group);
  const attributes = useSelectorMachineContext(state => {
    var _state$context$produc;
    return (_state$context$produc = state.context.product) === null || _state$context$produc === void 0 ? void 0 : _state$context$produc.attributes;
  });
  const isStarted = useSelectorMachineContext(state => state.matches("STARTED"));
  useEffect4(() => {
    if (!isStarted || !attributes) return;
    const urlSelection = getSelectionFromUrl(url, attributes);
    if ((touchedAttributes.length || urlSelection) && Object.keys(selection).length > 0) {
      try {
        const selectionQueryParameter = selectionToQueryParameter(selection);
        if (selectionQueryParameter.length > 0) {
          setUrlParameters({
            selectionParameter: selectionQueryParameter
          });
        }
      } catch (_unused) {}
    } else {
      deleteSearchParameter("selection");
    }
  }, [JSON.stringify(selection), isStarted]);
  useEffect4(() => {
    if (!isStarted || !attributes) return;
    const urlSelection = getSelectionFromUrl(url, attributes);
    if ((touchedAttributes.length || urlSelection) && groupSelection.length > 0) {
      const group = groupSelection.filter(entry => entry.quantity > 0).map(entry => _objectSpread(_objectSpread({}, entry.attributes), {}, {
        quantity: entry.quantity
      }));
      if (group.length > 0) {
        setUrlParameters({
          comboSelectionParameter: encodeURIComponent(JSON.stringify(group))
        });
      }
    } else {
      deleteSearchParameter("comboSelection");
    }
  }, [JSON.stringify(groupSelection), isStarted]);
  useEffect4(() => {
    if (!isStarted || !attributes) return;
    const quantityParam = getParamFromUrl(url, "quantity");
    const deliveryOptionIdParam = getParamFromUrl(url, "deliveryOptionId");
    if ((touchedAttributes.length || quantityParam || deliveryOptionIdParam) && (totalQuantity || selectedDeliveryOption.id)) {
      try {
        if (totalQuantity) {
          setUrlParameters({
            quantityParameter: String(totalQuantity)
          });
        }
        if (selectedDeliveryOption.id) {
          setUrlParameters({
            deliveryOptionIdParameter: selectedDeliveryOption.id
          });
        }
      } catch (_unused2) {}
    } else {
      deleteSearchParameter("quantity");
      deleteSearchParameter("deliveryOptionId");
    }
  }, [totalQuantity, JSON.stringify(selectedDeliveryOption), isStarted]);
};

// src/components/selector/attribute-templates/GridInput.tsx
import { jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
var getGroupIndex = (groupSelection, group) => groupSelection.findIndex(_ref282 => {
  let {
    attributes
  } = _ref282;
  return isEqual(group.attributes, attributes);
});
var updateGroup = (groupSelection, group) => {
  const groupIndex = getGroupIndex(groupSelection, group);
  if (group.quantity === 0) {
    const clonedGroup = cloneDeep(groupSelection);
    clonedGroup.splice(groupIndex, 1);
    return clonedGroup;
  }
  if (groupIndex !== -1) {
    const clonedGroup = cloneDeep(groupSelection);
    clonedGroup[groupIndex] = group;
    return clonedGroup;
  }
  return [...groupSelection, group];
};
var GridInput = _ref283 => {
  let {
    columnValue,
    rowValue,
    grid,
    groupSelection,
    setGroupSelection,
    calculateRange: calculateRange2,
    isRangeValid: isRangeValid2,
    setAvailability,
    className
  } = _ref283;
  const intl = useIntl2();
  const isImpressto = configurationProvider7.getValue("STORE_KEY") === "impressto-fr";
  const inventory = useSelectorMachineContext(state => state.context.inventory);
  const remainingOptionsPerGroup = useSelectorMachineContext(state => state.context.remainingOptionsPerGroup);
  const {
    row,
    column
  } = grid;
  const [showInventory, setShowInventory] = useState5(false);
  const inventoryInfo = inventory === null || inventory === void 0 ? void 0 : inventory.find(_ref284 => {
    let {
      groupAttribute: inventoryAttribute
    } = _ref284;
    return inventoryAttribute === null || inventoryAttribute === void 0 ? void 0 : inventoryAttribute.every(_ref285 => {
      let {
        value
      } = _ref285;
      return value === columnValue.name || value === rowValue.name;
    });
  });
  const groupAttribute = groupSelection.find(_ref286 => {
    let {
      attributes
    } = _ref286;
    return attributes[row.name] === rowValue.name && attributes[column.name] === columnValue.name;
  });
  const {
    quantity
  } = groupAttribute || {
    quantity: 0
  };
  const valid = isGridCellValid({
    name: row.name,
    value: rowValue.name
  }, {
    name: column.name,
    value: columnValue.name
  }, remainingOptionsPerGroup);
  const range = calculateRange2("Quantity");
  const shouldValidateRange = range && range.minimum === range.maximum;
  const rangeIsValid = shouldValidateRange ? isRangeValid2("Quantity", quantity) : true;
  const minimum = range !== null && range !== void 0 && range.minimum && range.minimum > 1 ? range.minimum : 0;
  const isInputValid = Boolean(quantity === 0 || !range || quantity >= range.minimum && quantity <= range.maximum);
  const Group2 = isImpressto ? "div" : Table.Td;
  const Input2 = isImpressto ? TextInput : TextField;
  useEffect5(() => {
    if (isImpressto) {
      if (showInventory && setAvailability) {
        setAvailability(inventoryInfo === null || inventoryInfo === void 0 ? void 0 : inventoryInfo.availability);
      } else if (!showInventory && setAvailability) {
        setAvailability(void 0);
      }
    }
  }, [showInventory]);
  if (!valid && grid.invalidValuesVisibility === "hidden") {
    return /* @__PURE__ */jsx6(Table.Td, {
      className: "pd:border pd:border-dim-200 pd:p-4"
    }, columnValue.name);
  }
  return /* @__PURE__ */jsxs3(Group2, {
    className: clsx("pd:relative", className),
    children: [isImpressto && (!rangeIsValid || !isInputValid) &&
    // TODO: use proper Tooltip component
    // (https://styleguide.printdeal.cloud/packages/ui-library/7.19.0/?path=/docs/components-tooltip--docs)
    /* @__PURE__ */
    jsx6("div", {
      role: "tooltip",
      id: "tooltip-".concat(slugify(columnValue.name), "-").concat(slugify(rowValue.name)),
      className: "pd:tooltip__message--top pd:absolute pd:z-10 pd:block pd:h-auto pd:w-max pd:max-w-sm pd:overflow-visible pd:whitespace-normal pd:rounded pd:bg-dark pd:p-3 pd:text-center pd:text-sm pd:text-white pd:opacity-100",
      children: /* @__PURE__ */jsx6("span", {
        "data-cy": "max-quantity-error",
        children: /* @__PURE__ */jsx6(FormattedMessage3, {
          id: "selector.quantityGrid.maxQuantity",
          values: {
            maxQuantity: range === null || range === void 0 ? void 0 : range.maximum
          },
          defaultMessage: "Max {maxQuantity} pcs"
        })
      })
    }), /* @__PURE__ */jsx6(Input2, {
      type: "number",
      className: cx("pd:w-full ".concat(quantity > 0 ? "pd:text-dim-800" : "pd:text-dim-600")),
      "aria-describedby": isImpressto ? "tooltip-".concat(slugify(columnValue.name), "-").concat(slugify(rowValue.name)) : void 0,
      disabled: !valid,
      name: "".concat(columnValue.name, "-").concat(rowValue.name),
      id: "".concat(slugify(columnValue.name), "-").concat(slugify(rowValue.name)),
      "data-testid": "".concat(columnValue.name, "-").concat(rowValue.name),
      value: quantity > 0 ? quantity : "",
      onFocus: () => setShowInventory(true),
      onBlur: () => setShowInventory(false),
      suffix: !isImpressto ? intl.formatMessage({
        id: "selector.quantity.pieces",
        defaultMessage: "{quantity, plural, =0 {pc.} =1 {pc.} other {pcs.}}"
      }, {
        quantity
      }) : void 0,
      min: shouldValidateRange ? minimum : 0,
      max: shouldValidateRange ? range.maximum : void 0,
      onChange: event => setGroupSelection(updateGroup(groupSelection, {
        attributes: {
          [row.name]: rowValue.name,
          [column.name]: columnValue.name
        },
        quantity: Number(event.target.value),
        isValid: valid
      })),
      onWheel: event => {
        event.currentTarget.blur();
      },
      validation: !rangeIsValid || !isInputValid ? "error" : void 0,
      validationMessage: !isImpressto && (!rangeIsValid || !isInputValid) ? /* @__PURE__ */jsx6("span", {
        "data-cy": "max-quantity-error",
        children: /* @__PURE__ */jsx6(FormattedMessage3, {
          id: "selector.quantityGrid.maxQuantity",
          values: {
            maxQuantity: range === null || range === void 0 ? void 0 : range.maximum
          },
          defaultMessage: "Max {maxQuantity} pcs"
        })
      }) : void 0
    }), !isImpressto && showInventory && /* @__PURE__ */jsx6(InventoryInfo_default, {
      availability: inventoryInfo === null || inventoryInfo === void 0 ? void 0 : inventoryInfo.availability,
      range
    })]
  }, columnValue.name);
};
var GridInput_default = GridInput;

// src/components/selector/attribute-templates/ColumnGrid.tsx
import { useState as useState6 } from "react";

// src/hooks/useDebouncedSelection.ts
import { useEffect as useEffect6 } from "react";
import debounce from "lodash.debounce";
import { configurationProvider as configurationProvider8 } from "@printdeal/configuration";
var debouncedSelectAttribute = debounce((groupSelection, isRangeValid2, selectAttribute) => {
  const totalQuantity = getTotalQuantity2(groupSelection);
  const isValidRange = isRangeValid2("groupedQuantity", totalQuantity);
  selectAttribute({
    selectionType: "group",
    groupSelection,
    shouldValidate: isValidRange
  });
}, 1500);
var useDebouncedSelection = (groupSelection, isRangeValid2, selectAttribute) => {
  const isImpressto = configurationProvider8.getValue("STORE_KEY") === "impressto-fr";
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  useEffect6(() => {
    if (isImpressto && selectionMode === "default-values") {
      debouncedSelectAttribute(groupSelection, isRangeValid2, selectAttribute);
    }
    return () => {
      debouncedSelectAttribute.cancel();
    };
  }, [isImpressto, groupSelection]);
};

// src/components/selector/attribute-templates/ColumnGrid.tsx
import { jsx as jsx7, jsxs as jsxs4 } from "react/jsx-runtime";
var ColumnGrid = _ref287 => {
  var _columnProductAttribu, _row$values2;
  let {
    attribute,
    productAttributes,
    column,
    groupSelection,
    setGroupSelection
  } = _ref287;
  const [availability, setAvailability] = useState6();
  const productAttribute = getProductAttribute(productAttributes, attribute.name);
  const {
    selectAttribute,
    calculateRange: calculateRange2,
    isRangeValid: isRangeValid2,
    getGrid
  } = useSelectorAttribute(attribute, productAttribute);
  useDebouncedSelection(groupSelection, isRangeValid2, selectAttribute);
  const grid = getGrid();
  if (!grid) {
    return null;
  }
  const {
    row
  } = grid;
  const rowProductAttribute = getProductAttribute(productAttributes, row.name);
  const columnProductAttribute = getProductAttribute(productAttributes, column.name);
  const range = calculateRange2("Quantity");
  return /* @__PURE__ */jsxs4("div", {
    className: "pd:flex pd:flex-col pd:gap-4",
    children: [/* @__PURE__ */jsx7("h3", {
      className: "pd:font-medium pd:text-lg pd:text-dim-800",
      children: (columnProductAttribute === null || columnProductAttribute === void 0 || (_columnProductAttribu = columnProductAttribute.values) === null || _columnProductAttribu === void 0 || (_columnProductAttribu = _columnProductAttribu.find(attributeValue => attributeValue.pimAttributeValue === column.name)) === null || _columnProductAttribu === void 0 ? void 0 : _columnProductAttribu.attributeValueAlias) || column.name
    }), /* @__PURE__ */jsx7("div", {
      className: "pd:grid pd:grid-cols-[repeat(auto-fit,minmax(75px,1fr))] pd:gap-4",
      children: (_row$values2 = row.values) === null || _row$values2 === void 0 ? void 0 : _row$values2.map(rowValue => {
        var _rowProductAttribute$;
        return /* @__PURE__ */jsxs4("div", {
          className: "pd:flex pd:flex-col pd:gap-2",
          children: [/* @__PURE__ */jsx7(GridInput_default, {
            columnValue: column,
            rowValue,
            groupSelection,
            setGroupSelection,
            grid,
            calculateRange: calculateRange2,
            isRangeValid: isRangeValid2,
            setAvailability
          }, rowValue.name), /* @__PURE__ */jsx7("span", {
            className: "pd:font-medium pd:text-center pd:text-sm pd:text-dim-600",
            children: (rowProductAttribute === null || rowProductAttribute === void 0 || (_rowProductAttribute$ = rowProductAttribute.values) === null || _rowProductAttribute$ === void 0 || (_rowProductAttribute$ = _rowProductAttribute$.find(attributeValue => attributeValue.pimAttributeValue === rowValue.name)) === null || _rowProductAttribute$ === void 0 ? void 0 : _rowProductAttribute$.attributeValueAlias) || rowValue.name
          })]
        }, rowValue.name);
      })
    }), /* @__PURE__ */jsx7(InventoryInfo_default, {
      availability,
      range
    })]
  }, column.name);
};

// src/components/selector/attribute-templates/QuantityGrid.tsx
import { jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var QuantityGrid = _ref288 => {
  var _column$values2, _column$values3, _row$values3;
  let {
    attribute,
    productAttributes
  } = _ref288;
  const productAttribute = getProductAttribute(productAttributes, attribute.name);
  const groupSelectionFromMachine = useSelectorMachineContext(state => state.context.group);
  const attributes = useSelectorMachineContext(state => state.context.attributes);
  const currentSelection = useSelectorMachineContext(state => state.context.selection);
  const remainingOptionsPerGroup = useSelectorMachineContext(state => state.context.remainingOptionsPerGroup);
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  const [groupSelection, setGroupSelection] = useState7(groupSelectionFromMachine);
  const {
    selectAttribute,
    calculateRange: calculateRange2,
    isRangeValid: isRangeValid2,
    getGrid
  } = useSelectorAttribute(attribute, productAttribute);
  const grid = getGrid();
  const totalQuantity = getTotalQuantity2(groupSelection);
  const isImpressto = configurationProvider9.getValue("STORE_KEY") === "impressto-fr";
  useEffect7(() => {
    if (!isEqual2(groupSelectionFromMachine, groupSelection)) {
      setGroupSelection(groupSelectionFromMachine);
    }
  }, [groupSelectionFromMachine]);
  useEffect7(() => {
    if (isImpressto && groupSelectionFromMachine.length === 0 && selectionMode === "default-values") {
      const quantityFromSelection = parseInt(currentSelection.groupedQuantity, 10);
      const defaultGroupSelectionForImpressto = getDefaultGroup(attributes, quantityFromSelection, false, remainingOptionsPerGroup, true, "M");
      selectAttribute({
        selectionType: "group",
        groupSelection: defaultGroupSelectionForImpressto,
        shouldValidate: false
      });
    }
  }, [attributes, isImpressto, currentSelection, remainingOptionsPerGroup]);
  if (!grid) {
    return null;
  }
  const {
    row,
    column
  } = grid;
  const rowProductAttribute = getProductAttribute(productAttributes, row.name);
  const columnProductAttribute = getProductAttribute(productAttributes, column.name);
  const submitAmounts = () => {
    const valid = isRangeValid2("groupedQuantity", totalQuantity);
    selectAttribute({
      selectionType: "group",
      groupSelection,
      shouldValidate: valid
    });
  };
  const showConfirmQtyButton = !isImpressto || selectionMode !== "default-values";
  return /* @__PURE__ */jsxs5("section", {
    className: "pd:flex pd:flex-col pd:gap-4 pd:py-2",
    children: [attribute.hasSizesDiffer && /* @__PURE__ */jsx8(Alert2, {
      variant: "dim",
      children: /* @__PURE__ */jsx8(FormattedMessage4, {
        id: "selector.quantityGrid.sizesDiffer",
        defaultMessage: "This product runs small. We recommend that you choose one size larger."
      })
    }), /* @__PURE__ */jsx8(LinkAsButton, {
      type: "submit",
      form: SizeTableFormId,
      onClick: () => addDataLayerEntry2("click-on-view-size-table-button"),
      variant: "secondary",
      iconBefore: "info",
      className: "pd:mb-1",
      children: /* @__PURE__ */jsx8(FormattedMessage4, {
        id: "product.show.sizetable",
        defaultMessage: "Show sizetable"
      })
    }), isImpressto ? /* @__PURE__ */jsx8("div", {
      className: "pd:flex pd:flex-col pd:gap-6",
      children: (_column$values2 = column.values) === null || _column$values2 === void 0 ? void 0 : _column$values2.map(columnValue => /* @__PURE__ */jsx8(ColumnGrid, {
        attribute,
        productAttributes,
        column: columnValue,
        groupSelection,
        setGroupSelection
      }, columnValue.id))
    }) : /* @__PURE__ */jsxs5(Table2, {
      className: "pd:border-collapse",
      children: [/* @__PURE__ */jsx8(Table2.Thead, {
        children: /* @__PURE__ */jsxs5(Table2.Tr, {
          className: "pd:text-right",
          children: [/* @__PURE__ */jsx8(Table2.Th, {
            className: "pd:border pd:border-dim-200"
          }), (_column$values3 = column.values) === null || _column$values3 === void 0 ? void 0 : _column$values3.map(value => {
            var _columnProductAttribu2;
            return /* @__PURE__ */jsx8(Table2.Th, {
              className: "pd:border pd:border-dim-200",
              children: (columnProductAttribute === null || columnProductAttribute === void 0 || (_columnProductAttribu2 = columnProductAttribute.values) === null || _columnProductAttribu2 === void 0 || (_columnProductAttribu2 = _columnProductAttribu2.find(attributeValue => attributeValue.pimAttributeValue === value.name)) === null || _columnProductAttribu2 === void 0 ? void 0 : _columnProductAttribu2.attributeValueAlias) || value.name
            }, value.id);
          })]
        })
      }), /* @__PURE__ */jsx8(Table2.Tbody, {
        children: (_row$values3 = row.values) === null || _row$values3 === void 0 ? void 0 : _row$values3.map(rowValue => {
          var _rowProductAttribute$2, _column$values4;
          return /* @__PURE__ */jsxs5(Table2.Tr, {
            className: "pd:bg-white",
            children: [/* @__PURE__ */jsx8(Table2.Td, {
              className: "pd:border pd:border-dim-200 pd:text-right",
              children: (rowProductAttribute === null || rowProductAttribute === void 0 || (_rowProductAttribute$2 = rowProductAttribute.values) === null || _rowProductAttribute$2 === void 0 || (_rowProductAttribute$2 = _rowProductAttribute$2.find(attributeValue => attributeValue.pimAttributeValue === rowValue.name)) === null || _rowProductAttribute$2 === void 0 ? void 0 : _rowProductAttribute$2.attributeValueAlias) || rowValue.name
            }), (_column$values4 = column.values) === null || _column$values4 === void 0 ? void 0 : _column$values4.map(columnValue => /* @__PURE__ */jsx8(GridInput_default, {
              columnValue,
              rowValue,
              groupSelection,
              setGroupSelection,
              grid,
              calculateRange: calculateRange2,
              isRangeValid: isRangeValid2,
              className: "pd:border pd:border-dim-200"
            }, columnValue.name))]
          }, rowValue.name);
        })
      })]
    }), showConfirmQtyButton && /* @__PURE__ */jsx8("footer", {
      className: "pd:mt-2 pd:flex pd:items-center pd:justify-end",
      children: /* @__PURE__ */jsx8(Button, {
        "data-cy": "submit-quantity",
        onClick: submitAmounts,
        disabled: totalQuantity === 0,
        children: /* @__PURE__ */jsx8(FormattedMessage4, {
          id: "selector.quantity.confirm.amounts",
          defaultMessage: "Confirm amounts"
        })
      })
    })]
  });
};
var QuantityGrid_default = QuantityGrid;

// src/components/selector/attribute-templates/Color.tsx
import { RadioSwatchGroup } from "@printdeal/ui-library";

// src/hooks/useSelectAttribute.ts
import { useRef, useCallback } from "react";
function useKeyboardMouseSelect(selectAttribute) {
  const lastKeyPressedRef = useRef(null);
  const isNavigationKey = useCallback(key => ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(key !== null && key !== void 0 ? key : ""), []);
  const handleKeyDown = useCallback(event => {
    lastKeyPressedRef.current = event.key;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      selectAttribute({
        selectionType: "attribute",
        attributeValueName: event.currentTarget.value
      });
      lastKeyPressedRef.current = null;
    }
  }, [selectAttribute]);
  const handleChange = useCallback(event => {
    const lastKey = lastKeyPressedRef.current;
    if (lastKey === "Enter" || lastKey === " " || isNavigationKey(lastKey)) {
      lastKeyPressedRef.current = null;
      return;
    }
    lastKeyPressedRef.current = null;
    selectAttribute({
      selectionType: "attribute",
      attributeValueName: event.currentTarget.value
    });
  }, [selectAttribute, isNavigationKey]);
  return {
    handleKeyDown,
    handleChange
  };
}

// src/components/selector/attribute-templates/Color.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
var filteredColors = (colors, invalidValuesVisibility) => {
  if (invalidValuesVisibility === "hidden") {
    return colors.filter(_ref289 => {
      let {
        valid
      } = _ref289;
      return valid === true;
    });
  }
  return colors;
};
var Color = _ref290 => {
  let {
    attribute,
    selectorAttribute
  } = _ref290;
  const device = useSelectorMachineContext(state => state.context.device);
  const MAX_VISIBLE_COLORS = device === "mobile" ? 4 : 6;
  const {
    selectAttribute,
    attributeValues,
    selectedValue
  } = selectorAttribute;
  const colors = filteredColors(attributeValues, attribute.invalidValuesVisibility);
  const totalColors = colors.length || 0;
  const {
    handleKeyDown,
    handleChange
  } = useKeyboardMouseSelect(selectAttribute);
  const handleShowAllClick = () => {
    dispatchDataLayerEntry("selector", "click", {
      "element-type": "input",
      "element-content": "show_all_colors"
    });
  };
  if (totalColors > 0) {
    return /* @__PURE__ */jsx9(RadioSwatchGroup, {
      id: slugify(attribute.id),
      name: attribute.name,
      maxItems: MAX_VISIBLE_COLORS,
      moreButton: /* @__PURE__ */jsx9(RadioSwatchGroup.MoreButton, {
        onClick: handleShowAllClick
      }),
      children: colors.map(color => {
        var _productAttributeValu;
        const {
          productAttributeValue,
          selectorAttributeValue
        } = color;
        const checked = selectedValue === selectorAttributeValue.name;
        const title = (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.attributeValueAlias) || (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.pimAttributeValue) || selectorAttributeValue.name;
        return /* @__PURE__ */jsx9(RadioSwatchGroup.Field, {
          id: slugify(selectorAttributeValue.id),
          value: selectorAttributeValue.name,
          onChange: handleChange,
          onKeyDown: handleKeyDown,
          checked,
          label: title,
          image: (productAttributeValue === null || productAttributeValue === void 0 || (_productAttributeValu = productAttributeValue.attributeValueImage) === null || _productAttributeValu === void 0 ? void 0 : _productAttributeValu.url) && /* @__PURE__ */jsx9("img", {
            src: "".concat(productAttributeValue.attributeValueImage.url, "?w=64&h=64&q=70&fm=png"),
            alt: title,
            width: 64,
            loading: "eager"
          })
        }, selectorAttributeValue.id);
      })
    });
  }
  return null;
};
var Color_default = Color;

// src/components/selector/attribute-templates/DeliveryTime.tsx
import cx2 from "clsx";
import { FormattedMessage as FormattedMessage5, useIntl as useIntl5 } from "react-intl";
import { Grid, RadioCard } from "@printdeal/ui-library";

// src/components/prices/Money.tsx
import { useIntl as useIntl3 } from "react-intl";
var Money = _ref291 => {
  let {
    value,
    currency = "EUR",
    showCurrency = true,
    isDiscount = false
  } = _ref291;
  const intl = useIntl3();
  const money = intl.formatNumber(value / 100, {
    currency,
    style: "currency",
    currencyDisplay: showCurrency ? "symbol" : "code"
  });
  if (isDiscount || !showCurrency) {
    return money.replace(currency, "");
  }
  return money;
};

// src/components/selector/ValueLabel.tsx
import { Badge } from "@printdeal/ui-library";
import { defineMessages as defineMessages2, useIntl as useIntl4 } from "react-intl";
import { jsx as jsx10 } from "react/jsx-runtime";
var translations2 = defineMessages2({
  eco: {
    id: "selector.label.eco",
    defaultMessage: "Sustainable"
  },
  cheapest: {
    id: "selector.label.cheapest",
    defaultMessage: "Budget"
  },
  mostchosen: {
    id: "selector.label.mostchosen",
    defaultMessage: "Most chosen"
  },
  new: {
    id: "selector.label.new",
    defaultMessage: "New"
  },
  premium: {
    id: "selector.label.premium",
    defaultMessage: "Premium"
  },
  bestPrice: {
    id: "selector.label.bestPrice",
    defaultMessage: "Best price"
  }
});
var getLabelBadge = label => {
  switch (label.type) {
    case "eco":
      return {
        variant: "success-outline",
        translation: translations2.eco
      };
    case "cheapest":
      return {
        variant: "warning",
        translation: translations2.cheapest
      };
    case "most-chosen":
      return {
        variant: "info-outline",
        translation: translations2.mostchosen
      };
    case "new":
      return {
        variant: "primary",
        translation: translations2.new
      };
    case "premium":
      return {
        variant: "primary",
        translation: translations2.premium
      };
    case "best-price":
      return {
        variant: "primary-outline",
        translation: translations2.bestPrice
      };
    default:
      return null;
  }
};
var ValueLabel = _ref292 => {
  let {
    label
  } = _ref292;
  const intl = useIntl4();
  const labelBadge = getLabelBadge(label);
  if (!labelBadge) {
    return null;
  }
  return /* @__PURE__ */jsx10(Badge, {
    variant: labelBadge.variant,
    children: intl.formatMessage(labelBadge.translation)
  });
};

// src/components/selector/attribute-templates/DeliveryTime.tsx
import { Fragment as Fragment3, jsx as jsx11, jsxs as jsxs6 } from "react/jsx-runtime";
var DeliveryTime = _ref293 => {
  let {
    attribute,
    selectorAttribute
  } = _ref293;
  const {
    invalidValuesVisibility
  } = attribute;
  const arrivalDates = useSelectorMachineContext(state => state.context.arrivalDates);
  const {
    selectAttribute,
    isPricePivot,
    attributeValues,
    selectedValue
  } = selectorAttribute;
  const {
    handleKeyDown,
    handleChange
  } = useKeyboardMouseSelect(selectAttribute);
  const intl = useIntl5();
  const isFaded = invalidValuesVisibility === "faded";
  const isHidden = invalidValuesVisibility === "hidden";
  return /* @__PURE__ */jsx11(Grid, {
    className: "pd:grid-cols-1 pd:gap-4 pd:@xs:grid-cols-2 pd:@md:grid-cols-3 pd:@2xl:grid-cols-4",
    children: attributeValues.map(value => {
      var _arrivalDates$find;
      const {
        selectorAttributeValue,
        productAttributeValue,
        valid,
        extraCosts
      } = value;
      const checked = selectorAttributeValue.name === selectedValue;
      const arrivalDate = (_arrivalDates$find = arrivalDates.find(date => date.deliveryType === selectorAttributeValue.name)) === null || _arrivalDates$find === void 0 ? void 0 : _arrivalDates$find.date;
      const title = (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.attributeValueAlias) || (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.pimAttributeValue) || selectorAttributeValue.name;
      return /* @__PURE__ */jsx11(Grid.Item, {
        children: /* @__PURE__ */jsx11(RadioCard, {
          name: selectorAttributeValue.name,
          id: slugify(selectorAttributeValue.id),
          value: selectorAttributeValue.name,
          checked,
          className: cx2("pd:h-full", {
            "pd:hidden": !valid && (isHidden || !arrivalDate)
          }),
          label: arrivalDate && Date.parse(arrivalDate) ? /* @__PURE__ */jsx11("span", {
            className: "pd:capitalize",
            children: intl.formatDate(arrivalDate, {
              weekday: "long",
              month: "short",
              day: "numeric"
            })
          }) : void 0,
          badge: selectorAttributeValue.label && /* @__PURE__ */jsx11(ValueLabel, {
            label: selectorAttributeValue.label
          }),
          description: /* @__PURE__ */jsx11("p", {
            "data-cy": "".concat(selectorAttributeValue.id, "-description"),
            className: "pd:font-normal",
            children: isPricePivot && extraCosts !== void 0 ? /* @__PURE__ */jsx11("span", {
              children: extraCosts === 0 ? /* @__PURE__ */jsx11("span", {
                className: "pd:text-success-500",
                children: /* @__PURE__ */jsx11(FormattedMessage5, {
                  id: "selector.delivery-time.free-shipping",
                  defaultMessage: "Free"
                })
              }) : /* @__PURE__ */jsxs6(Fragment3, {
                children: [extraCosts >= 0 ? "+ " : "- ", /* @__PURE__ */jsx11(Money, {
                  value: Math.abs(extraCosts),
                  currency: "EUR"
                })]
              })
            }) : /* @__PURE__ */jsx11("span", {
              className: "pd:text-success-500",
              children: /* @__PURE__ */jsx11(FormattedMessage5, {
                id: "selector.delivery-time.free-shipping",
                defaultMessage: "Free"
              })
            })
          }),
          secondaryAction: /* @__PURE__ */jsx11("span", {
            className: "pd:text-md pd:font-normal pd:text-dim-600",
            children: title
          }),
          onChange: handleChange,
          onKeyDown: handleKeyDown,
          validation: !valid && isFaded ? "dim" : void 0,
          validationMessage: !valid && isFaded && /* @__PURE__ */jsx11(FormattedMessage5, {
            id: "product.configurator.notPossibleInCombination",
            defaultMessage: "Not possible in combination"
          })
        })
      }, selectorAttributeValue.id);
    })
  });
};
var DeliveryTime_default = DeliveryTime;

// src/components/selector/attribute-templates/Dropdown.tsx
import { Listbox, ListboxField } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage6 } from "react-intl";

// src/components/selector/attribute-templates/PivotPrice.tsx
import cx3 from "clsx";
import { Fragment as Fragment4, jsx as jsx12, jsxs as jsxs7 } from "react/jsx-runtime";
var PivotPrice = _ref294 => {
  let {
    extraCosts,
    pricesLoading
  } = _ref294;
  if (pricesLoading) return /* @__PURE__ */jsx12("span", {
    children: "\u2014,\u2014\u2014"
  });
  return /* @__PURE__ */jsxs7("span", {
    className: cx3({
      "pd:text-success-500": extraCosts < 0
    }),
    children: [extraCosts >= 0 ? /* @__PURE__ */jsx12(Fragment4, {
      children: " + "
    }) : /* @__PURE__ */jsxs7("span", {
      className: cx3({
        "pd:text-success-500": extraCosts < 0
      }),
      children: [" ", "-", " "]
    }), /* @__PURE__ */jsx12(Money, {
      value: Math.abs(extraCosts),
      currency: "EUR"
    })]
  });
};

// src/components/selector/attribute-templates/Dropdown.tsx
import { jsx as jsx13, jsxs as jsxs8 } from "react/jsx-runtime";
var Dropdown = _ref295 => {
  let {
    attribute,
    selectorAttribute
  } = _ref295;
  const {
    invalidValuesVisibility,
    id,
    name
  } = attribute;
  const {
    selectAttribute,
    attributeValues,
    selectedValue,
    generateValues,
    isRangeValid: isRangeValid2,
    contentAttribute
  } = selectorAttribute;
  const pricesLoading = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "FETCHING PRICES"
      }
    }
  }) || state.matches({
    STARTED: {
      "FETCHING DATA": {
        "PIVOT PRICES": "FETCHING PIVOT PRICES"
      }
    }
  }));
  const pivotPrices = useSelectorMachineContext(state => state.context.pivotPrices);
  const translationKey = slugify(attribute.name || attribute.pimName);
  const message = translationKey && translations[translationKey];
  const handleChange = changedValue => {
    selectAttribute({
      selectionType: "attribute",
      attributeValueName: changedValue,
      type: attribute.type
    });
  };
  const generatedValues = generateValues();
  if (generatedValues !== null && generatedValues !== void 0 && generatedValues.length) {
    return /* @__PURE__ */jsx13(ListboxField, {
      "data-cy": "dropdown-".concat(name),
      name,
      id,
      label: (contentAttribute === null || contentAttribute === void 0 ? void 0 : contentAttribute.attributeAlias) || attribute.name,
      value: selectedValue || "",
      onChange: option => handleChange(option),
      className: "pd:w-full pd:md:w-2/3",
      children: generatedValues.map(value => {
        const valid = isRangeValid2(attribute.name, value);
        return /* @__PURE__ */jsx13(ListboxField.Option, {
          "data-cy": value,
          value: String(value),
          disabled: !valid,
          children: message ? /* @__PURE__ */jsx13(FormattedMessage6, {
            id: message.id,
            defaultMessage: message.defaultMessage,
            values: {
              value
            }
          }) : value
        }, value);
      })
    });
  }
  return /* @__PURE__ */jsx13(Listbox, {
    "data-cy": "dropdown-".concat(name),
    name,
    id,
    value: selectedValue || "",
    onChange: handleChange,
    className: "pd:w-full pd:md:w-2/3",
    children: attributeValues.map(value => {
      var _pivotPrices$name;
      const {
        productAttributeValue,
        selectorAttributeValue,
        valid,
        extraCosts
      } = value;
      const disabled = !valid && invalidValuesVisibility === "hidden";
      const isFaded = invalidValuesVisibility === "faded";
      const title = (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.attributeValueAlias) || (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.pimAttributeValue) || selectorAttributeValue.name;
      const hasPivotPrice = Boolean((_pivotPrices$name = pivotPrices[name]) === null || _pivotPrices$name === void 0 ? void 0 : _pivotPrices$name[selectorAttributeValue.name]);
      return /* @__PURE__ */jsx13(Listbox.Option, {
        "data-cy": title,
        value: selectorAttributeValue.name,
        disabled,
        validation: !valid && isFaded ? "dim" : void 0,
        validationMessage: !valid && isFaded && /* @__PURE__ */jsx13(FormattedMessage6, {
          id: "product.configurator.notPossibleInCombination",
          defaultMessage: "Not possible in combination"
        }),
        children: /* @__PURE__ */jsxs8("div", {
          className: "pd:flex pd:items-center pd:justify-start pd:gap-4",
          children: [/* @__PURE__ */jsx13("span", {
            children: title
          }), hasPivotPrice && extraCosts !== void 0 && /* @__PURE__ */jsx13("span", {
            "data-cy": "".concat(selectorAttributeValue.id, "-description"),
            "data-testid": pricesLoading ? "prices-loading" : "prices-loaded",
            className: "text-gray-600 pd:text-md pd:font-normal",
            children: /* @__PURE__ */jsx13(PivotPrice, {
              extraCosts,
              pricesLoading
            })
          })]
        })
      }, selectorAttributeValue.id);
    })
  });
};
var Dropdown_default = Dropdown;

// src/components/selector/attribute-templates/DatePicker.tsx
import { DatepickerField } from "@printdeal/ui-library";
import { addBusinessDays, differenceInBusinessDays, format } from "date-fns";
import { useCallback as useCallback2, useMemo as useMemo2 } from "react";
import { FormattedMessage as FormattedMessage7 } from "react-intl";
import { jsx as jsx14 } from "react/jsx-runtime";
var convertAttributeValuesToDates = attributeValues => attributeValues.map(_ref296 => {
  let {
    selectorAttributeValue
  } = _ref296;
  return new Date(selectorAttributeValue.name);
});
var today = /* @__PURE__ */new Date();
var bufferDays = 7;
var removeDaysInThePast = dates => dates.filter(date => date > addBusinessDays(today, bufferDays));
var DatePicker = _ref297 => {
  let {
    attribute
  } = _ref297;
  const {
    selectAttribute,
    attributeValues,
    selectedValue
  } = useSelectorAttribute(attribute);
  const allowedDates = useMemo2(() => removeDaysInThePast(convertAttributeValuesToDates(attributeValues).sort((a, b) => a.getTime() - b.getTime())), [today, attributeValues.length]);
  const isAllowed = useCallback2(date => allowedDates.some(allowed => allowed.getFullYear() === date.getFullYear() && allowed.getMonth() === date.getMonth() && allowed.getDate() === date.getDate()), [allowedDates.length]);
  const onDateChange = useCallback2(event => {
    const selectedDate = new Date(event.target.value);
    const workdaysFromToday = differenceInBusinessDays(selectedDate, today);
    const formattedDate = format(selectedDate, "dd MMMM yyyy");
    const groupedAttributes = {
      [attribute.name]: formattedDate,
      "Working Days Until Delivery": String(workdaysFromToday)
    };
    selectAttribute({
      selectionType: "attributeGroup",
      groupedAttributes,
      groupName: attribute.name
    });
  }, [selectAttribute]);
  return /* @__PURE__ */jsx14("div", {
    className: "pd:flex pd:justify-between",
    children: /* @__PURE__ */jsx14(DatepickerField, {
      id: attribute.id,
      datepickerScreenReaderLabel: attribute.name,
      name: attribute.name,
      description: /* @__PURE__ */jsx14(FormattedMessage7, {
        id: "product.configurator.datepicker.description",
        defaultMessage: "The chosen date holds true for +/- 3 days"
      }),
      datepickerConfig: {
        // @ts-expect-error -- Bug in ui library, props are available: https://daypicker.dev/guides/custom-modifiers#disabled-modifier
        disabled: date => !isAllowed(date),
        startMonth: allowedDates[0]
      },
      onChange: onDateChange,
      value: selectedValue
    })
  });
};
var DatePicker_default = DatePicker;

// src/components/selector/attribute-templates/Input.tsx
import { useEffect as useEffect8, useRef as useRef2, useState as useState8 } from "react";
import { FormattedMessage as FormattedMessage8, useIntl as useIntl6 } from "react-intl";
import { Icon, LinkAsButton as LinkAsButton2, TextField as TextField2, ValidationMessage } from "@printdeal/ui-library";
import { configurationProvider as configurationProvider10 } from "@printdeal/configuration";
import cx4 from "clsx";
import { Fragment as Fragment5, jsx as jsx15, jsxs as jsxs9 } from "react/jsx-runtime";
var Input = _ref298 => {
  var _validationAttributes, _productAttribute$att;
  let {
    attribute,
    product,
    isGroup
  } = _ref298;
  const inputRef = useRef2(null);
  const {
    formatMessage
  } = useIntl6();
  const send = useSelectorMachineSend();
  const {
    openPanel
  } = useSelectorMachineContext(state2 => state2.context.panel);
  const touchedSelection = useSelectorMachineContext(state2 => state2.context.touchedAttributes);
  const isReviewPage = useSelectorMachineContext(state2 => state2.context.isReviewPage);
  const selectionMode = useSelectorMachineContext(state2 => state2.context.selectionMode);
  const touched = touchedSelection.includes(attribute.name);
  const defaultValue = Number(attribute.defaultValue) || "";
  const productAttribute = getProductAttribute(product.attributes, attribute.name);
  const validationAttributes = useSelectorMachineContext(state2 => state2.context.productAttributes);
  const state = useSelectorState();
  const unitOfMeasure = (_validationAttributes = validationAttributes.find(_ref299 => {
    let {
      key
    } = _ref299;
    return key === attribute.name;
  })) === null || _validationAttributes === void 0 ? void 0 : _validationAttributes.unitOfMeasure;
  const [value, setValue] = useState8(defaultValue);
  const {
    calculateRange: calculateRange2,
    selectedValue,
    selectAttribute,
    isRangeValid: isRangeValid2
  } = useSelectorAttribute(attribute);
  const range = calculateRange2();
  const isInputValid = isRangeValid2(attribute.name, Number(value));
  const isImpressto = configurationProvider10.getValue("STORE_KEY") === "impressto-fr";
  const shouldShowGrid = attribute.grid && selectionMode === "default-values" && !isImpressto;
  const translatedUnitOfMeasure = unitOfMeasure && formatMessage(translations[unitOfMeasure]);
  const validate = () => {
    if (!isInputValid) {
      return "error";
    }
    if (value && isGroup && (value !== defaultValue || touched)) {
      return "success";
    }
    return void 0;
  };
  const getSuffix = () => {
    if (translatedUnitOfMeasure) {
      return translatedUnitOfMeasure;
    }
    if (!isGroup || !range) {
      return formatMessage({
        id: "selector.quantity.pieces",
        defaultMessage: "{quantity, plural, =0 {pc.} =1 {pc.} other {pcs.}}"
      }, {
        quantity: value
      });
    }
    return "";
  };
  useEffect8(() => {
    setValue(Number(selectedValue) || defaultValue);
  }, [selectedValue, defaultValue, state]);
  useEffect8(() => {
    const inputElement = inputRef.current;
    if (inputElement) {
      const handleWheel = event => {
        event.preventDefault();
      };
      inputElement.addEventListener("wheel", handleWheel, {
        passive: false
      });
      return () => {
        inputElement.removeEventListener("wheel", handleWheel);
      };
    }
    return void 0;
  }, []);
  const handleBlur = event => {
    var _event$relatedTarget;
    const hasSubmitted = ((_event$relatedTarget = event.relatedTarget) === null || _event$relatedTarget === void 0 ? void 0 : _event$relatedTarget.id) === "group-submit-button";
    if (!hasSubmitted && value && isInputValid) {
      selectAttribute({
        selectionType: "attribute",
        attributeValueName: String(value),
        type: "lor"
      });
    }
  };
  const handleGrid = () => {
    send({
      type: "Toggle panel",
      panelName: "groupedQuantity"
    });
    if (!isReviewPage) {
      dispatchDataLayerEntry("selector", "click", {
        "element-type": "button",
        "element-content": "".concat(!openPanel ? "open" : "close", "_quantity_grid")
      });
    }
  };
  const suffix = getSuffix();
  const validationMessage = range && isGroup && /* @__PURE__ */jsx15("span", {
    className: cx4("pd:text-sm", {
      "pd:text-dim-600": isInputValid,
      "pd:text-error-500": !isInputValid
    }),
    children: /* @__PURE__ */jsx15(FormattedMessage8, {
      id: "selector.unitRange.minToMaxAndUnit",
      defaultMessage: "{rangeTotalMin} t/m {rangeTotalMax} {translatedUnitOfMeasure}",
      values: {
        rangeTotalMin: range.minimum,
        rangeTotalMax: range.maximum,
        translatedUnitOfMeasure: translatedUnitOfMeasure || ""
      }
    })
  });
  return /* @__PURE__ */jsxs9(Fragment5, {
    children: [/* @__PURE__ */jsxs9("div", {
      className: cx4("pd:flex", {
        "pd:items-stretch pd:w-full": isGroup
      }, {
        "pd:items-center": !isGroup
      }),
      children: [/* @__PURE__ */jsx15(TextField2, {
        "data-testid": attribute.id,
        ref: inputRef,
        type: "number",
        className: cx4({
          "pd:w-full": isGroup,
          "pd:w-40": !isGroup,
          "pd:hidden": attribute.grid && !shouldShowGrid
        }),
        name: attribute.name,
        id: attribute.id,
        value,
        label: isGroup ? (_productAttribute$att = productAttribute === null || productAttribute === void 0 ? void 0 : productAttribute.attributeAlias) !== null && _productAttribute$att !== void 0 ? _productAttribute$att : "" : "",
        suffix,
        min: range === null || range === void 0 ? void 0 : range.minimum,
        max: range === null || range === void 0 ? void 0 : range.maximum,
        step: range === null || range === void 0 ? void 0 : range.increment,
        onBlur: handleBlur,
        onChange: event => setValue(event.target.value ? Number(event.target.value) : ""),
        validation: validate(),
        validationMessage,
        "data-hj-allow": true
      }), shouldShowGrid && /* @__PURE__ */jsx15(LinkAsButton2, {
        "data-testid": "toggle-qty-grid",
        variant: "secondary",
        className: "pd:ml-3",
        onClick: handleGrid,
        iconBefore: /* @__PURE__ */jsx15(Icon, {
          icon: openPanel ? "minus" : "plus",
          size: "xl"
        }),
        children: openPanel ? /* @__PURE__ */jsx15(FormattedMessage8, {
          id: "selector.hideSizes",
          defaultMessage: "Hide sizes"
        }) : /* @__PURE__ */jsx15(FormattedMessage8, {
          id: "selector.chooseSizes",
          defaultMessage: "Choose sizes"
        })
      })]
    }), /* @__PURE__ */jsx15(ValidationMessage, {
      variant: "error",
      className: "pd:grid pd:py-1 pd:text-sm",
      children: !isInputValid && !isGroup && /* @__PURE__ */jsx15("span", {
        "data-testid": "max-qty-error",
        children: /* @__PURE__ */jsx15(FormattedMessage8, {
          id: "selector.quantity.maxQuantity",
          values: {
            maxQuantity: range === null || range === void 0 ? void 0 : range.maximum,
            minQuantity: range === null || range === void 0 ? void 0 : range.minimum
          },
          defaultMessage: "We handle a minimum of {minQuantity} and a maximum of {maxQuantity} pieces per order for this product selection"
        })
      })
    })]
  });
};
var Input_default = Input;

// src/components/selector/attribute-templates/Radio.tsx
import { useState as useState9 } from "react";
import { FormattedMessage as FormattedMessage10 } from "react-intl";
import cx6 from "clsx";
import { RadioGroup, LinkAsButton as LinkAsButton3 } from "@printdeal/ui-library";

// src/components/selector/SupportArticleModal.tsx
import { Collapsible, Grid as Grid2, Heading, Link, Modal as Modal2, RichText as RichText2, Spinner as Spinner2, Gallery } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage9, useIntl as useIntl8 } from "react-intl";
import { Image, Source } from "@unpic/react";
import { Suspense as Suspense2, lazy as lazy2, useEffect as useEffect9 } from "react";
import cx5 from "clsx";
import { addDataLayerEntry as addDataLayerEntry3 } from "@printdeal/data-layer-manager";
import { ErrorBoundary } from "@printdeal/error-management/react";

// src/hooks/content/useSupportArticleContent.ts
import { useQuery as useQuery5 } from "@tanstack/react-query";
var useSupportArticleContent = settings => {
  const {
    supportArticleId,
    locale,
    enabled = true
  } = settings;
  return useQuery5({
    queryKey: ["supportArticle", supportArticleId, locale],
    queryFn: async () => contentfulClient.getSupportArticleContent(supportArticleId, locale),
    enabled: enabled && Boolean(supportArticleId)
  });
};

// src/hooks/content/useSystemPageContent.ts
import { useQuery as useQuery6 } from "@tanstack/react-query";
var useSystemPageContent = settings => {
  const {
    systemPageType,
    locale,
    enabled = true
  } = settings;
  return useQuery6({
    queryKey: ["systemPage", systemPageType, locale],
    queryFn: async () => contentfulClient.getSystemPageContent(systemPageType, locale),
    enabled: enabled && Boolean(systemPageType)
  });
};

// src/components/ErrorComponent.tsx
import { useIntl as useIntl7 } from "react-intl";
import { jsx as jsx16, jsxs as jsxs10 } from "react/jsx-runtime";
var ErrorComponent = _ref300 => {
  let {
    debugId
  } = _ref300;
  const intl = useIntl7();
  return /* @__PURE__ */jsxs10("div", {
    className: "pd:border-red-500 pd:bg-red-50 pd:text-red-700 pd:rounded-md pd:border pd:p-4",
    children: [/* @__PURE__ */jsx16("p", {
      className: "pd:font-medium",
      children: intl.formatMessage({
        id: "error.component.heading",
        defaultMessage: "We encountered an error"
      })
    }), /* @__PURE__ */jsxs10("p", {
      className: "pd:mt-1 pd:text-sm",
      children: [intl.formatMessage({
        id: "error.component.title",
        defaultMessage: "Please try again later or contact support with this Debug ID:"
      }), debugId]
    })]
  });
};

// src/components/selector/SupportArticleModal.tsx
import { jsx as jsx17, jsxs as jsxs11 } from "react/jsx-runtime";
var Markdown2 = lazy2(() => import("@printdeal/markdown/react").then(module => ({
  default: module.Markdown
})));
var getSupportArticleUrl = (helpCenterSlug, categorySlug, slug, pathLocale) => {
  if (typeof window === "undefined" || !helpCenterSlug || !slug || !pathLocale) return void 0;
  const url = new URL(window.location.origin);
  if (categorySlug) {
    url.pathname = "".concat(pathLocale, "/").concat(helpCenterSlug, "/").concat(categorySlug, "/").concat(slug);
  } else {
    url.pathname = "".concat(pathLocale, "/").concat(helpCenterSlug, "/").concat(slug);
  }
  return url.toString();
};
var SupportArticleModal = _ref301 => {
  var _supportArticle$title, _supportArticle$galle;
  let {
    supportArticleId,
    show,
    onClose
  } = _ref301;
  const intl = useIntl8();
  const {
    locale
  } = intl;
  const {
    data: supportArticle,
    status
  } = useSupportArticleContent({
    supportArticleId,
    locale,
    enabled: show
  });
  const showReadMore = Boolean((supportArticle === null || supportArticle === void 0 ? void 0 : supportArticle.content) && supportArticle.slug);
  const {
    data: systemPage
  } = useSystemPageContent({
    locale,
    systemPageType: "helpCenterIndex",
    enabled: showReadMore && show
  });
  const fullArticleUrl = getSupportArticleUrl(systemPage === null || systemPage === void 0 ? void 0 : systemPage.slug, supportArticle === null || supportArticle === void 0 ? void 0 : supportArticle.categorySlug, supportArticle === null || supportArticle === void 0 ? void 0 : supportArticle.slug, locale.substring(0, 2));
  useEffect9(() => {
    if (show && supportArticleId) {
      addDataLayerEntry3("support-article-open", {
        supportArticleId
      });
    }
    return () => {
      if (show && supportArticleId) {
        addDataLayerEntry3("support-article-close", {
          supportArticleId
        });
      }
    };
  }, []);
  return /* @__PURE__ */jsxs11(Modal2, {
    size: "xl",
    title: (_supportArticle$title = supportArticle === null || supportArticle === void 0 ? void 0 : supportArticle.title) !== null && _supportArticle$title !== void 0 ? _supportArticle$title : intl.formatMessage({
      id: "selector.supportArticle.modal.title.loading",
      defaultMessage: "Loading..."
    }),
    onClose,
    isOpen: show,
    dismissLabel: intl.formatMessage({
      id: "general.alert.dismiss",
      defaultMessage: "Dismiss"
    }),
    children: [status === "pending" && /* @__PURE__ */jsx17(Modal2.Content, {
      className: "pd:flex pd:h-96 pd:items-center pd:justify-center",
      children: /* @__PURE__ */jsx17(Spinner2, {
        screenReaderLabel: intl.formatMessage({
          id: "selector.supportArticle.modal.content.loading",
          defaultMessage: "Loading..."
        })
      })
    }), status === "success" && supportArticle && /* @__PURE__ */jsx17(Modal2.Content, {
      children: /* @__PURE__ */jsx17(ErrorBoundary, {
        as: ErrorComponent,
        children: /* @__PURE__ */jsxs11(Grid2, {
          className: "pd:grid-cols-1 pd:gap-4 pd:lg:grid-cols-5",
          children: [((_supportArticle$galle = supportArticle.gallery) === null || _supportArticle$galle === void 0 ? void 0 : _supportArticle$galle.images.length) && /* @__PURE__ */jsx17(Grid2.Item, {
            className: "pd:col-span-2",
            children: /* @__PURE__ */jsxs11(Gallery, {
              id: supportArticle.gallery.id,
              prevButton: /* @__PURE__ */jsx17(Gallery.Button, {
                variant: "prev",
                screenReaderLabel: "Previous",
                onClick: () => addDataLayerEntry3("support-article-gallery-prev", {
                  supportArticleId
                })
              }),
              nextButton: /* @__PURE__ */jsx17(Gallery.Button, {
                variant: "next",
                screenReaderLabel: "Next",
                onClick: () => addDataLayerEntry3("support-article-gallery-next", {
                  supportArticleId
                })
              }),
              className: "pd:grid pd:gap-4",
              children: [/* @__PURE__ */jsx17(Gallery.Root, {
                children: supportArticle.gallery.images.map((image, index) => /* @__PURE__ */jsx17(Gallery.Item, {
                  children: /* @__PURE__ */jsxs11("picture", {
                    "data-zoom": image.url,
                    children: [["avif", "webp", null].map(format2 => /* @__PURE__ */jsx17(Source, {
                      type: format2 && "image/".concat(format2),
                      src: image.url,
                      layout: "fullWidth",
                      breakpoints: [150, 260, 450, 740]
                    }, "support-article-gallery-img-".concat(format2 || "default"))), /* @__PURE__ */jsx17(Image, {
                      priority: index === 0,
                      alt: image.title,
                      src: image.url,
                      breakpoints: [150, 260, 450, 740],
                      layout: "fullWidth",
                      className: "pd:cover-parent"
                    })]
                  }, "support-article-gallery-img-".concat(image.url))
                }, image.id))
              }), /* @__PURE__ */jsx17(Gallery.Navigation, {
                maxItems: 4,
                className: "pd:mt-6",
                children: supportArticle.gallery.images.map((image, index) => /* @__PURE__ */jsx17(Gallery.Navigation.Item, {
                  children: /* @__PURE__ */jsx17(Image, {
                    className: "thumbs pd:cover-parent",
                    layout: "constrained",
                    src: image.url,
                    aspectRatio: 1,
                    alt: image.title,
                    priority: index < 4,
                    breakpoints: [48, 92],
                    width: image.width,
                    cdn: "contentful"
                  }, image.id)
                }, image.id))
              })]
            })
          }), supportArticle.heroImage && !supportArticle.gallery && /* @__PURE__ */jsx17(Grid2.Item, {
            className: "pd:col-span-2",
            children: /* @__PURE__ */jsx17(Image, {
              breakpoints: [200, 300, 400, 600, 700],
              priority: true,
              alt: supportArticle.heroImage.title,
              src: supportArticle.heroImage.url,
              width: supportArticle.heroImage.width,
              height: supportArticle.heroImage.height,
              layout: "constrained"
            })
          }), /* @__PURE__ */jsx17(Grid2.Item, {
            className: cx5("pd:lg:col-span-3", {
              "pd:lg:col-span-5": !supportArticle.heroImage && !supportArticle.gallery
            }),
            children: /* @__PURE__ */jsxs11(Grid2, {
              className: "pd:gap-2",
              children: [supportArticle.summary && /* @__PURE__ */jsx17(Grid2.Item, {
                children: /* @__PURE__ */jsx17(Suspense2, {
                  fallback: /* @__PURE__ */jsx17(Spinner2, {
                    screenReaderLabel: intl.formatMessage({
                      id: "selector.sizetable.modal.content.loading",
                      defaultMessage: "Loading..."
                    })
                  }),
                  children: /* @__PURE__ */jsx17(RichText2, {
                    as: Markdown2,
                    children: supportArticle.summary
                  })
                })
              }), showReadMore && /* @__PURE__ */jsx17(Grid2.Item, {
                children: /* @__PURE__ */jsx17(Link, {
                  variant: "primary",
                  href: fullArticleUrl,
                  onClick: () => addDataLayerEntry3("support-article-read-more", {
                    supportArticleId
                  }),
                  target: "_blank",
                  rel: "noreferrer",
                  children: /* @__PURE__ */jsx17(FormattedMessage9, {
                    id: "helpcenter.support.article.read.all",
                    defaultMessage: "Read full article"
                  })
                })
              }), supportArticle.faqs.length > 0 && /* @__PURE__ */jsx17(Grid2.Item, {
                children: /* @__PURE__ */jsxs11(Grid2, {
                  className: "pd:gap-2",
                  children: [/* @__PURE__ */jsx17(Grid2.Item, {
                    children: /* @__PURE__ */jsx17(Heading, {
                      as: "h5",
                      size: "2",
                      variant: "display",
                      children: /* @__PURE__ */jsx17(FormattedMessage9, {
                        id: "helpcenter.support.faq.title",
                        defaultMessage: "Frequently Asked Questions"
                      })
                    })
                  }), supportArticle.faqs.map(faq => /* @__PURE__ */jsx17(Grid2.Item, {
                    children: /* @__PURE__ */jsxs11(Collapsible, {
                      id: faq.id,
                      variant: "secondary",
                      children: [/* @__PURE__ */jsx17(Collapsible.Header, {
                        title: faq.title
                      }), /* @__PURE__ */jsx17(Collapsible.Panel, {
                        children: /* @__PURE__ */jsx17(Suspense2, {
                          fallback: /* @__PURE__ */jsx17(Spinner2, {
                            screenReaderLabel: intl.formatMessage({
                              id: "selector.sizetable.modal.content.loading",
                              defaultMessage: "Loading..."
                            })
                          }),
                          children: /* @__PURE__ */jsx17(RichText2, {
                            as: Markdown2,
                            children: faq.content
                          })
                        })
                      })]
                    }, faq.id)
                  }, faq.id))]
                })
              })]
            })
          })]
        })
      })
    })]
  });
};

// src/components/selector/attribute-templates/Radio.tsx
import { Fragment as Fragment6, jsx as jsx18, jsxs as jsxs12 } from "react/jsx-runtime";
var RadioValue = _ref302 => {
  let {
    title,
    checked,
    value,
    handleChange,
    handleKeyDown,
    invalidValuesVisibility,
    pricesLoading,
    hasPivotPrice
  } = _ref302;
  const [showSupportArticleModal, setShowSupportArticleModal] = useState9(false);
  const isFaded = invalidValuesVisibility === "faded";
  const isHidden = invalidValuesVisibility === "hidden";
  const {
    selectorAttributeValue,
    productAttributeValue,
    valid,
    extraCosts
  } = value;
  return /* @__PURE__ */jsx18(RadioGroup.Field, {
    id: slugify(selectorAttributeValue.id),
    value: selectorAttributeValue.name,
    className: cx6({
      "pd:hidden": !valid && isHidden
    }),
    label: title,
    description: hasPivotPrice && extraCosts !== void 0 && /* @__PURE__ */jsx18("p", {
      "data-testid": "".concat(selectorAttributeValue.id, "-description"),
      children: /* @__PURE__ */jsx18("span", {
        "data-testid": pricesLoading ? "prices-loading" : "prices-loaded",
        className: "text-gray-600 pd:text-md pd:font-normal",
        children: /* @__PURE__ */jsx18(PivotPrice, {
          extraCosts,
          pricesLoading
        })
      })
    }),
    badge: selectorAttributeValue.label && /* @__PURE__ */jsx18(ValueLabel, {
      label: selectorAttributeValue.label
    }),
    secondaryAction: (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.supportArticle) && /* @__PURE__ */jsxs12(Fragment6, {
      children: [/* @__PURE__ */jsx18(LinkAsButton3, {
        variant: "secondary",
        iconBefore: "info",
        onClick: () => setShowSupportArticleModal(true),
        children: /* @__PURE__ */jsx18(FormattedMessage10, {
          id: "general.selector.moreInfo",
          defaultMessage: "More info"
        })
      }), showSupportArticleModal && /* @__PURE__ */jsx18(SupportArticleModal, {
        supportArticleId: productAttributeValue.supportArticle.id,
        show: showSupportArticleModal,
        onClose: () => setShowSupportArticleModal(false)
      })]
    }),
    checked,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    validation: !valid && isFaded ? "dim" : void 0,
    validationMessage: !valid && isFaded && /* @__PURE__ */jsx18(FormattedMessage10, {
      id: "product.configurator.notPossibleInCombination",
      defaultMessage: "Not possible in combination"
    })
  });
};
var Radio = _ref303 => {
  let {
    attribute,
    selectorAttribute
  } = _ref303;
  const {
    invalidValuesVisibility,
    id,
    name,
    disablePopularOptions
  } = attribute;
  const {
    selectAttribute,
    attributeValues,
    selectedValue
  } = selectorAttribute;
  const pricesLoading = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "FETCHING PRICES"
      }
    }
  }) || state.matches({
    STARTED: {
      "FETCHING DATA": {
        "PIVOT PRICES": "FETCHING PIVOT PRICES"
      }
    }
  }));
  const pivotPrices = useSelectorMachineContext(state => state.context.pivotPrices);
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  const {
    handleKeyDown,
    handleChange
  } = useKeyboardMouseSelect(selectAttribute);
  const isPopularOptionsDisabled = disablePopularOptions || selectionMode === "default-values";
  return /* @__PURE__ */jsx18(RadioGroup, {
    id: "".concat(slugify(id), "-radio-group"),
    name: "".concat(name, "-radio-group"),
    maxItems: isPopularOptionsDisabled ? attributeValues.length : 4,
    moreButton: /* @__PURE__ */jsx18(RadioGroup.MoreButton, {
      children: /* @__PURE__ */jsx18(FormattedMessage10, {
        id: "general.selector.showMore",
        defaultMessage: "Show more"
      })
    }),
    children: attributeValues.map(value => {
      var _pivotPrices$name2;
      const {
        productAttributeValue,
        selectorAttributeValue
      } = value;
      const checked = selectedValue === selectorAttributeValue.name;
      const title = (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.attributeValueAlias) || (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.pimAttributeValue) || selectorAttributeValue.name;
      const hasPivotPrice = Boolean((_pivotPrices$name2 = pivotPrices[name]) === null || _pivotPrices$name2 === void 0 ? void 0 : _pivotPrices$name2[selectorAttributeValue.name]);
      return /* @__PURE__ */jsx18(RadioValue, {
        value,
        checked,
        handleChange,
        handleKeyDown,
        invalidValuesVisibility,
        title,
        pricesLoading,
        hasPivotPrice
      }, selectorAttributeValue.id);
    })
  });
};
var Radio_default = Radio;

// src/components/selector/attribute-templates/Thumbnail.tsx
import { useState as useState10 } from "react";
import { FormattedMessage as FormattedMessage11, useIntl as useIntl9 } from "react-intl";
import cx7 from "clsx";
import { LinkAsButton as LinkAsButton4, RadioCardGroup } from "@printdeal/ui-library";
import { Image as Image2 } from "@unpic/react";
import { Fragment as Fragment7, jsx as jsx19, jsxs as jsxs13 } from "react/jsx-runtime";
var ThumbnailValue = _ref304 => {
  var _productAttributeValu2;
  let {
    title,
    checked,
    isPricePivot,
    hasPivotPrice,
    value,
    invalidValuesVisibility,
    pricesLoading,
    handleChange,
    handleKeyDown
  } = _ref304;
  const {
    formatMessage
  } = useIntl9();
  const [showSupportArticleModal, setShowSupportArticleModal] = useState10(false);
  const isFaded = invalidValuesVisibility === "faded";
  const isHidden = invalidValuesVisibility === "hidden";
  const toggleModal = () => setShowSupportArticleModal(!showSupportArticleModal);
  const {
    selectorAttributeValue,
    productAttributeValue,
    valid,
    extraCosts
  } = value;
  return /* @__PURE__ */jsxs13(Fragment7, {
    children: [/* @__PURE__ */jsx19(RadioCardGroup.Field, {
      id: slugify(selectorAttributeValue.id),
      value: selectorAttributeValue.name,
      className: cx7({
        "pd:hidden": !valid && isHidden
      }),
      label: /* @__PURE__ */jsx19("span", {
        "data-invalid-message": formatMessage({
          id: "product.configurator.notPossibleInCombination",
          defaultMessage: "Not possible in combination"
        }),
        children: title
      }),
      image: (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.attributeValueImage) && /* @__PURE__ */jsx19(Image2, {
        loading: "eager",
        layout: "constrained",
        src: productAttributeValue.attributeValueImage.url,
        alt: title,
        width: Math.max(productAttributeValue.attributeValueImage.width, 200),
        height: Math.max(productAttributeValue.attributeValueImage.height, 200),
        breakpoints: [260, 315, 360],
        cdn: "contentful"
      }),
      badge: selectorAttributeValue.label && /* @__PURE__ */jsx19(ValueLabel, {
        label: selectorAttributeValue.label
      }),
      description: (isPricePivot || hasPivotPrice) && extraCosts !== void 0 && /* @__PURE__ */jsx19("p", {
        "data-testid": "".concat(selectorAttributeValue.id, "-description"),
        children: /* @__PURE__ */jsx19("span", {
          "data-testid": pricesLoading ? "prices-loading" : "prices-loaded",
          className: "text-gray-600 pd:text-md pd:font-normal",
          children: /* @__PURE__ */jsx19(PivotPrice, {
            extraCosts,
            pricesLoading
          })
        })
      }),
      secondaryAction: (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.supportArticle) && /* @__PURE__ */jsx19(LinkAsButton4, {
        variant: "secondary",
        iconBefore: "info",
        onClick: toggleModal,
        children: /* @__PURE__ */jsx19(FormattedMessage11, {
          id: "general.selector.moreInfo",
          defaultMessage: "More info"
        })
      }),
      checked,
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      validation: !valid && !isPricePivot && isFaded ? "dim" : void 0,
      validationMessage: !valid && !isPricePivot && isFaded && /* @__PURE__ */jsx19(FormattedMessage11, {
        id: "product.configurator.notPossibleInCombination",
        defaultMessage: "Not possible in combination"
      })
    }), showSupportArticleModal && /* @__PURE__ */jsx19(SupportArticleModal, {
      supportArticleId: productAttributeValue === null || productAttributeValue === void 0 || (_productAttributeValu2 = productAttributeValue.supportArticle) === null || _productAttributeValu2 === void 0 ? void 0 : _productAttributeValu2.id,
      show: showSupportArticleModal,
      onClose: () => setShowSupportArticleModal(false)
    })]
  });
};
var Thumbnail = _ref305 => {
  let {
    attribute,
    selectorAttribute
  } = _ref305;
  const {
    invalidValuesVisibility,
    name,
    disablePopularOptions
  } = attribute;
  const {
    selectAttribute,
    isPricePivot,
    attributeValues,
    selectedValue
  } = selectorAttribute;
  const pricesLoading = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "FETCHING PRICES"
      }
    }
  }) || state.matches({
    STARTED: {
      "FETCHING DATA": {
        "PIVOT PRICES": "FETCHING PIVOT PRICES"
      }
    }
  }));
  const pivotPrices = useSelectorMachineContext(state => state.context.pivotPrices);
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  const {
    handleKeyDown,
    handleChange
  } = useKeyboardMouseSelect(selectAttribute);
  const isPopularOptionsDisabled = disablePopularOptions || selectionMode === "default-values";
  return /* @__PURE__ */jsx19(RadioCardGroup, {
    id: "".concat(slugify(attribute.id), "-radio-group"),
    name: "".concat(attribute.name, "-radio-group"),
    maxItems: isPopularOptionsDisabled ? attributeValues.length : 4,
    moreButton: /* @__PURE__ */jsx19(RadioCardGroup.MoreButton, {
      children: /* @__PURE__ */jsx19(FormattedMessage11, {
        id: "general.selector.showMore",
        defaultMessage: "Show more"
      })
    }),
    children: /* @__PURE__ */jsx19(RadioCardGroup.Fields, {
      className: cx7("pd:grid-cols-1 pd:gap-4", {
        "pd:@xs:grid-cols-2 pd:@md:grid-cols-3 pd:@2xl:grid-cols-4": !isPricePivot,
        "pd:@xs:grid-cols-2": isPricePivot
      }),
      children: attributeValues.map(value => {
        var _pivotPrices$name3;
        const {
          selectorAttributeValue,
          productAttributeValue
        } = value;
        const checked = selectedValue === selectorAttributeValue.name;
        const title = (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.attributeValueAlias) || (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.pimAttributeValue) || selectorAttributeValue.name;
        const hasPivotPrice = Boolean((_pivotPrices$name3 = pivotPrices[name]) === null || _pivotPrices$name3 === void 0 ? void 0 : _pivotPrices$name3[selectorAttributeValue.name]);
        return /* @__PURE__ */jsx19(ThumbnailValue, {
          title,
          checked,
          isPricePivot,
          hasPivotPrice,
          value,
          invalidValuesVisibility,
          pricesLoading,
          handleChange,
          handleKeyDown
        }, selectorAttributeValue.id);
      })
    })
  });
};
var Thumbnail_default = Thumbnail;

// src/components/selector/attribute-templates/Group.tsx
import { Button as Button2 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage12 } from "react-intl";

// src/components/selector/attribute-templates/GroupItem.tsx
import { jsx as jsx20 } from "react/jsx-runtime";
var GroupItem = _ref306 => {
  let {
    groupItemAttribute,
    product
  } = _ref306;
  const productAttribute = getProductAttribute(product.attributes, groupItemAttribute.name);
  const selectorAttribute = useSelectorAttribute(groupItemAttribute, productAttribute);
  return /* @__PURE__ */jsx20(AttributeTemplate, {
    configurationAttribute: groupItemAttribute,
    selectorAttribute,
    product,
    isGroup: true
  });
};

// src/components/selector/attribute-templates/Group.tsx
import { jsx as jsx21, jsxs as jsxs14 } from "react/jsx-runtime";
var Group = _ref307 => {
  let {
    attribute,
    product
  } = _ref307;
  const state = useSelectorState();
  const {
    selectAttribute
  } = useSelectorAttribute(attribute);
  if (attribute.type !== "group") return null;
  const attributes = attribute.attributes.filter(groupedAttribute => groupedAttribute.template !== "hidden");
  const handleSubmit = event => {
    event.preventDefault();
    const formValid = attributes.every(groupAttribute => {
      const element = event.currentTarget[groupAttribute.name];
      return element.value && !(element.ariaInvalid === "true");
    });
    if (formValid) {
      const groupedAttributes = attributes.reduce((validAttributes, validAttribute) => _objectSpread(_objectSpread({}, validAttributes), {}, {
        [validAttribute.name]: event.currentTarget[validAttribute.name].value
      }), {});
      selectAttribute({
        selectionType: "attributeGroup",
        groupedAttributes,
        groupName: attribute.name
      });
    }
  };
  return /* @__PURE__ */jsxs14("form", {
    "data-testid": "group-form",
    onSubmit: handleSubmit,
    children: [/* @__PURE__ */jsx21("div", {
      className: "pd:flex pd:gap-5",
      children: attributes.map(groupItemAttribute => /* @__PURE__ */jsx21(GroupItem, {
        groupItemAttribute,
        product
      }, groupItemAttribute.id))
    }), /* @__PURE__ */jsx21("footer", {
      className: "pd:mb-3 pd:mt-4 pd:flex pd:w-full pd:justify-end",
      children: /* @__PURE__ */jsx21(Button2, {
        type: "submit",
        id: "group-submit-button",
        isLoading: state === "loading",
        children: /* @__PURE__ */jsx21(FormattedMessage12, {
          id: "product.configurator.btn.calculate",
          defaultMessage: "Calculate"
        })
      })
    })]
  });
};
var Group_default = Group;

// src/components/selector/attribute-templates/Scene.tsx
import { useMemo as useMemo3 } from "react";
import { RadioCardGroup as RadioCardGroup2 } from "@printdeal/ui-library";
import cx8 from "clsx";
import { FormattedMessage as FormattedMessage14 } from "react-intl";

// src/hooks/useScenePreviews.ts
import { usePreviews } from "@printdeal/previews";
var useScenePreview = _ref308 => {
  let {
    productId,
    currentColor,
    attributeName
  } = _ref308;
  const shouldReturnPreviews = Boolean(productId && currentColor);
  const defaultSelection = useSelectorMachineContext(state => state.context.selection);
  const {
    data,
    status
  } = usePreviews({
    mcpSku: productId,
    mcpAttributes: _objectSpread(_objectSpread({}, defaultSelection), {}, {
      [attributeName]: currentColor
    }),
    variant: "scene"
  });
  if (!shouldReturnPreviews) {
    return {
      preview: null,
      isLoading: false,
      hasError: false
    };
  }
  return {
    preview: !(data !== null && data !== void 0 && data[0]) ? null : data[0],
    isLoading: status === "pending",
    hasError: status === "error"
  };
};

// src/components/selector/attribute-templates/ScenePreview.tsx
import { Preview } from "@printdeal/previews";
import { FormattedMessage as FormattedMessage13 } from "react-intl";
import { jsx as jsx22 } from "react/jsx-runtime";
var PreviewSkeleton = () => /* @__PURE__ */jsx22("div", {
  className: "pd:w-full pd:animate-pulse pd:rounded-md pd:bg-dim-200",
  style: {
    aspectRatio: "1/1",
    minHeight: "120px"
  },
  "data-testid": "preview-skeleton"
});
var DOCUMENT_REFERENCE_URL = "https://uds.documents.cimpress.io/v3/documents/6284ca9a-0b04-4346-9039-5256838b8e9f/docref";
var ScenePreview = _ref309 => {
  let {
    isLoading,
    preview,
    hasError
  } = _ref309;
  if (isLoading) {
    return /* @__PURE__ */jsx22(PreviewSkeleton, {});
  }
  if (preview) {
    return /* @__PURE__ */jsx22(Preview, {
      documentReferenceUrl: DOCUMENT_REFERENCE_URL,
      view: preview
    });
  }
  if (hasError) {
    return /* @__PURE__ */jsx22("div", {
      className: "pd:text-gray-500 pd:p-4 pd:text-sm",
      children: /* @__PURE__ */jsx22(FormattedMessage13, {
        id: "selector.scene.previewUnavailable",
        defaultMessage: "Preview unavailable"
      })
    });
  }
  return /* @__PURE__ */jsx22("div", {
    className: "pd:text-gray-500 pd:p-4 pd:text-sm",
    children: /* @__PURE__ */jsx22(FormattedMessage13, {
      id: "selector.scene.noPreviewAvailable",
      defaultMessage: "No preview available"
    })
  });
};

// src/components/selector/attribute-templates/Scene.tsx
import { jsx as jsx23 } from "react/jsx-runtime";
var SceneCard = _ref310 => {
  var _attributeValue$produ, _attributeValue$produ2;
  let {
    title,
    checked,
    onChange,
    onKeyDown,
    hasPivotPrice,
    attributeValue,
    attributeName,
    product,
    invalidValuesVisibility,
    pricesLoading
  } = _ref310;
  const {
    selectorAttributeValue,
    valid,
    extraCosts
  } = attributeValue;
  const isFaded = invalidValuesVisibility === "faded";
  const isHidden = invalidValuesVisibility === "hidden";
  const productId = product.isPimProduct ? product.key : product.mcpSku;
  const {
    preview,
    isLoading,
    hasError
  } = useScenePreview({
    productId,
    currentColor: (_attributeValue$produ = (_attributeValue$produ2 = attributeValue.productAttributeValue) === null || _attributeValue$produ2 === void 0 ? void 0 : _attributeValue$produ2.pimAttributeValue) !== null && _attributeValue$produ !== void 0 ? _attributeValue$produ : "",
    attributeName
  });
  return /* @__PURE__ */jsx23(RadioCardGroup2.Field, {
    id: slugify("".concat(attributeName, "-").concat(selectorAttributeValue.id)),
    className: cx8({
      "pd:hidden": !valid && isHidden
    }),
    value: selectorAttributeValue.name,
    onChange,
    onKeyDown,
    checked,
    label: title,
    image: /* @__PURE__ */jsx23(ScenePreview, {
      isLoading,
      preview,
      hasError
    }),
    description: hasPivotPrice && extraCosts !== void 0 && /* @__PURE__ */jsx23("p", {
      "data-testid": "".concat(selectorAttributeValue.id, "-description"),
      children: /* @__PURE__ */jsx23("span", {
        "data-testid": pricesLoading ? "prices-loading" : "prices-loaded",
        className: "text-gray-600 pd:text-md pd:font-normal",
        children: /* @__PURE__ */jsx23(PivotPrice, {
          extraCosts,
          pricesLoading
        })
      })
    }),
    validation: !valid && isFaded ? "dim" : void 0,
    validationMessage: !valid && isFaded && /* @__PURE__ */jsx23(FormattedMessage14, {
      id: "product.configurator.notPossibleInCombination",
      defaultMessage: "Not possible in combination"
    })
  });
};
var Scene = _ref311 => {
  let {
    attribute,
    selectorAttribute,
    product
  } = _ref311;
  const {
    invalidValuesVisibility,
    name
  } = attribute;
  const {
    selectAttribute,
    attributeValues,
    selectedValue,
    contentAttribute
  } = selectorAttribute;
  const {
    handleKeyDown,
    handleChange
  } = useKeyboardMouseSelect(selectAttribute);
  const filteredColors2 = useMemo3(() => attribute.invalidValuesVisibility === "hidden" ? attributeValues.filter(_ref312 => {
    let {
      valid
    } = _ref312;
    return valid;
  }) : attributeValues, [attribute.invalidValuesVisibility, attributeValues]);
  const pricesLoading = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "FETCHING PRICES"
      }
    }
  }) || state.matches({
    STARTED: {
      "FETCHING DATA": {
        "PIVOT PRICES": "FETCHING PIVOT PRICES"
      }
    }
  }));
  const pivotPrices = useSelectorMachineContext(state => state.context.pivotPrices);
  return /* @__PURE__ */jsx23(RadioCardGroup2, {
    id: "".concat(attribute.id, "-scene-group"),
    name: "".concat(attribute.name, "-scene-group"),
    children: /* @__PURE__ */jsx23(RadioCardGroup2.Fields, {
      className: "pd:grid-cols-1 pd:gap-4 pd:@xs:grid-cols-2 pd:@md:grid-cols-3 pd:@2xl:grid-cols-4",
      children: filteredColors2.map(colorAttributeValue => {
        var _pivotPrices$name4;
        const {
          selectorAttributeValue,
          productAttributeValue
        } = colorAttributeValue;
        const colorName = (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.attributeValueAlias) || (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.pimAttributeValue) || selectorAttributeValue.name;
        const hasPivotPrice = Boolean((_pivotPrices$name4 = pivotPrices[name]) === null || _pivotPrices$name4 === void 0 ? void 0 : _pivotPrices$name4[selectorAttributeValue.name]);
        return /* @__PURE__ */jsx23(SceneCard, {
          attributeValue: colorAttributeValue,
          attributeName: contentAttribute === null || contentAttribute === void 0 ? void 0 : contentAttribute.pimAttributeName,
          product,
          invalidValuesVisibility,
          title: colorName,
          hasPivotPrice,
          checked: selectedValue === selectorAttributeValue.name,
          onChange: handleChange,
          onKeyDown: handleKeyDown,
          pricesLoading
        }, selectorAttributeValue.id);
      })
    })
  });
};
var Scene_default = Scene;

// src/components/selector/attribute-templates/AttributeTemplate.tsx
import { jsx as jsx24 } from "react/jsx-runtime";
var AttributeTemplate = _ref313 => {
  let {
    configurationAttribute,
    selectorAttribute,
    product,
    /* This prop is used to recursively use this component in case of a group */
    isGroup = false
  } = _ref313;
  switch (configurationAttribute.template) {
    case "radio":
      return /* @__PURE__ */jsx24(Radio_default, {
        attribute: configurationAttribute,
        selectorAttribute
      });
    case "thumbnail":
      return /* @__PURE__ */jsx24(Thumbnail_default, {
        attribute: configurationAttribute,
        selectorAttribute
      });
    case "color":
      return /* @__PURE__ */jsx24(Color_default, {
        attribute: configurationAttribute,
        selectorAttribute
      });
    case "dropdown":
      return /* @__PURE__ */jsx24(Dropdown_default, {
        attribute: configurationAttribute,
        selectorAttribute
      });
    case "deliveryDate":
      return /* @__PURE__ */jsx24(DeliveryTime_default, {
        attribute: configurationAttribute,
        selectorAttribute
      });
    case "group":
      return /* @__PURE__ */jsx24(Group_default, {
        attribute: configurationAttribute,
        product
      });
    case "input":
      return /* @__PURE__ */jsx24(Input_default, {
        attribute: configurationAttribute,
        product,
        isGroup
      });
    case "datepicker":
      return /* @__PURE__ */jsx24(DatePicker_default, {
        attribute: configurationAttribute
      });
    case "scene":
      return /* @__PURE__ */jsx24(Scene_default, {
        attribute: configurationAttribute,
        product,
        selectorAttribute
      });
    default:
      return null;
  }
};

// src/components/selector/Attribute.tsx
import { jsx as jsx25, jsxs as jsxs15 } from "react/jsx-runtime";
var Attribute = _ref314 => {
  var _attribute$groupTitle;
  let {
    attribute,
    product,
    index,
    filteredAttributes
  } = _ref314;
  const {
    locale
  } = useIntl10();
  const isIdle = useSelectorState() === "idle";
  const productAttribute = useMemo4(() => getProductAttribute(product.attributes, attribute.name), [product.attributes, attribute.name]);
  const isImpressto = configurationProvider11.getValue("STORE_KEY") === "impressto-fr";
  const currentSelection = useSelectorMachineContext(state => state.context.selection);
  const {
    showMessage,
    openPanel,
    panelName,
    values,
    variant,
    message
  } = useSelectorMachineContext(state => state.context.panel);
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  const price = useSelectorMachineContext(state => state.context.price);
  const totalQuantity = useSelectorMachineContext(state => state.context.totalQuantity);
  const showPricePerPiece = attribute.name === "groupedQuantity" && price && totalQuantity && isIdle;
  const {
    selectedValue,
    selectedProductValue
  } = getSelectedValue(currentSelection, attribute, productAttribute);
  const showQuantityGrid = Boolean(attribute.grid) && (openPanel || isImpressto || selectionMode === "step-by-step");
  const [showSupportArticleModal, setShowSupportArticleModal] = useState11(false);
  const selectorAttribute = useSelectorAttribute(attribute, productAttribute);
  const translationKey = slugify(attribute.name || attribute.pimName);
  const valueMessage = translationKey && translations[translationKey];
  const {
    open,
    setOpen
  } = useCollapseLogic({
    filteredAttributes,
    attributeName: attribute.name,
    attributeIndex: index,
    selectedValue
  });
  const title = (productAttribute === null || productAttribute === void 0 ? void 0 : productAttribute.attributeAlias) || (productAttribute === null || productAttribute === void 0 ? void 0 : productAttribute.pimAttributeName) || ((_attribute$groupTitle = attribute.groupTitle) === null || _attribute$groupTitle === void 0 ? void 0 : _attribute$groupTitle[locale]);
  const attributeName = (productAttribute === null || productAttribute === void 0 ? void 0 : productAttribute.pimAttributeName) || attribute.name;
  const collapsibleVariant = selectionMode === "step-by-step" ? "primary" : "secondary";
  const alertRef = useRef3(null);
  useEffect10(() => {
    if (message) {
      var _alertRef$current;
      (_alertRef$current = alertRef.current) === null || _alertRef$current === void 0 || _alertRef$current.scrollIntoView({
        behavior: "smooth"
      });
    }
  }, [message]);
  return /* @__PURE__ */jsx25("section", {
    "data-cy": "template-content",
    children: /* @__PURE__ */jsxs15(Collapsible2, {
      id: "selector-attribute",
      "data-testid": attributeName,
      variant: collapsibleVariant,
      isOpen: open,
      defaultOpen: open,
      children: [/* @__PURE__ */jsx25(Collapsible2.Header, {
        "data-cy": "".concat(attributeName, "-collapsible-header"),
        title,
        secondaryAction: (productAttribute === null || productAttribute === void 0 ? void 0 : productAttribute.supportArticle) && /* @__PURE__ */jsx25(LinkAsButton5, {
          variant: "secondary",
          onClick: () => setShowSupportArticleModal(true),
          iconBefore: "info",
          screenReaderLabel: "View more information"
        }),
        button: /* @__PURE__ */jsx25(Collapsible2.Button, {
          "data-testid": "collapse-".concat(attributeName),
          onClick: () => setOpen(!open)
        }),
        children: /* @__PURE__ */jsxs15("div", {
          className: "pd:flex pd:items-center pd:justify-between",
          children: [/* @__PURE__ */jsx25("span", {
            children: (selectedProductValue === null || selectedProductValue === void 0 ? void 0 : selectedProductValue.attributeValueAlias) || (valueMessage && selectedValue !== null && selectedValue !== void 0 && selectedValue.name ? /* @__PURE__ */jsx25(FormattedMessage15, {
              id: valueMessage.id,
              defaultMessage: valueMessage.defaultMessage,
              values: {
                value: selectedValue.name
              }
            }) : selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.name)
          }), showPricePerPiece && isImpressto && /* @__PURE__ */jsxs15("span", {
            className: "pd:text-sm",
            children: [/* @__PURE__ */jsx25(FormattedMessage15, {
              id: "selector.attribute.groupedQuantity.price.per.piece",
              defaultMessage: "Price per piece:"
            }), " ", /* @__PURE__ */jsx25("span", {
              className: "pd:font-bold pd:text-dim-800",
              children: /* @__PURE__ */jsx25(Money, {
                value: price.totalGross.centAmount / totalQuantity,
                showCurrency: false
              })
            })]
          })]
        })
      }), /* @__PURE__ */jsxs15(Collapsible2.Panel, {
        "data-cy": "".concat(attribute.name, "-collapsible-panel"),
        children: [attribute.name === panelName && showMessage && variant && message && /* @__PURE__ */jsx25(Alert3, {
          ref: alertRef,
          variant,
          className: "pd:my-3",
          children: /* @__PURE__ */jsx25(FormattedMessage15, {
            id: message.id,
            defaultMessage: message.defaultMessage,
            values
          })
        }), /* @__PURE__ */jsx25(AttributeTemplate, {
          configurationAttribute: attribute,
          selectorAttribute,
          product
        }), showQuantityGrid && /* @__PURE__ */jsx25(QuantityGrid_default, {
          attribute,
          productAttributes: product.attributes
        })]
      }), (productAttribute === null || productAttribute === void 0 ? void 0 : productAttribute.supportArticle) && showSupportArticleModal && /* @__PURE__ */jsx25(SupportArticleModal, {
        show: showSupportArticleModal,
        onClose: () => setShowSupportArticleModal(false),
        supportArticleId: productAttribute.supportArticle.id
      })]
    })
  });
};
var Attribute_default = memo(Attribute);

// src/components/selector/attribute-templates/Prices.tsx
import { FormattedMessage as FormattedMessage16, useIntl as useIntl11 } from "react-intl";
import { Collapsible as Collapsible3, Listbox as Listbox2 } from "@printdeal/ui-library";
import { jsx as jsx26, jsxs as jsxs16 } from "react/jsx-runtime";
var ATTRIBUTE_NAME = "Quantity";
var Prices = _ref315 => {
  let {
    filteredAttributes,
    index
  } = _ref315;
  const intl = useIntl11();
  const send = useSelectorMachineSend();
  const currentSelection = useSelectorMachineContext(state => state.context.selection);
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  const quantities = useSelectorMachineContext(state => state.context.pricesPerQuantity);
  const selectedQuantity = currentSelection[ATTRIBUTE_NAME];
  const collapsibleVariant = selectionMode === "step-by-step" ? "primary" : "secondary";
  const setQuantity2 = value => {
    send({
      type: "Select attribute value",
      attributeSelection: {
        name: "Quantity",
        value
      },
      shouldValidate: true,
      valid: true
    });
  };
  const {
    open,
    setOpen
  } = useCollapseLogic({
    filteredAttributes,
    attributeName: ATTRIBUTE_NAME,
    attributeIndex: index,
    selectedValue: {
      name: selectedQuantity
    }
  });
  return /* @__PURE__ */jsx26("section", {
    children: /* @__PURE__ */jsxs16(Collapsible3, {
      id: "quantity",
      variant: collapsibleVariant,
      isOpen: open,
      defaultOpen: open,
      className: "pd:mb-4",
      children: [/* @__PURE__ */jsx26(Collapsible3.Header, {
        "data-testid": "quantity-collapsible-header",
        title: intl.formatMessage({
          id: "selector.quantity.title",
          defaultMessage: "Quantity"
        }),
        button: /* @__PURE__ */jsx26(Collapsible3.Button, {
          onClick: () => setOpen(!open)
        }),
        children: /* @__PURE__ */jsx26(FormattedMessage16, {
          id: "selector.quantity.suffix",
          defaultMessage: "{value} pieces",
          values: {
            value: selectedQuantity
          }
        })
      }), /* @__PURE__ */jsx26(Collapsible3.Panel, {
        "data-testid": "quantity-collapsible-panel",
        children: /* @__PURE__ */jsx26(Listbox2, {
          "data-testid": "Quantity",
          name: "Quantity",
          value: selectedQuantity || "",
          onChange: changedQuantity => setQuantity2(changedQuantity),
          className: "pd:w-full pd:md:w-2/3",
          children: quantities.map(_ref316 => {
            let {
              quantity,
              deliveryType
            } = _ref316;
            return /* @__PURE__ */jsxs16(Listbox2.Option, {
              "data-testid": quantity,
              value: String(quantity),
              children: [quantity, " -", " ", deliveryType.price && intl.formatNumber(getPriceAmount("totalNet", deliveryType.price, deliveryType.discountedPrice) / 100, {
                style: "currency",
                currencyDisplay: "symbol",
                currency: deliveryType.price.totalNet.currencyCode
              })]
            }, quantity);
          })
        })
      })]
    })
  });
};
var Prices_default = Prices;

// src/components/selector/attribute-templates/LoadingTemplate.tsx
import clsx2 from "clsx";
import { jsx as jsx27 } from "react/jsx-runtime";
var LoadingTemplate = _ref317 => {
  let {
    isGrid
  } = _ref317;
  return /* @__PURE__ */jsx27("div", {
    className: clsx2("pd:w-full pd:rounded-md pd:bg-dim-200", {
      "pd:h-[800px]": isGrid,
      "pd:h-[300px]": !isGrid
    })
  });
};

// src/components/selector/UnsetModal.tsx
import { Alert as Alert4, Button as Button3, DescriptionList, Modal as Modal3 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage17, useIntl as useIntl12 } from "react-intl";
import { useEffect as useEffect11, useState as useState12 } from "react";
import { dequal as dequal3 } from "dequal";
import { jsx as jsx28, jsxs as jsxs17 } from "react/jsx-runtime";
var getAttributeTranslation = (attributes, attributeName, attributeValueName) => {
  var _getAttributeValue;
  if (!attributeName || !attributeValueName) return {};
  const attribute = getProductAttribute(attributes, attributeName);
  return {
    name: attribute === null || attribute === void 0 ? void 0 : attribute.attributeAlias,
    value: (_getAttributeValue = getAttributeValue(attributeValueName, attribute === null || attribute === void 0 ? void 0 : attribute.values)) === null || _getAttributeValue === void 0 ? void 0 : _getAttributeValue.attributeValueAlias
  };
};
var createChanges = (selection, attributes, configurationAttributes, validationResult) => {
  if (!validationResult || validationResult.state === "unresolvable" && !validationResult.violatedAttributes.length) {
    return [];
  }
  const changedAttributes = validationResult.violatedAttributes.length > 0 ? validationResult.violatedAttributes.filter(violatedAttribute => attributes.find(attribute => attribute.pimAttributeName === violatedAttribute)).map(violatedAttribute => getProductAttribute(attributes, violatedAttribute)) : attributes.filter(_ref318 => {
    let {
      pimAttributeName
    } = _ref318;
    return !pricePivotAttributes.includes(pimAttributeName);
  });
  return changedAttributes.map(attribute => {
    if (attribute) {
      var _configurationAttribu3;
      const {
        pimAttributeName,
        values,
        attributeAlias
      } = attribute;
      const defaultValue = (_configurationAttribu3 = configurationAttributes.find(_ref319 => {
        let {
          name
        } = _ref319;
        return name === pimAttributeName;
      })) === null || _configurationAttribu3 === void 0 ? void 0 : _configurationAttribu3.defaultValue;
      const currentValue = getAttributeValue(selection[pimAttributeName], values);
      const remainingOption = getResolvedAttribute(validationResult.remainingOptions, pimAttributeName);
      const newValue = (remainingOption === null || remainingOption === void 0 ? void 0 : remainingOption.values.length) === 1 && remainingOption.values[0].type === "stringLiteral" ? getAttributeValue(remainingOption.values[0].stringLiteral, values) : getAttributeValue(defaultValue, values);
      if (!dequal3(currentValue === null || currentValue === void 0 ? void 0 : currentValue.attributeValueAlias, newValue === null || newValue === void 0 ? void 0 : newValue.attributeValueAlias)) {
        return {
          attributeName: attributeAlias || pimAttributeName || void 0,
          currentValue: (currentValue === null || currentValue === void 0 ? void 0 : currentValue.attributeValueAlias) || (currentValue === null || currentValue === void 0 ? void 0 : currentValue.pimAttributeValue) || void 0,
          newValue: (newValue === null || newValue === void 0 ? void 0 : newValue.attributeValueAlias) || (newValue === null || newValue === void 0 ? void 0 : newValue.pimAttributeValue) || void 0
        };
      }
    }
    return void 0;
  }).filter(Boolean);
};
var UnsetModal = _ref320 => {
  let {
    product
  } = _ref320;
  const intl = useIntl12();
  const {
    attributes,
    key,
    isPimProduct,
    productVersion
  } = product;
  const selection = useSelectorMachineContext(state => state.context.selection);
  const configurationAttributes = useSelectorMachineContext(state => state.context.attributes);
  const invalidSelection = useSelectorMachineContext(state => state.context.invalidSelection);
  const send = useSelectorMachineSend();
  const [validationResult, setValidationResult] = useState12();
  const changes = createChanges(selection, attributes, configurationAttributes, validationResult);
  const waitForUserConfirmation = useSelectorMachineContext(state => state.matches({
    STARTED: "WAIT FOR USER CONFIRMATION"
  }));
  const hasInvalidSelection = Object.entries(invalidSelection).length;
  const [invalidName, invalidValue] = hasInvalidSelection ? Object.entries(invalidSelection)[0] : [];
  const selectedAttribute = getAttributeTranslation(attributes, invalidName, invalidValue);
  const hasChanges = changes.length > 0;
  const validateSelection2 = async () => {
    const {
      data
    } = await validationClient.validate(key, selection, invalidSelection, {
      "x-filename": "unsetModal.tsx"
    }, isPimProduct, productVersion);
    setValidationResult(data);
  };
  const handleConfirm = () => {
    if (invalidName && invalidValue) {
      send({
        type: "Select attribute value",
        attributeSelection: {
          name: invalidName,
          value: invalidValue
        },
        shouldValidate: true,
        valid: false
      });
      dispatchDataLayerEntry("confirm-unset", "click");
    }
  };
  useEffect11(() => {
    if (waitForUserConfirmation) {
      validateSelection2();
      dispatchDataLayerEntry("show unset modal", "display", selectedAttribute);
    }
    if (waitForUserConfirmation && validationResult && validationResult.state === "unresolvable" && !validationResult.violatedAttributes.length && !hasChanges) {
      handleConfirm();
    }
  }, [waitForUserConfirmation, JSON.stringify(validationResult), hasChanges]);
  const handleCancel = () => {
    send({
      type: "Cancel unset"
    });
    dispatchDataLayerEntry("cancel-unset", "click");
  };
  if (!waitForUserConfirmation || !hasChanges) {
    return null;
  }
  return /* @__PURE__ */jsxs17(Modal3, {
    size: "lg",
    title: intl.formatMessage({
      id: "selector.product.unset.modal.title",
      defaultMessage: "This combination is not possible"
    }),
    isOpen: true,
    onClose: handleCancel,
    dismissLabel: intl.formatMessage({
      id: "general.alert.dismiss",
      defaultMessage: "Dismiss"
    }),
    children: [/* @__PURE__ */jsxs17(Modal3.Content, {
      className: "pd:grid pd:grid-cols-1 pd:gap-4",
      children: [/* @__PURE__ */jsx28(Alert4, {
        variant: "warning",
        children: /* @__PURE__ */jsx28(FormattedMessage17, {
          id: "selector.product.unset.modal.warning.message",
          defaultMessage: "The selected option is not possible with your current selection."
        })
      }), /* @__PURE__ */jsx28(FormattedMessage17, {
        id: "selector.product.unset.modal.message",
        defaultMessage: "The option that you selected {option} is not possible with your current selection. We created the following automatic selection for you:",
        values: {
          option: "(".concat(selectedAttribute.name, ": ").concat(selectedAttribute.value, ")")
        }
      }), changes.map((attribute, index) => /* @__PURE__ */jsxs17("div", {
        children: [/* @__PURE__ */jsxs17(DescriptionList, {
          children: [/* @__PURE__ */jsx28(DescriptionList.Title, {
            children: /* @__PURE__ */jsx28(FormattedMessage17, {
              id: "selector.product.unset.modal.current.message",
              defaultMessage: "{attributeName} (current selection)",
              values: {
                attributeName: attribute === null || attribute === void 0 ? void 0 : attribute.attributeName
              }
            })
          }), /* @__PURE__ */jsx28(DescriptionList.Content, {
            children: attribute !== null && attribute !== void 0 && attribute.currentValue ? attribute.currentValue : /* @__PURE__ */jsx28(FormattedMessage17, {
              id: "selector.product.unset.modal.noselect.message",
              defaultMessage: "- (Not selected)"
            })
          }), /* @__PURE__ */jsx28(DescriptionList.Title, {
            children: /* @__PURE__ */jsx28(FormattedMessage17, {
              id: "selector.product.unset.modal.new.message",
              defaultMessage: "{attributeName} (new selection)",
              values: {
                attributeName: attribute === null || attribute === void 0 ? void 0 : attribute.attributeName
              }
            })
          }), /* @__PURE__ */jsx28(DescriptionList.Content, {
            children: attribute !== null && attribute !== void 0 && attribute.newValue ? attribute.newValue : /* @__PURE__ */jsx28(FormattedMessage17, {
              id: "selector.product.unset.modal.select.message",
              defaultMessage: "- (Select again)"
            })
          })]
        }), changes.length - 1 !== index && /* @__PURE__ */jsx28("hr", {})]
      }, attribute === null || attribute === void 0 ? void 0 : attribute.attributeName))]
    }), /* @__PURE__ */jsx28(Modal3.Footer, {
      children: /* @__PURE__ */jsxs17("div", {
        className: "pd:flex pd:justify-end pd:gap-3",
        children: [/* @__PURE__ */jsx28(Button3, {
          variant: "secondary",
          onClick: handleCancel,
          children: /* @__PURE__ */jsx28(FormattedMessage17, {
            id: "selector.product.unset.modal.cancel",
            defaultMessage: "Cancel"
          })
        }), /* @__PURE__ */jsx28(Button3, {
          onClick: handleConfirm,
          children: /* @__PURE__ */jsx28(FormattedMessage17, {
            id: "selector.product.unset.modal.confirm",
            defaultMessage: "confirm new selections"
          })
        })]
      })
    })]
  });
};
var UnsetModal_default = UnsetModal;

// src/components/selector/Selector.tsx
import { jsx as jsx29, jsxs as jsxs18 } from "react/jsx-runtime";
var Selector = _ref321 => {
  let {
    productPageId,
    selector,
    customerGroupId,
    isReviewPage = false,
    shippingAddress = {
      CountryCode: "NL",
      PostalCode: "7418 ET"
    },
    prefilledSelection = void 0,
    serviceKeys = [],
    deliveryOptionId,
    quantity,
    templateSelection = {}
  } = _ref321;
  const isMobile = useMediaQuery("(max-width: 768px)");
  const send = useSelectorMachineSend();
  const updatedAttributes = useSelectorMachineContext(state => state.context.attributes);
  const {
    configuration,
    product,
    selectionMode
  } = selector;
  const attributes = updatedAttributes.length ? updatedAttributes : configuration.attributes;
  const touchedAttributes = useSelectorMachineContext(state => state.context.touchedAttributes);
  const [selectionInteractionStarted, setSelectionInteractionStarted] = useState13(false);
  const isStepByStep2 = selectionMode === "step-by-step";
  const remainingOptions = useSelectorMachineContext(state => state.context.remainingOptionsPerGroup);
  const selection = useSelectorMachineContext(state => state.context.selection);
  const selectorState = useSelectorState();
  const isIdle = selectorState === "idle";
  const defaultSelection = useMemo5(() => getDefaultSelection(attributes), [attributes]);
  const filteredAttributes = useMemo5(() => {
    if (isReviewPage && (Object.keys(selection).length === 0 || remainingOptions.length === 0)) return void 0;
    return filterAttributes(attributes, remainingOptions, isReviewPage, selection, selectionMode, templateSelection);
  }, [attributes, remainingOptions, isReviewPage, selection, selectionMode, templateSelection]);
  const flatPrefilledSelection = useMemo5(() => Array.isArray(prefilledSelection) ? Object.assign({}, ...prefilledSelection) : prefilledSelection, [prefilledSelection]);
  useEffect12(() => {
    const defaultSelection2 = getDefaultSelection(attributes);
    const url = getCurrentUrl();
    const urlSelection = getSelectionFromUrl(url, product.attributes);
    const urlGroupSelection = getGroupFromUrl(url);
    const {
      selection: selection2,
      groupSelection
    } = formatPrefilledSelection(configuration.attributes, prefilledSelection || urlSelection);
    const quantityParam = getParamFromUrl(url, "quantity");
    const deliveryOptionIdParam = getParamFromUrl(url, "deliveryOptionId");
    send({
      type: "Start machine",
      attributes,
      selection: selection2 || defaultSelection2,
      group: groupSelection || urlGroupSelection,
      groupAttributes: getGroupAttributes(attributes),
      panel: {
        panelName: "groupedQuantity",
        openPanel: isReviewPage
      },
      totalQuantity: getTotalQuantity({
        quantity,
        quantityParam,
        urlSelection,
        defaultSelection: defaultSelection2
      }),
      touchedAttributes: isStepByStep2 ? Object.keys(flatPrefilledSelection || {}) : [],
      productKey: product.key,
      serviceKeys,
      mcpSku: product.mcpSku,
      shippingAddress,
      customerGroupId,
      device: isMobile ? "mobile" : "desktop",
      isReviewPage,
      selectionMode,
      product: selector.product,
      selectedDeliveryOptionId: deliveryOptionId || deliveryOptionIdParam
    });
  }, []);
  useEffect12(() => {
    send({
      type: "Set device",
      device: isMobile ? "mobile" : "desktop"
    });
  }, [isMobile]);
  if (isReviewPage && !filteredAttributes) {
    const reviewAttributes = attributes.filter(attribute => attribute.onReviewPage);
    return /* @__PURE__ */jsx29("div", {
      className: "pd:grid pd:animate-pulse pd:gap-6",
      children: reviewAttributes.map(reviewAttribute => /* @__PURE__ */jsx29(LoadingTemplate, {
        isGrid: !!reviewAttribute.grid
      }, reviewAttribute.id))
    });
  }
  if (touchedAttributes.length === 1 && !selectionInteractionStarted) {
    dispatchDataLayerEntry("selector", "selector_interaction_start", {
      contentful_id: productPageId
    });
    setSelectionInteractionStarted(true);
  }
  return /* @__PURE__ */jsxs18(Grid3, {
    className: "pd:@container pd:relative pd:z-10 pd:gap-4",
    "data-testid": isIdle ? "selector-machine-idle" : "selector-machine-loading",
    children: [filteredAttributes === null || filteredAttributes === void 0 ? void 0 : filteredAttributes.map((attribute, index) => /* @__PURE__ */jsxs18(Grid3.Item, {
      className: clsx3("pd:relative", index > 0 ? "pd:-z-".concat(index) : "pd:z-0"),
      children: [attribute.name === "Delivery Type" && selectionMode === "default-values" && !Number(defaultSelection.groupedQuantity) && /* @__PURE__ */jsx29(Prices_default, {
        filteredAttributes,
        index
      }), /* @__PURE__ */jsx29(Attribute_default, {
        index,
        attribute,
        product: selector.product,
        filteredAttributes
      })]
    }, attribute.id)), /* @__PURE__ */jsx29(SizeTableModal_default, {
      productPageId
    }), /* @__PURE__ */jsx29(UnsetModal_default, {
      product: selector.product
    })]
  });
};

// src/components/prices/Prices.tsx
import { useEffect as useEffect17 } from "react";

// src/components/prices/table/PriceTableLoading.tsx
import { Heading as Heading2, Spinner as Spinner3 } from "@printdeal/ui-library";
import { useIntl as useIntl13 } from "react-intl";
import { jsx as jsx30, jsxs as jsxs19 } from "react/jsx-runtime";
var PriceTableLoading = _ref322 => {
  let {
    showCards
  } = _ref322;
  const intl = useIntl13();
  return /* @__PURE__ */jsxs19("div", {
    "data-testid": "price-table-loading",
    className: "pd:overflow-hidden pd:rounded-md pd:border-1 pd:border-dim-200",
    children: [/* @__PURE__ */jsx30("div", {
      className: "pd:bg-dim-100 pd:p-5",
      children: /* @__PURE__ */jsx30("div", {
        className: "pd:flex pd:justify-between",
        children: /* @__PURE__ */jsxs19("div", {
          className: "pd:pr-4",
          children: [/* @__PURE__ */jsx30(Heading2, {
            as: "div",
            size: "3",
            children: "\xA0"
          }), "\xA0"]
        })
      })
    }), showCards ? /* @__PURE__ */jsx30("div", {
      className: "pd:flex pd:h-40 pd:w-full pd:items-center pd:justify-center pd:p-4",
      children: /* @__PURE__ */jsx30(Spinner3, {
        size: "lg",
        screenReaderLabel: intl.formatMessage({
          id: "uilib.spinner.loading",
          defaultMessage: "Loading..."
        })
      })
    }) : /* @__PURE__ */jsx30("table", {
      className: "pd:mb-0 pd:w-full pd:text-center",
      children: /* @__PURE__ */jsx30("tbody", {
        children: /* @__PURE__ */jsx30("tr", {
          children: /* @__PURE__ */jsx30("td", {
            className: "pd:flex pd:h-60 pd:w-full pd:items-center pd:justify-center pd:p-4",
            children: /* @__PURE__ */jsx30(Spinner3, {
              size: "lg",
              screenReaderLabel: intl.formatMessage({
                id: "uilib.spinner.loading",
                defaultMessage: "Loading..."
              })
            })
          })
        })
      })
    })]
  });
};

// src/components/prices/cards/PriceCards.tsx
import { useContext as useContext3, useEffect as useEffect13 } from "react";
import { FormattedMessage as FormattedMessage18, useIntl as useIntl15 } from "react-intl";
import { Collapsible as Collapsible4, Grid as Grid4, RadioCard as RadioCard2 } from "@printdeal/ui-library";

// src/components/prices/ArrivalDate.tsx
import { FormattedDate as FormattedDate2, useIntl as useIntl14 } from "react-intl";
import { Spinner as Spinner4 } from "@printdeal/ui-library";

// src/statemachines/prices/prices.machine.selectors.ts
var selectArrivalDates = state => state.context.arrivalDates;
var selectSelectedPriceAttributes = state => state.context.selectedPriceAttributes;
var selectCustomQuantities = state => state.context.customQuantities;
var selectPrices = state => state.context.prices;
var selectCustomQuantityPrices = state => state.context.customQuantityPrices;
var selectPriceAttributes = state => state.context.selectedPriceAttributes;

// src/components/prices/ArrivalDate.tsx
import { jsx as jsx31, jsxs as jsxs20 } from "react/jsx-runtime";
var ArrivalDate = _ref323 => {
  let {
    deliveryType,
    printingProcess
  } = _ref323;
  const intl = useIntl14();
  const isLoadingArrivalDates = usePricesMachineContext(state => state.matches({
    "Showing Prices": {
      "Arrival dates": "Loading arrival dates"
    }
  }));
  const arrivalDates = usePricesMachineContext(selectArrivalDates);
  const arrivalDate = getArrivalDate(arrivalDates, deliveryType, printingProcess);
  if (isLoadingArrivalDates) {
    return /* @__PURE__ */jsx31(Spinner4, {
      "data-testid": "delivery-date-loading",
      size: "sm",
      variant: "dim",
      screenReaderLabel: intl.formatMessage({
        id: "uilib.spinner.loading",
        defaultMessage: "Loading..."
      })
    });
  }
  if (arrivalDate && Date.parse(arrivalDate)) {
    return /* @__PURE__ */jsxs20("div", {
      children: [/* @__PURE__ */jsx31("span", {
        className: "pd:mr-1",
        children: /* @__PURE__ */jsx31(FormattedDate2, {
          weekday: "short",
          value: arrivalDate
        })
      }), /* @__PURE__ */jsx31("span", {
        children: /* @__PURE__ */jsx31(FormattedDate2, {
          month: "short",
          day: "numeric",
          value: arrivalDate
        })
      })]
    });
  }
  return null;
};

// src/components/prices/cards/PriceCards.tsx
import { dequal as dequal4 } from "dequal";
import { jsx as jsx32, jsxs as jsxs21 } from "react/jsx-runtime";
var PriceCards = _ref324 => {
  let {
    printingProcessPrice
  } = _ref324;
  const intl = useIntl15();
  const {
    vatMode
  } = useContext3(VatModeContext);
  const selectedPriceAttributes = usePricesMachineContext(selectSelectedPriceAttributes);
  const selectedPrice = usePricesMachineContext(state => {
    var _state$context$select;
    return (_state$context$select = state.context.selectedPrice) === null || _state$context$select === void 0 ? void 0 : _state$context$select.discountedPrice;
  });
  const selectorMachineSend = useSelectorMachineSend();
  const priceMachineSend = usePricesMachineSend();
  const configurationAttributes = useSelectorMachineContext(state => state.context.attributes);
  useEffect13(() => {
    if (selectedPrice && selectedPriceAttributes) {
      selectorMachineSend({
        type: "Select attribute value",
        groupedAttributes: _objectSpread(_objectSpread({}, getSelectedPriceAttributes(configurationAttributes, selectedPriceAttributes)), {}, {
          Quantity: String(selectedPriceAttributes.Quantity)
        }),
        shouldValidate: true,
        valid: true
      });
      selectorMachineSend({
        type: "Set price",
        price: selectedPrice
      });
    }
  }, [JSON.stringify(selectedPrice), JSON.stringify(selectedPriceAttributes), selectorMachineSend]);
  return /* @__PURE__ */jsx32("section", {
    "data-cy": "price-cards",
    children: /* @__PURE__ */jsxs21(Collapsible4, {
      id: "price-cards-collapsible",
      isOpen: true,
      children: [/* @__PURE__ */jsx32(Collapsible4.Header, {
        "data-cy": "price-cards-collapsible-header",
        title: /* @__PURE__ */jsx32(FormattedMessage18, {
          id: "account.order.delivery.title",
          defaultMessage: "Delivery"
        })
      }), /* @__PURE__ */jsx32(Collapsible4.Panel, {
        "data-testid": "price-cards-collapsible-panel",
        children: /* @__PURE__ */jsx32(Grid4, {
          className: "pd:grid-cols-2 pd:gap-4",
          children: printingProcessPrice.quantities.map(_ref325 => {
            let {
              deliveryTypes,
              quantity
            } = _ref325;
            return deliveryTypes.map(_ref326 => {
              let {
                name,
                price,
                discountedPrice
              } = _ref326;
              const priceAttributes = _objectSpread(_objectSpread(_objectSpread({}, getPriceAttribute(configurationAttributes, printingProcessPrice.name)), getPriceAttribute(configurationAttributes, name)), quantity && {
                Quantity: quantity
              });
              if (!price) {
                return null;
              }
              const handlePriceSelection = () => {
                priceMachineSend({
                  type: "Select price",
                  selectedPrice: {
                    price,
                    discountedPrice
                  },
                  selectedPriceAttributes: priceAttributes
                });
              };
              const selected = dequal4(discountedPrice, selectedPrice);
              return /* @__PURE__ */jsx32(RadioCard2, {
                id: slugify("price-card-".concat(name)),
                name: "price-card-".concat(name),
                onChange: handlePriceSelection,
                checked: selected,
                label: /* @__PURE__ */jsx32(ArrivalDate, {
                  deliveryType: name,
                  printingProcess: printingProcessPrice.name
                }),
                description: /* @__PURE__ */jsxs21(Grid4, {
                  className: "pd:font-normal",
                  children: [/* @__PURE__ */jsx32(Grid4.Item, {
                    children: /* @__PURE__ */jsx32(Money, {
                      value: getPriceAmount(vatMode, price, discountedPrice)
                    })
                  }), /* @__PURE__ */jsx32(Grid4.Item, {
                    children: /* @__PURE__ */jsx32("span", {
                      children: intl.formatMessage(translations[vatMode])
                    })
                  }), /* @__PURE__ */jsxs21(Grid4.Item, {
                    children: [name === "Next Day" && /* @__PURE__ */jsx32(FormattedMessage18, {
                      id: "general.selector.pricetable.deliverymethod.nextDay",
                      defaultMessage: "Next day delivery"
                    }), name === "Express" && /* @__PURE__ */jsx32(FormattedMessage18, {
                      id: "general.selector.pricetable.deliverymethod.express",
                      defaultMessage: "Express delivery"
                    }), name === "Normal" && /* @__PURE__ */jsx32(FormattedMessage18, {
                      id: "general.selector.pricetable.deliverymethod.normal",
                      defaultMessage: "Normal delivery"
                    })]
                  })]
                })
              }, name);
            });
          })
        })
      })]
    })
  });
};

// src/components/prices/table/PriceTable.tsx
import { useContext as useContext5, useMemo as useMemo7, useState as useState16 } from "react";
import { FormattedMessage as FormattedMessage21, useIntl as useIntl19 } from "react-intl";
import { Badge as Badge2, Heading as Heading3, LinkAsButton as LinkAsButton6 } from "@printdeal/ui-library";

// src/components/prices/table/PriceCell.tsx
import { useContext as useContext4, useEffect as useEffect14 } from "react";
import { useIntl as useIntl16 } from "react-intl";
import { Spinner as Spinner5 } from "@printdeal/ui-library";

// src/components/prices/table/PriceToolTip.tsx
import { Tooltip } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage19 } from "react-intl";
import { jsx as jsx33, jsxs as jsxs22 } from "react/jsx-runtime";
var PriceTooltip = _ref327 => {
  let {
    vatMode,
    price,
    discountedPrice,
    children
  } = _ref327;
  if (!hasDiscount(vatMode, price, discountedPrice)) {
    return children;
  }
  const handleTooltipHover = () => {
    dispatchDataLayerEntry("price_table_tooltip", "display");
  };
  return /* @__PURE__ */jsxs22(Tooltip, {
    placement: "top",
    className: "pd:w-full",
    onMouseEnter: handleTooltipHover,
    trigger: /* @__PURE__ */jsx33(Tooltip.Trigger, {
      className: "pd:w-full",
      as: "div",
      children
    }),
    children: [/* @__PURE__ */jsx33(FormattedMessage19, {
      id: "general.product.reseller.tooltip.text",
      defaultMessage: "Regular Price:"
    }), " ", /* @__PURE__ */jsx33(Money, {
      value: getPriceAmount(vatMode, price),
      showCurrency: true
    })]
  });
};

// src/components/prices/table/PriceButton.tsx
import { FormattedMessage as FormattedMessage20 } from "react-intl";
import cx9 from "clsx";
import { jsx as jsx34, jsxs as jsxs23 } from "react/jsx-runtime";
var PriceButton = _ref328 => {
  let {
      vatMode,
      price,
      discountedPrice,
      selected,
      handleClick
    } = _ref328,
    rest = _objectWithoutProperties(_ref328, _excluded);
  return (
    // The contents of the button are the label, so we don't need an aria-label
    /* @__PURE__ */
    jsxs23("button", _objectSpread(_objectSpread({
      "data-testid": "price-table-button",
      "aria-pressed": selected,
      type: "button",
      className: cx9("pd:p-3 pd:w-full pd:hover:bg-primary-500 pd:hover:text-white", {
        "pd:bg-primary-500 pd:text-white": selected
      }),
      onClick: handleClick
    }, rest), {}, {
      children: [/* @__PURE__ */jsx34("span", {
        className: "pd:block",
        children: /* @__PURE__ */jsx34(Money, {
          value: getPriceAmount(vatMode, price, discountedPrice),
          showCurrency: false
        })
      }), /* @__PURE__ */jsx34("span", {
        className: "pd:block",
        children: /* @__PURE__ */jsx34(FormattedMessage20, {
          id: translations[vatMode].id,
          defaultMessage: translations[vatMode].defaultMessage
        })
      })]
    }))
  );
};

// src/components/prices/table/PriceCell.tsx
import { dequal as dequal5 } from "dequal";
import { jsx as jsx35 } from "react/jsx-runtime";
var PriceCell = _ref329 => {
  let {
    price,
    discountedPrice,
    isLoading,
    priceAttributes,
    isReseller = false
  } = _ref329;
  const intl = useIntl16();
  const {
    vatMode
  } = useContext4(VatModeContext);
  const selectorMachineSend = useSelectorMachineSend();
  const priceMachineSend = usePricesMachineSend();
  const selectedPrice = usePricesMachineContext(state => {
    var _state$context$select2;
    return (_state$context$select2 = state.context.selectedPrice) === null || _state$context$select2 === void 0 ? void 0 : _state$context$select2.discountedPrice;
  });
  const selectedPriceAttributes = usePricesMachineContext(state => state.context.selectedPriceAttributes);
  const configurationAttributes = useSelectorMachineContext(state => state.context.attributes);
  const handlePriceSelection = () => {
    if (price && priceAttributes) {
      priceMachineSend({
        type: "Select price",
        selectedPrice: {
          price,
          discountedPrice
        },
        selectedPriceAttributes: priceAttributes
      });
      const deliveryType = String(priceAttributes["Delivery Type"]);
      const deliveryTypeLowerCased = deliveryType.toLowerCase().replace(/ /g, "_");
      const formattedPrice = intl.formatNumber(price[vatMode].centAmount / 100, {
        currency: price[vatMode].currencyCode
      });
      dispatchDataLayerEntry("price_table", "click", {
        "element-type": "button_pricetable",
        "element-content": "pricetable_price_cell",
        "element-context": "pricetable_column_".concat(deliveryTypeLowerCased),
        "delivery-type": deliveryType,
        quantity: priceAttributes.Quantity,
        price: formattedPrice
      });
    }
  };
  const selected = selectedPriceAttributes && priceAttributes && dequal5(selectedPriceAttributes, priceAttributes) && dequal5(discountedPrice, selectedPrice);
  useEffect14(() => {
    if (selectedPrice && selectedPriceAttributes) {
      selectorMachineSend({
        type: "Select attribute value",
        groupedAttributes: _objectSpread(_objectSpread({}, getSelectedPriceAttributes(configurationAttributes, selectedPriceAttributes)), {}, {
          Quantity: String(selectedPriceAttributes.Quantity)
        }),
        shouldValidate: true,
        valid: true
      });
      selectorMachineSend({
        type: "Set price",
        price: selectedPrice
      });
    }
  }, [JSON.stringify(selectedPrice), JSON.stringify(selectedPriceAttributes)]);
  if (!price) {
    if (isLoading) {
      return /* @__PURE__ */jsx35("td", {
        className: "pd:border",
        children: /* @__PURE__ */jsx35("div", {
          className: "pd:flex pd:w-full pd:justify-center",
          children: /* @__PURE__ */jsx35(Spinner5, {
            variant: "dim",
            screenReaderLabel: intl.formatMessage({
              id: "uilib.spinner.loading",
              defaultMessage: "Loading..."
            })
          })
        })
      });
    }
    return /* @__PURE__ */jsx35("td", {});
  }
  return /* @__PURE__ */jsx35("td", {
    className: "pd:m-0 pd:border-1 pd:border-x-dim-200 pd:p-0",
    children: isReseller ? /* @__PURE__ */jsx35(PriceTooltip, {
      vatMode,
      price,
      discountedPrice,
      children: /* @__PURE__ */jsx35(PriceButton, {
        vatMode,
        price,
        discountedPrice,
        selected,
        handleClick: handlePriceSelection
      })
    }) : /* @__PURE__ */jsx35(PriceButton, {
      vatMode,
      price,
      discountedPrice,
      selected,
      handleClick: handlePriceSelection
    })
  });
};

// src/components/prices/table/CustomQuantities.tsx
import { useEffect as useEffect16, useMemo as useMemo6, useState as useState15 } from "react";

// src/components/prices/table/SelectCustomQuantity.tsx
import { Listbox as Listbox3 } from "@printdeal/ui-library";
import { useIntl as useIntl17 } from "react-intl";
import { jsx as jsx36 } from "react/jsx-runtime";
var SelectCustomQuantity = _ref330 => {
  let {
    quantities,
    onChange,
    selectedQuantity
  } = _ref330;
  const intl = useIntl17();
  return /* @__PURE__ */jsx36(Listbox3, {
    id: "customQuantity",
    name: "customQuantity",
    onChange: value => onChange(Number(value)),
    placeholder: intl.formatMessage({
      id: "pricetable.customQuantities.placeholder",
      defaultMessage: "Higher quantities"
    }),
    value: String(selectedQuantity),
    children: quantities.map(quantity => /* @__PURE__ */jsx36(Listbox3.Option, {
      value: String(quantity),
      children: quantity
    }, quantity))
  });
};

// src/components/prices/table/CustomQuantityInput.tsx
import { useState as useState14, useEffect as useEffect15 } from "react";
import { useIntl as useIntl18 } from "react-intl";
import { TextField as TextField3 } from "@printdeal/ui-library";
import { jsx as jsx37 } from "react/jsx-runtime";
var CustomQuantityInput = _ref331 => {
  var _remainingOptions$pri;
  let {
    value,
    onChange,
    printingProcess
  } = _ref331;
  const intl = useIntl18();
  const [quantityInput, setQuantityInput] = useState14(value !== 0 ? String(value) : "");
  const remainingOptions = usePricesMachineContext(state => state.context.remainingOptions);
  const remainingOptionsForPrintingProcess = (_remainingOptions$pri = remainingOptions === null || remainingOptions === void 0 ? void 0 : remainingOptions[printingProcess]) !== null && _remainingOptions$pri !== void 0 ? _remainingOptions$pri : [];
  useEffect15(() => {
    setQuantityInput(value !== 0 ? String(value) : "");
  }, [value]);
  const range = calculateRange("Quantity", remainingOptionsForPrintingProcess);
  const minimumQuantity = range === null || range === void 0 ? void 0 : range.minimum;
  const maximumQuantity = range === null || range === void 0 ? void 0 : range.maximum;
  const increment = range === null || range === void 0 ? void 0 : range.increment;
  const trimmedQuantity = quantityInput.trim();
  const numericValue = trimmedQuantity ? Number(trimmedQuantity) : void 0;
  const isValidNumber = numericValue !== void 0 && Number.isFinite(numericValue) && !Number.isNaN(numericValue) && numericValue > 0;
  const isInputValid = isValidNumber ? isRangeValid("Quantity", remainingOptionsForPrintingProcess, numericValue) : true;
  const validationMessage = range ? intl.formatMessage({
    id: "selector.quantity.maxQuantity",
    defaultMessage: "Orders for this product range from {minQuantity} to {maxQuantity}, in increments of {increment} pieces"
  }, {
    minQuantity: minimumQuantity,
    maxQuantity: maximumQuantity,
    increment
  }) : "";
  const validate = () => {
    if (!isInputValid) {
      return "error";
    }
    return void 0;
  };
  const handleChange = event => {
    setQuantityInput(event.target.value);
  };
  const handleBlur = () => {
    if (isValidNumber && isInputValid) {
      onChange(numericValue);
    }
  };
  const handleKeyDown = event => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (isValidNumber && isInputValid) {
        onChange(numericValue);
      }
    }
  };
  return /* @__PURE__ */jsx37(TextField3, {
    "data-testid": "custom-quantity-input-price-table",
    type: "number",
    name: "customQuantityInput",
    value: quantityInput,
    min: minimumQuantity,
    max: maximumQuantity,
    step: increment,
    id: "customQuantityInput",
    inputMode: "numeric",
    validation: validate(),
    validationMessage: isInputValid ? "" : validationMessage,
    suffix: intl.formatMessage({
      id: "selector.quantityGrid.customQuantitySuffix",
      defaultMessage: "pieces"
    }),
    "aria-label": intl.formatMessage({
      id: "selector.customQuantity.label",
      defaultMessage: "Custom quantity"
    }),
    onBlur: handleBlur,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    onWheel: event => {
      event.currentTarget.blur();
    }
  });
};

// src/components/prices/table/CustomQuantities.tsx
import { useExperiment as useExperiment2 } from "@printdeal/feature-management/react";
import { jsx as jsx38, jsxs as jsxs24 } from "react/jsx-runtime";
var addEmptyPrices = (columns, deliveryTypes) => columns.map(column => {
  const present = deliveryTypes.find(deliveryType => deliveryType.name === column.name);
  if (present) {
    return present;
  }
  return column;
});
var CustomQuantities = _ref332 => {
  let {
    printingProcess,
    quantities,
    columns,
    isReseller = false,
    productKey
  } = _ref332;
  const send = usePricesMachineSend();
  const loadingCustomQuantities = usePricesMachineContext(state => state.matches({
    "Showing Prices": {
      "Custom quantities": {
        "Showing custom quantities": "Loading custom quantity prices"
      }
    }
  }));
  const prices = usePricesMachineContext(selectPrices);
  const customQuantityPrices = usePricesMachineContext(selectCustomQuantityPrices);
  const selectedPriceAttributes = usePricesMachineContext(selectPriceAttributes);
  const [deliveryTypes, setDeliveryTypes] = useState15(columns);
  const [selectedQuantity, setSelectedQuantity] = useState15(Number(selectedPriceAttributes === null || selectedPriceAttributes === void 0 ? void 0 : selectedPriceAttributes.Quantity));
  const configurationAttributes = useSelectorMachineContext(selectorState => selectorState.context.attributes);
  const {
    isInitialized,
    experiment: exp1849
  } = useExperiment2(EXP1849.id);
  const isExp1849Active = Boolean(isInitialized && (exp1849 === null || exp1849 === void 0 ? void 0 : exp1849.variation) === "variant");
  const isProductEligible = isExp1849Product(productKey, printingProcess);
  const showCustomQuantityInput = Boolean(isExp1849Active && isProductEligible);
  const customQuantityAmounts = useMemo6(() => {
    if (isInitialized && (exp1849 === null || exp1849 === void 0 ? void 0 : exp1849.variation) === "control" && isProductEligible) {
      var _getExp1849CustomQuan;
      return (_getExp1849CustomQuan = getExp1849CustomQuantityAmounts(productKey, prices)) !== null && _getExp1849CustomQuan !== void 0 ? _getExp1849CustomQuan : [];
    }
    return quantities;
  }, [prices, quantities, isInitialized, exp1849 === null || exp1849 === void 0 ? void 0 : exp1849.variation, productKey, printingProcess]);
  const handleQuantityChange = quantity => {
    if (!quantity || quantity <= 0) return;
    setSelectedQuantity(quantity);
    if (showCustomQuantityInput) {
      dispatchDataLayerEntry("price_table", "custom_quantity_input", {
        quantity,
        productKey
      });
    }
    setDeliveryTypes(columns);
    send({
      type: "Select custom quantity",
      quantity: [quantity]
    });
  };
  useEffect16(() => {
    if (selectedPriceAttributes !== null && selectedPriceAttributes !== void 0 && selectedPriceAttributes.Quantity && quantities.includes(Number(selectedPriceAttributes.Quantity))) {
      send({
        type: "Select custom quantity",
        quantity: [Number(selectedPriceAttributes.Quantity)]
      });
    }
  }, [selectedPriceAttributes === null || selectedPriceAttributes === void 0 ? void 0 : selectedPriceAttributes.Quantity, send]);
  useEffect16(() => {
    if (customQuantityPrices !== null && customQuantityPrices !== void 0 && customQuantityPrices.length) {
      const printingProcessPrice = customQuantityPrices.find(process => process.name === printingProcess);
      if (printingProcessPrice) {
        const [quantity] = printingProcessPrice.quantities;
        setDeliveryTypes(addEmptyPrices(columns, quantity.deliveryTypes));
      }
    }
    return () => {
      setDeliveryTypes(columns);
    };
  }, [customQuantityPrices]);
  const memoizedPriceAttributesMap = useMemo6(() => generatePriceAttributesMap(configurationAttributes, printingProcess, deliveryTypes, selectedQuantity), [configurationAttributes, printingProcess, deliveryTypes, selectedQuantity]);
  return /* @__PURE__ */jsxs24("tr", {
    className: "pd:border-1",
    children: [/* @__PURE__ */jsx38("td", {
      width: "200",
      className: "pd:border-1 pd:p-2",
      children: printingProcess && showCustomQuantityInput ? /* @__PURE__ */jsx38(CustomQuantityInput, {
        value: selectedQuantity,
        onChange: handleQuantityChange,
        printingProcess
      }) : /* @__PURE__ */jsx38(SelectCustomQuantity, {
        quantities: customQuantityAmounts,
        selectedQuantity,
        onChange: handleQuantityChange
      })
    }), deliveryTypes.map(deliveryType => {
      const priceAttributes = memoizedPriceAttributesMap.get("".concat(selectedQuantity, "-").concat(deliveryType.name));
      return /* @__PURE__ */jsx38(PriceCell, {
        price: deliveryType.price,
        discountedPrice: deliveryType.discountedPrice,
        isLoading: loadingCustomQuantities,
        priceAttributes,
        isReseller
      }, deliveryType.name);
    })]
  });
};

// src/components/prices/table/PriceTable.tsx
import { jsx as jsx39, jsxs as jsxs25 } from "react/jsx-runtime";
var getValue2 = (values, name) => values === null || values === void 0 ? void 0 : values.find(value => value.pimAttributeValue === name);
var getAttributeValue2 = (attributes, name) => {
  const productAttribue = attributes.find(_ref333 => {
    let {
      values
    } = _ref333;
    return getValue2(values, name);
  });
  return getValue2(productAttribue === null || productAttribue === void 0 ? void 0 : productAttribue.values, name);
};
var getCustomQuantityAmounts = (customQuantities, printingProcess) => {
  if (!customQuantities) {
    return [];
  }
  if (printingProcess) {
    var _customQuantities$pri;
    return (_customQuantities$pri = customQuantities[printingProcess]) !== null && _customQuantities$pri !== void 0 ? _customQuantities$pri : [];
  }
  if (Array.isArray(customQuantities.quantities)) {
    return customQuantities.quantities;
  }
  return [];
};
var PriceTable = _ref334 => {
  var _prices$, _attributeValue$suppo;
  let {
    product,
    printingProcessPrice,
    isReseller = false,
    productDiscounts
  } = _ref334;
  const intl = useIntl19();
  const [showSupportArticleModal, setShowSupportArticleModal] = useState16(false);
  const {
    vatMode
  } = useContext5(VatModeContext);
  const customQuantities = usePricesMachineContext(selectCustomQuantities);
  const attributeValue = getAttributeValue2(product.attributes, printingProcessPrice.name);
  const configurationAttributes = useSelectorMachineContext(state => state.context.attributes);
  const selectedPrice = usePricesMachineContext(state => state.context.selectedPrice);
  const prices = usePricesMachineContext(state => state.context.prices);
  const firstAvailablePrice = prices === null || prices === void 0 || (_prices$ = prices[0]) === null || _prices$ === void 0 || (_prices$ = _prices$.quantities[0]) === null || _prices$ === void 0 ? void 0 : _prices$.deliveryTypes[0];
  const discountExist = selectedPrice && hasDiscount(vatMode, selectedPrice.price, selectedPrice.discountedPrice) || (firstAvailablePrice === null || firstAvailablePrice === void 0 ? void 0 : firstAvailablePrice.price) && (firstAvailablePrice === null || firstAvailablePrice === void 0 ? void 0 : firstAvailablePrice.discountedPrice) && hasDiscount(vatMode, firstAvailablePrice.price, firstAvailablePrice.discountedPrice);
  const showDiscountBadge = discountExist && isReseller;
  const {
    deliveryTypes,
    quantities,
    name
  } = printingProcessPrice;
  const memoizedPriceAttributesMap = useMemo7(() => {
    const map = /* @__PURE__ */new Map();
    quantities.forEach(_ref335 => {
      let {
        quantity,
        deliveryTypes: deliveryTypes2
      } = _ref335;
      const deliveryTypesMap = generatePriceAttributesMap(configurationAttributes, name, deliveryTypes2, quantity);
      deliveryTypesMap.forEach((value, key2) => {
        map.set(key2, value);
      });
    });
    return map;
  }, [quantities, configurationAttributes, name]);
  const customQuantitiesAmounts = useMemo7(() => getCustomQuantityAmounts(customQuantities, name), [customQuantities, name]);
  const key = name ? name.toLowerCase().replace(/\s/g, "") : "unknown";
  const titleTranslation = translations["printingType_".concat(key)];
  const descriptionTranslation = translations["description_".concat(key)];
  return /* @__PURE__ */jsxs25("div", {
    "data-testid": "price-table-section",
    className: "pd:rounded-md pd:border-t-1",
    children: [/* @__PURE__ */jsx39("div", {
      className: "pd:rounded-t-md pd:border-x-1 pd:bg-dim-100 pd:px-5 pd:pb-2 pd:pt-5",
      children: /* @__PURE__ */jsx39("div", {
        className: "pd:flex pd:items-stretch pd:justify-between",
        children: /* @__PURE__ */jsxs25("div", {
          className: "pd:flex pd:flex-wrap pd:gap-2",
          children: [/* @__PURE__ */jsx39(Heading3, {
            variant: "display",
            size: "3",
            children: /* @__PURE__ */jsxs25("div", {
              className: "pd:flex pd:flex-row pd:gap-2",
              children: [intl.formatMessage(translations.headerFlag), (attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.supportArticle) && /* @__PURE__ */jsx39(LinkAsButton6, {
                variant: "secondary",
                onClick: () => setShowSupportArticleModal(true),
                iconBefore: "info",
                screenReaderLabel: intl.formatMessage({
                  id: "general.selector.moreInfo",
                  defaultMessage: "More info"
                })
              })]
            })
          }), /* @__PURE__ */jsxs25("div", {
            className: "pd:text-lg pd:font-normal pd:text-dim-600",
            children: [(attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.attributeValueAlias) || titleTranslation && intl.formatMessage(titleTranslation), descriptionTranslation && " (".concat(intl.formatMessage(descriptionTranslation), ")"), productDiscounts && productDiscounts.length > 0 && /* @__PURE__ */jsxs25(Badge2, {
              className: "pd:sm:ml-2",
              variant: "warning",
              children: ["".concat(productDiscounts[0].discountValue.percentage, "% "), /* @__PURE__ */jsx39(FormattedMessage21, {
                id: "product.discount-calculated",
                defaultMessage: "discount calculated"
              })]
            }), showDiscountBadge && /* @__PURE__ */jsx39(Badge2, {
              className: "pd:sm:ml-2",
              variant: "warning",
              children: /* @__PURE__ */jsx39(FormattedMessage21, {
                id: "general.discounts.reseller.text",
                defaultMessage: "Partner pro discount calculated"
              })
            })]
          })]
        })
      })
    }), /* @__PURE__ */jsxs25("table", {
      "data-testid": "price-table",
      className: "pd:w-full pd:border-collapse pd:text-center",
      children: [/* @__PURE__ */jsx39("thead", {
        children: /* @__PURE__ */jsxs25("tr", {
          className: "pd:border-1",
          children: [/* @__PURE__ */jsx39("th", {
            className: "pd:border-1 pd:p-2 pd:align-bottom pd:font-bold",
            children: intl.formatMessage(translations.quantity)
          }), deliveryTypes.map(deliveryType => /* @__PURE__ */jsx39("th", {
            className: "pd:border-1 pd:p-2",
            children: /* @__PURE__ */jsxs25("div", {
              className: "pd:flex pd:flex-col pd:items-center pd:gap-2",
              children: [/* @__PURE__ */jsx39(Badge2, {
                variant: getBadgeVariant(deliveryType),
                children: intl.formatMessage(translations[deliveryType])
              }), /* @__PURE__ */jsx39(ArrivalDate, {
                deliveryType,
                printingProcess: name
              })]
            })
          }, deliveryType))]
        })
      }), /* @__PURE__ */jsxs25("tbody", {
        children: [quantities.map(_ref336 => {
          let {
            quantity,
            deliveryTypes: deliveries
          } = _ref336;
          return /* @__PURE__ */jsxs25("tr", {
            className: "pd:border-1",
            children: [/* @__PURE__ */jsx39("td", {
              children: quantity
            }), deliveries.map(deliveryType => {
              const priceAttributes = memoizedPriceAttributesMap.get("".concat(quantity, "-").concat(deliveryType.name));
              return /* @__PURE__ */jsx39(PriceCell, {
                price: deliveryType.price,
                discountedPrice: deliveryType.discountedPrice,
                priceAttributes,
                isReseller
              }, "".concat(quantity, "-").concat(deliveryType.name));
            })]
          }, quantity);
        }), customQuantitiesAmounts.length > 0 && /* @__PURE__ */jsx39(CustomQuantities, {
          quantities: customQuantitiesAmounts,
          printingProcess: name,
          columns: deliveryTypes.map(deliveryType => ({
            name: deliveryType
          })),
          isReseller,
          productKey: product.key
        })]
      })]
    }), /* @__PURE__ */jsx39(SupportArticleModal, {
      show: showSupportArticleModal,
      onClose: () => setShowSupportArticleModal(false),
      supportArticleId: attributeValue === null || attributeValue === void 0 || (_attributeValue$suppo = attributeValue.supportArticle) === null || _attributeValue$suppo === void 0 ? void 0 : _attributeValue$suppo.id
    })]
  });
};

// src/components/prices/Prices.tsx
import { jsx as jsx40 } from "react/jsx-runtime";
var PricesComponent = _ref337 => {
  let {
    selectionAttributes,
    group,
    quantity,
    product,
    shippingAddress,
    sort,
    preselectedPriceAttributes,
    customerGroupId,
    inventoryCheckEnabled,
    merchandisedQuantities,
    contentfulId,
    isReseller = false,
    productDiscounts
  } = _ref337;
  const quantityList = quantity ? [quantity] : [];
  const requestedQuantity = merchandisedQuantities !== null && merchandisedQuantities !== void 0 && merchandisedQuantities.length ? merchandisedQuantities : quantityList;
  const showCards = Boolean(quantity) || group.length;
  const send = usePricesMachineSend();
  const loadingPrices = usePricesMachineContext(state => state.matches("Loading prices"));
  const isShowingPrices = usePricesMachineContext(state => state.matches("Showing Prices"));
  const prices = usePricesMachineContext(selectPrices);
  const isShowingArrivalDates = usePricesMachineContext(state => state.matches({
    "Showing Prices": {
      "Arrival dates": "Showing arrival dates"
    }
  }));
  const waitingForCustomQuantitySelection = usePricesMachineContext(state => state.matches({
    "Showing Prices": {
      "Custom quantities": {
        "Showing custom quantities": "Waiting for quantity selection"
      }
    }
  }));
  const showingCustomQuantityPrices = usePricesMachineContext(state => state.matches({
    "Showing Prices": {
      "Custom quantities": {
        "Showing custom quantities": "Showing custom quantity prices"
      }
    }
  }));
  const isIdle = isShowingArrivalDates && (waitingForCustomQuantitySelection || showingCustomQuantityPrices);
  useEffect17(() => {
    send({
      type: "Start machine",
      mcpSku: product.mcpSku,
      productKey: product.key,
      selectionAttributes,
      shippingAddress,
      group,
      customerGroupId,
      quantity: requestedQuantity,
      preselectedPriceAttributes,
      sort,
      inventoryCheckEnabled,
      merchandisedQuantities
    });
    return () => {
      send({
        type: "Reset"
      });
    };
  }, []);
  useEffect17(() => {
    send({
      type: "Get prices",
      selectionAttributes,
      group,
      quantity: requestedQuantity,
      customerGroupId
    });
  }, [JSON.stringify(selectionAttributes), customerGroupId, JSON.stringify(group), send]);
  useEffect17(() => {
    if (isShowingPrices) {
      dispatchDataLayerEntry("price_table", "display", {
        contentful_id: contentfulId
      });
    }
  }, [isShowingPrices, contentfulId]);
  if (loadingPrices) {
    return /* @__PURE__ */jsx40(PriceTableLoading, {
      showCards
    });
  }
  if (isShowingPrices) {
    return /* @__PURE__ */jsx40("div", {
      "data-testid": isIdle ? "prices-machine-idle" : "prices-machine-loading",
      className: "pd:flex pd:flex-col pd:gap-5",
      children: prices === null || prices === void 0 ? void 0 : prices.map(printingProcessPrice => {
        if (showCards) {
          return /* @__PURE__ */jsx40(PriceCards, {
            printingProcessPrice
          }, printingProcessPrice.name);
        }
        return /* @__PURE__ */jsx40(PriceTable, {
          printingProcessPrice,
          product,
          isReseller,
          productDiscounts
        }, printingProcessPrice.name);
      })
    });
  }
  return null;
};

// src/components/selector/Pricing.tsx
import { Badge as Badge3, Collapsible as Collapsible5, Heading as Heading4, Spinner as Spinner6, TextField as TextField4, Icon as Icon2, Grid as Grid5, RadioCard as RadioCard3 } from "@printdeal/ui-library";
import { dequal as dequal6 } from "dequal";
import { FormattedMessage as FormattedMessage23, useIntl as useIntl21 } from "react-intl";
import { useContext as useContext7, useEffect as useEffect18, useState as useState17, useMemo as useMemo8 } from "react";

// src/components/selector/DeliveryDate.tsx
import { FormattedDate as FormattedDate3 } from "react-intl";
import { jsx as jsx41, jsxs as jsxs26 } from "react/jsx-runtime";
var DeliveryDate = _ref338 => {
  var _deliveryDates$find;
  let {
    deliveryType,
    deliveryDates
  } = _ref338;
  const deliveryDate = deliveryDates === null || deliveryDates === void 0 || (_deliveryDates$find = deliveryDates.find(date => date.name === deliveryType)) === null || _deliveryDates$find === void 0 ? void 0 : _deliveryDates$find.date;
  if (deliveryDate && Date.parse(deliveryDate)) {
    return /* @__PURE__ */jsxs26("div", {
      children: [/* @__PURE__ */jsx41("span", {
        className: "pd:mr-1",
        children: /* @__PURE__ */jsx41(FormattedDate3, {
          weekday: "short",
          value: deliveryDate
        })
      }), /* @__PURE__ */jsx41("span", {
        children: /* @__PURE__ */jsx41(FormattedDate3, {
          month: "short",
          day: "numeric",
          value: deliveryDate
        })
      })]
    });
  }
  return null;
};

// src/components/selector/QuantityPrice.tsx
import { RadioField } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage22, useIntl as useIntl20 } from "react-intl";
import { useContext as useContext6 } from "react";
import { jsx as jsx42 } from "react/jsx-runtime";
var QuantityPrice = _ref339 => {
  let {
    quantity,
    deliveryType,
    totalQuantity,
    handlePriceSelection
  } = _ref339;
  const intl = useIntl20();
  const {
    vatMode
  } = useContext6(VatModeContext);
  const {
    name,
    unitPrice,
    discountedUnitPrice,
    percentageSavings,
    discountedPrice,
    price
  } = deliveryType;
  const isInventoryInsufficient2 = useMatchesState({
    STARTED: {
      "FETCHING DATA": {
        INVENTORY: "INSUFFICIENT INVENTORY"
      }
    }
  });
  if (!discountedPrice || !unitPrice) {
    return null;
  }
  return /* @__PURE__ */jsx42(PriceTooltip, {
    vatMode,
    price: unitPrice,
    discountedPrice: discountedUnitPrice,
    children: /* @__PURE__ */jsx42(RadioField, {
      id: "".concat(slugify(name), "-").concat(quantity),
      "data-testid": "quantity-option-radio",
      name: "quantity",
      checked: quantity === totalQuantity,
      disabled: isInventoryInsufficient2 && quantity === totalQuantity,
      label: /* @__PURE__ */jsx42(FormattedMessage22, {
        id: "selector.quantityGrid.label",
        defaultMessage: "{quantity} pieces",
        values: {
          quantity
        }
      }),
      onChange: () => {
        handlePriceSelection(discountedPrice, name, quantity, price);
      },
      className: "pd:mb-3",
      description: /* @__PURE__ */jsx42(FormattedMessage22, {
        id: "selector.quantityGrid.description",
        defaultMessage: "{value} per piece",
        values: {
          value: intl.formatNumber(getPriceAmount(vatMode, unitPrice, discountedUnitPrice) / 100, {
            style: "currency",
            currencyDisplay: "symbol",
            currency: unitPrice[vatMode].currencyCode
          })
        }
      }),
      suffix: isInventoryInsufficient2 && quantity === totalQuantity ? /* @__PURE__ */jsx42("span", {
        className: "pd:text-error-600",
        children: /* @__PURE__ */jsx42(FormattedMessage22, {
          id: "selector.quantityGrid.isOutOfStock",
          defaultMessage: "Insufficient stock"
        })
      }) : percentageSavings !== 0 && /* @__PURE__ */jsx42("span", {
        className: "pd:text-success-600",
        children: /* @__PURE__ */jsx42(FormattedMessage22, {
          id: "selector.quantityGrid.suffix",
          defaultMessage: "Save {value}%",
          values: {
            value: percentageSavings
          }
        })
      })
    })
  });
};

// src/components/selector/Pricing.tsx
import { jsx as jsx43, jsxs as jsxs27 } from "react/jsx-runtime";
var INITIAL_QUANTITIES_TO_SHOW = 6;
var Pricing = _ref340 => {
  var _inventory$;
  let {
    isReseller = false
  } = _ref340;
  const intl = useIntl21();
  const send = useSelectorMachineSend();
  const selectorPrices = useSelectorMachineContext(state => state.context.prices);
  const isLoadingPrices = useMatchesState({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "FETCHING PRICES"
      }
    }
  });
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  const selectedDeliveryOption = useSelectorMachineContext(state => state.context.selectedDeliveryOption);
  const selectedPrice = useSelectorMachineContext(state => state.context.price);
  const totalQuantity = useSelectorMachineContext(state => state.context.totalQuantity);
  const selection = useSelectorMachineContext(state => state.context.selection);
  const customQuantity = useSelectorMachineContext(state => state.context.customQuantity);
  const pricesPerQuantity = useSelectorMachineContext(state => state.context.pricesPerQuantity);
  const attributes = useSelectorMachineContext(state => state.context.attributes);
  const remainingOptionsPerGroup = useSelectorMachineContext(state => state.context.remainingOptionsPerGroup);
  const groupSelection = useSelectorMachineContext(state => state.context.group);
  const inventory = useSelectorMachineContext(state => state.context.inventory);
  const range = calculateRange("Quantity", remainingOptionsPerGroup);
  const minimumQuantity = range === null || range === void 0 ? void 0 : range.minimum;
  const maximumQuantity = range === null || range === void 0 ? void 0 : range.maximum;
  const increment = range === null || range === void 0 ? void 0 : range.increment;
  const {
    vatMode
  } = useContext7(VatModeContext);
  const {
    open,
    setOpen
  } = useCollapseLogic({
    filteredAttributes: attributes,
    attributeName: "Pricing",
    attributeIndex: attributes.length + 1,
    selectedValue: {
      name: selectedDeliveryOption.name
    }
  });
  const [value, setValue] = useState17(0);
  const [showAllQuantities, setShowAllQuantities] = useState17(false);
  const isRangeValidForInput = value ? isRangeValid("Quantity", remainingOptionsPerGroup, value) : true;
  const maxInventory = inventory === null || inventory === void 0 || (_inventory$ = inventory[0]) === null || _inventory$ === void 0 ? void 0 : _inventory$.maxAvailableInventory;
  const isInventoryInsufficient2 = value > 0 && maxInventory !== void 0 && value > maxInventory;
  const isInputValid = isRangeValidForInput && !isInventoryInsufficient2;
  const getValidationMessage = () => {
    if (isInventoryInsufficient2) {
      return intl.formatMessage(translations.noInventory);
    }
    return intl.formatMessage({
      id: "selector.quantity.maxQuantity",
      defaultMessage: "Orders for this product range from {minQuantity} to {maxQuantity}, in increments of {increment} pieces"
    }, {
      minQuantity: minimumQuantity,
      maxQuantity: maximumQuantity,
      increment
    });
  };
  const isStepByStep2 = selectionMode === "step-by-step";
  const quantityPricePerDeliveryOption = pricesPerQuantity.filter(quantity => quantity.deliveryType.name === selectedDeliveryOption.name);
  const visibleQuantities = useMemo8(() => {
    const pricesWithoutCustomQuantity = quantityPricePerDeliveryOption.filter(_ref341 => {
      let {
        quantity
      } = _ref341;
      return quantity !== customQuantity;
    });
    if (!showAllQuantities) {
      return pricesWithoutCustomQuantity.slice(0, INITIAL_QUANTITIES_TO_SHOW);
    }
    return pricesWithoutCustomQuantity;
  }, [quantityPricePerDeliveryOption, showAllQuantities, customQuantity]);
  const customQuantityPrice = useMemo8(() => quantityPricePerDeliveryOption.find(_ref342 => {
    let {
      quantity
    } = _ref342;
    return quantity === customQuantity;
  }), [quantityPricePerDeliveryOption, customQuantity]);
  const handleToggleQuantityList = () => {
    setShowAllQuantities(!showAllQuantities);
    dispatchDataLayerEntry("selector", "click", {
      "element-type": "button",
      "element-content": showAllQuantities ? "show_less_quantities" : "show_more_quantities",
      "quantities-visible": showAllQuantities ? INITIAL_QUANTITIES_TO_SHOW : quantityPricePerDeliveryOption.length
    });
  };
  useEffect18(() => {
    if (quantityPricePerDeliveryOption.length > 0) {
      dispatchDataLayerEntry("price_overview", "display");
    }
  }, [quantityPricePerDeliveryOption.length]);
  const validate = () => {
    if (!isInputValid) {
      return "error";
    }
    return void 0;
  };
  const fetchPriceForCustomQuantity = () => {
    if (!value || !isInputValid) return;
    send({
      type: "Set custom quantity",
      customQuantity: value
    });
    setValue(0);
  };
  const handleSubmit = event => {
    event.preventDefault();
    fetchPriceForCustomQuantity();
    const deliveryOptionLowerCased = selectedDeliveryOption.name.toLowerCase().replace(/ /g, "_");
    dispatchDataLayerEntry("price_overview", "add_custom_quantity", {
      "element-type": "custom_quantity_priceoverview",
      "element-content": "priceoverview_custom_quantity_input",
      "element-context": "priceoverview_custom_quantity_input_".concat(deliveryOptionLowerCased),
      "delivery-type": selectedDeliveryOption.name,
      quantity: value
    });
  };
  useEffect18(() => {
    if (totalQuantity && selectedDeliveryOption.id) {
      const foundPrice = getSelectedPrice(selectorPrices, selection, quantityPricePerDeliveryOption, totalQuantity, selectedDeliveryOption.name, !isStepByStep2);
      if (foundPrice !== null && foundPrice !== void 0 && foundPrice.discountedPrice) {
        send({
          type: "Set price",
          price: foundPrice.discountedPrice,
          originalPrice: foundPrice.price
        });
      }
    }
  }, [totalQuantity, quantityPricePerDeliveryOption.length, JSON.stringify(selectedDeliveryOption), selectorPrices.length, isStepByStep2, selection]);
  if (isLoadingPrices && isStepByStep2) {
    return /* @__PURE__ */jsx43(PriceTableLoading, {
      showCards: false
    });
  }
  if (hasGroupedQuantity(attributes) && !isStepByStep2 || !selectorPrices.length && isStepByStep2) {
    return null;
  }
  const handlePriceSelection = (price, deliveryOption, quantity, originalPrice, prices) => {
    const deliveryOptionLowerCased = deliveryOption.toLowerCase().replace(/ /g, "_");
    const formattedPrice = intl.formatNumber(price[vatMode].centAmount / 100, {
      currency: price[vatMode].currencyCode
    });
    if (isStepByStep2 && prices) {
      var _prices$deliveryDates;
      const deliveryDate = (_prices$deliveryDates = prices.deliveryDates) === null || _prices$deliveryDates === void 0 ? void 0 : _prices$deliveryDates.find(option => option.name === deliveryOption);
      if (!deliveryDate) return;
      send({
        type: "Set delivery option",
        deliveryOption: deliveryDate
      });
      const attribute = attributes.find(_ref343 => {
        let {
          values
        } = _ref343;
        return values === null || values === void 0 ? void 0 : values.find(_ref344 => {
          let {
            name
          } = _ref344;
          return name === prices.name;
        });
      });
      if (attribute && prices.name) {
        send({
          type: "Select attribute value",
          attributeSelection: {
            name: attribute.name,
            value: prices.name
          },
          shouldValidate: false,
          valid: true
        });
      }
      dispatchDataLayerEntry("price_table", "click", {
        "element-type": "button_pricetable",
        "element-content": "pricetable_price_cell",
        "element-context": "pricetable_column_".concat(deliveryOptionLowerCased),
        "delivery-type": deliveryOption,
        quantity,
        price: formattedPrice
      });
    } else {
      dispatchDataLayerEntry("price_overview", "click", {
        "element-type": "radio_priceoverview",
        "element-content": "priceoverview_price_radio",
        "element-context": "priceoverview_radio_".concat(deliveryOptionLowerCased),
        "delivery-type": deliveryOption,
        quantity,
        price: formattedPrice
      });
    }
    send({
      type: "Set quantity",
      quantity: Number(quantity)
    });
    send({
      type: "Set price",
      price,
      originalPrice
    });
  };
  return selectorPrices.map(prices => {
    var _prices$discountTypes, _prices$quantities$;
    const isProductDiscountApplied = (_prices$discountTypes = prices.discountTypes) === null || _prices$discountTypes === void 0 ? void 0 : _prices$discountTypes.includes("product");
    const firstAvailablePrice = (_prices$quantities$ = prices.quantities[0]) === null || _prices$quantities$ === void 0 ? void 0 : _prices$quantities$.deliveryTypes[0];
    const discountExist = firstAvailablePrice.price && firstAvailablePrice.discountedPrice && hasDiscount(vatMode, firstAvailablePrice.price, firstAvailablePrice.discountedPrice);
    const showDiscountBadge = discountExist && isReseller;
    if (isStepByStep2) {
      if (groupSelection.length > 0) {
        return (
          // price cards for step-by-step with grouped quantity
          /* @__PURE__ */
          jsxs27(Collapsible5, {
            id: "price-cards-collapsible",
            isOpen: true,
            children: [/* @__PURE__ */jsx43(Collapsible5.Header, {
              title: /* @__PURE__ */jsx43(FormattedMessage23, {
                id: "account.order.delivery.title",
                defaultMessage: "Delivery"
              })
            }), /* @__PURE__ */jsx43(Collapsible5.Panel, {
              "data-testid": "price-cards-collapsible-panel",
              children: /* @__PURE__ */jsx43(Grid5, {
                className: "pd-grid pd:grid-cols-3 pd:gap-4",
                children: prices.quantities[0].deliveryTypes.map(_ref345 => {
                  let {
                    name,
                    discountedPrice,
                    price
                  } = _ref345;
                  return price && discountedPrice && /* @__PURE__ */jsx43(RadioCard3, {
                    id: slugify("price-card-".concat(name)),
                    name: "price-card-".concat(name),
                    "data-testid": slugify("price-card-".concat(name)),
                    onClick: () => handlePriceSelection(discountedPrice, name, totalQuantity, price, prices),
                    checked: selectedDeliveryOption.name === name,
                    label: /* @__PURE__ */jsx43(DeliveryDate, {
                      deliveryType: name
                    }),
                    description: /* @__PURE__ */jsxs27(Grid5, {
                      className: "pd:font-normal",
                      children: [/* @__PURE__ */jsx43(Grid5.Item, {
                        children: /* @__PURE__ */jsx43(Money, {
                          value: getPriceAmount(vatMode, price, discountedPrice)
                        })
                      }), /* @__PURE__ */jsx43(Grid5.Item, {
                        children: /* @__PURE__ */jsx43("span", {
                          children: intl.formatMessage(translations[vatMode])
                        })
                      }), /* @__PURE__ */jsx43(Grid5.Item, {
                        children: intl.formatMessage(translations[name])
                      })]
                    })
                  }, name);
                })
              })
            })]
          })
        );
      }
      return /* @__PURE__ */jsxs27("div", {
        "data-testid": "price-table-section",
        className: "pd:rounded-md pd:border-1 pd:mb-4",
        children: [/* @__PURE__ */jsx43("div", {
          className: "pd:rounded-t-md pd:bg-dim-100 pd:px-5 pd:pb-2 pd:pt-5",
          children: /* @__PURE__ */jsxs27("div", {
            className: "pd:flex pd:items-stretch pd:justify-between",
            children: [/* @__PURE__ */jsx43("div", {
              className: "pd:flex pd:flex-wrap pd:gap-2",
              children: /* @__PURE__ */jsx43(Heading4, {
                variant: "display",
                size: "3",
                children: intl.formatMessage(translations.headerFlag)
              })
            }), isProductDiscountApplied && /* @__PURE__ */jsx43(Badge3, {
              className: "pd:sm:ml-2",
              variant: "warning",
              children: /* @__PURE__ */jsx43(FormattedMessage23, {
                id: "product-discount-calculated",
                defaultMessage: "Product discount calculated"
              })
            }), showDiscountBadge && /* @__PURE__ */jsx43(Badge3, {
              className: "pd:sm:ml-2",
              variant: "warning",
              children: /* @__PURE__ */jsx43(FormattedMessage23, {
                id: "general.discounts.reseller.text",
                defaultMessage: "Partner pro discount calculated"
              })
            })]
          })
        }), /* @__PURE__ */jsxs27("table", {
          "data-testid": "price-table",
          className: "pd:w-full pd:border-collapse pd:text-center",
          children: [/* @__PURE__ */jsx43("thead", {
            className: "pd:border-b-2",
            children: /* @__PURE__ */jsxs27("tr", {
              children: [/* @__PURE__ */jsx43("th", {
                className: "pd:border pd:p-2 pd:align-bottom pd:font-bold",
                children: intl.formatMessage(translations.quantity)
              }), prices.deliveryTypes.map(deliveryType => /* @__PURE__ */jsx43("th", {
                className: "pd:border pd:p-2",
                children: /* @__PURE__ */jsxs27("div", {
                  className: "pd:flex pd:flex-col pd:items-center pd:gap-2",
                  children: [/* @__PURE__ */jsx43(Badge3, {
                    variant: getBadgeVariant(deliveryType),
                    children: intl.formatMessage(translations[deliveryType])
                  }), /* @__PURE__ */jsx43(DeliveryDate, {
                    deliveryType,
                    deliveryDates: prices.deliveryDates
                  })]
                })
              }, deliveryType))]
            })
          }), /* @__PURE__ */jsx43("tbody", {
            children: prices.quantities.map(_ref346 => {
              let {
                quantity,
                deliveryTypes: deliveries
              } = _ref346;
              return /* @__PURE__ */jsxs27("tr", {
                className: "pd:border",
                children: [/* @__PURE__ */jsx43("td", {
                  children: quantity
                }), deliveries.map(_ref347 => {
                  let {
                    name,
                    price,
                    discountedPrice
                  } = _ref347;
                  const selected = dequal6(discountedPrice, selectedPrice);
                  return discountedPrice && price ? /* @__PURE__ */jsx43("td", {
                    className: "pd:m-0 pd:border pd:border-x-dim-200 pd:p-0",
                    children: isReseller ? /* @__PURE__ */jsx43(PriceTooltip, {
                      vatMode,
                      price,
                      discountedPrice,
                      children: /* @__PURE__ */jsx43(PriceButton, {
                        "aria-label": "price-".concat(name, "-").concat(quantity),
                        vatMode,
                        price,
                        discountedPrice,
                        selected,
                        handleClick: () => handlePriceSelection(discountedPrice, name, quantity, price, prices)
                      })
                    }) : /* @__PURE__ */jsx43(PriceButton, {
                      "aria-label": "price-".concat(name, "-").concat(quantity),
                      vatMode,
                      price,
                      discountedPrice,
                      selected,
                      handleClick: () => handlePriceSelection(discountedPrice, name, quantity, price, prices)
                    })
                  }, name) : /* @__PURE__ */jsx43("td", {}, name);
                })]
              }, quantity);
            })
          })]
        })]
      });
    }
    return /* @__PURE__ */jsx43("section", {
      children: /* @__PURE__ */jsxs27(Collapsible5, {
        id: "quantity",
        variant: "secondary",
        isOpen: open,
        defaultOpen: true,
        className: "pd:mb-4",
        children: [/* @__PURE__ */jsx43(Collapsible5.Header, {
          "data-cy": "quantity-collapsible-header",
          title: intl.formatMessage({
            id: "selector.quantity.title",
            defaultMessage: "Quantity"
          }),
          button: /* @__PURE__ */jsx43(Collapsible5.Button, {
            onClick: () => setOpen(!open)
          }),
          children: /* @__PURE__ */jsx43(FormattedMessage23, {
            id: "selector.quantity.suffix",
            defaultMessage: "{value} pieces",
            values: {
              value: totalQuantity
            }
          })
        }), /* @__PURE__ */jsxs27(Collapsible5.Panel, {
          children: [visibleQuantities.map(_ref348 => {
            let {
              quantity,
              deliveryType
            } = _ref348;
            return /* @__PURE__ */jsx43(QuantityPrice, {
              quantity,
              deliveryType,
              totalQuantity,
              handlePriceSelection
            }, "".concat(deliveryType.name, "-").concat(quantity));
          }), customQuantityPrice && /* @__PURE__ */jsx43(QuantityPrice, {
            quantity: customQuantityPrice.quantity,
            deliveryType: customQuantityPrice.deliveryType,
            totalQuantity,
            handlePriceSelection
          }), !isLoadingPrices && /* @__PURE__ */jsx43("form", {
            id: "custom-quantity-form",
            onSubmit: handleSubmit,
            children: /* @__PURE__ */jsx43(TextField4, {
              "data-testid": "custom-quantity",
              type: "number",
              name: "customQuantity",
              min: minimumQuantity,
              max: maximumQuantity,
              id: "customQuantity",
              validation: validate(),
              validationMessage: isInputValid ? "" : getValidationMessage(),
              description: intl.formatMessage({
                id: "selector.quantityGrid.customQuantityDescription",
                defaultMessage: "Enter your own quantity{increment, plural, =0 {} =1 {} other { (increments of {increment})}}"
              }, {
                increment: increment !== null && increment !== void 0 ? increment : 0
              }),
              suffix: intl.formatMessage({
                id: "selector.quantityGrid.customQuantitySuffix",
                defaultMessage: "pieces"
              }),
              onBlur: fetchPriceForCustomQuantity,
              onChange: event => setValue(event.target.value ? Number(event.target.value) : 0)
            })
          }), quantityPricePerDeliveryOption.length > INITIAL_QUANTITIES_TO_SHOW && /* @__PURE__ */jsxs27("button", {
            "data-testid": "show-more-quantities",
            type: "button",
            onClick: handleToggleQuantityList,
            className: "pd:flex pd:w-full pd:items-center pd:justify-center pd:gap-2 pd:py-2 pd:text-sm pd:font-bold",
            children: [/* @__PURE__ */jsx43(Icon2, {
              icon: showAllQuantities ? "arrow-up" : "arrow-down"
            }), showAllQuantities ? intl.formatMessage(translations.showLessQuantities) : intl.formatMessage(translations.showMoreQuantities)]
          }), isLoadingPrices && /* @__PURE__ */jsx43("div", {
            className: "pd:border pd:p-2",
            children: /* @__PURE__ */jsx43("div", {
              className: "pd:flex pd:w-full pd:justify-center",
              children: /* @__PURE__ */jsx43(Spinner6, {
                "data-testid": "custom-quantity-spinner",
                variant: "dim",
                screenReaderLabel: intl.formatMessage({
                  id: "uilib.spinner.loading",
                  defaultMessage: "Loading..."
                })
              })
            })
          })]
        })]
      })
    }, prices.name);
  });
};

// src/components/selector/DeliveryOptions.tsx
import { useIntl as useIntl22 } from "react-intl";
import { Collapsible as Collapsible6, Spinner as Spinner7, RadioCardGroup as RadioCardGroup3 } from "@printdeal/ui-library";
import { useContext as useContext8 } from "react";
import { jsx as jsx44, jsxs as jsxs28 } from "react/jsx-runtime";
var DeliveryOptions = () => {
  const intl = useIntl22();
  const {
    vatMode
  } = useContext8(VatModeContext);
  const send = useSelectorMachineSend();
  const pricesLoading = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "FETCHING PRICES"
      }
    }
  }) || state.matches({
    STARTED: {
      "FETCHING DATA": {
        "PIVOT PRICES": "FETCHING PIVOT PRICES"
      }
    }
  }));
  const deliveryOptions = useSelectorMachineContext(state => state.context.deliveryDates);
  const pivotPrices = useSelectorMachineContext(state => state.context.pivotPrices);
  const selectedDeliveryOption = useSelectorMachineContext(state => state.context.selectedDeliveryOption);
  const attributes = useSelectorMachineContext(state => state.context.attributes);
  const isLoadingDeliveryDates = useMatchesState({
    STARTED: {
      "FETCHING DATA": {
        "FETCH DELIVERY DATES": "FETCHING DELIVERY DATES"
      }
    }
  });
  const {
    open,
    setOpen
  } = useCollapseLogic({
    filteredAttributes: attributes,
    attributeName: "Delivery Options",
    attributeIndex: attributes.length + 1,
    selectedValue: {
      name: selectedDeliveryOption.name
    }
  });
  const handleChange = deliveryOption => {
    send({
      type: "Set delivery option",
      deliveryOption
    });
  };
  const deliveryDateLoading = isLoadingDeliveryDates && /* @__PURE__ */jsx44(Spinner7, {
    "data-testid": "spinner",
    size: "sm",
    variant: "dim",
    screenReaderLabel: intl.formatMessage({
      id: "uilib.spinner.loading",
      defaultMessage: "Loading..."
    })
  });
  return /* @__PURE__ */jsxs28(Collapsible6, {
    "data-testid": "DeliveryOptions",
    id: "DeliveryOptions",
    variant: "secondary",
    isOpen: open,
    defaultOpen: true,
    className: "pd:@container pd:mb-4",
    children: [/* @__PURE__ */jsx44(Collapsible6.Header, {
      "data-testid": "DeliveryOptions-collapsible-header",
      title: intl.formatMessage({
        id: "selector.deliveryoption.title",
        defaultMessage: "Delivery option"
      }),
      button: /* @__PURE__ */jsx44(Collapsible6.Button, {
        onClick: () => setOpen(!open)
      }),
      children: /* @__PURE__ */jsx44("div", {
        className: "pd:flex pd:items-center pd:justify-between",
        children: intl.formatMessage(translations[selectedDeliveryOption.name])
      })
    }), /* @__PURE__ */jsx44(Collapsible6.Panel, {
      "data-testid": "DeliveryOptions-collapsible-panel",
      children: /* @__PURE__ */jsx44(RadioCardGroup3, {
        id: "delivery-options-radio-group",
        name: "delivery-option",
        children: /* @__PURE__ */jsx44(RadioCardGroup3.Fields, {
          "aria-label": "Delivery Options",
          className: "pd:grid-cols-1 pd:@xs:grid-cols-2 pd:@md:grid-cols-3 pd:@2xl:grid-cols-4 pd:gap-4",
          children: deliveryOptions.map(_ref349 => {
            var _pivotPrices$EdoId, _pivotPrices$EdoId2;
            let {
              id,
              name,
              date,
              cutofftime
            } = _ref349;
            return /* @__PURE__ */jsx44(RadioCardGroup3.Field, {
              id: slugify("delivery-option-".concat(name)),
              value: id,
              checked: id === selectedDeliveryOption.id,
              onChange: () => handleChange({
                id,
                name,
                date,
                cutofftime
              }),
              className: "pd:h-full",
              label: deliveryDateLoading || (date && Date.parse(date) ? /* @__PURE__ */jsx44("span", {
                className: "pd:capitalize",
                children: intl.formatDate(date, {
                  weekday: "long",
                  month: "short",
                  day: "numeric"
                })
              }) : void 0),
              secondaryAction: /* @__PURE__ */jsx44("span", {
                className: "pd:text-md pd:font-normal pd:text-dim-600",
                children: intl.formatMessage(translations[name])
              }),
              description: Boolean(!deliveryDateLoading && ((_pivotPrices$EdoId = pivotPrices.EdoId) === null || _pivotPrices$EdoId === void 0 ? void 0 : _pivotPrices$EdoId[name])) && /* @__PURE__ */jsx44("p", {
                "data-testid": "".concat(id, "-description"),
                children: /* @__PURE__ */jsx44("span", {
                  "data-testid": pricesLoading ? "prices-loading" : "prices-loaded",
                  className: "pd:text-dim-600 pd:text-md pd:font-normal",
                  children: /* @__PURE__ */jsx44(PivotPrice, {
                    extraCosts: ((_pivotPrices$EdoId2 = pivotPrices.EdoId) === null || _pivotPrices$EdoId2 === void 0 || (_pivotPrices$EdoId2 = _pivotPrices$EdoId2[name]) === null || _pivotPrices$EdoId2 === void 0 ? void 0 : _pivotPrices$EdoId2[vatMode].centAmount) || 0,
                    pricesLoading
                  })
                })
              })
            }, id);
          })
        })
      })
    })]
  });
};

// src/components/prices/SelectVatMode.tsx
import { useContext as useContext9 } from "react";
import { useIntl as useIntl23 } from "react-intl";
import { ToggleField } from "@printdeal/ui-library";
import { jsx as jsx45 } from "react/jsx-runtime";
var SelectVatMode = _ref350 => {
  let {
    className = ""
  } = _ref350;
  const intl = useIntl23();
  const {
    vatMode,
    setVatMode
  } = useContext9(VatModeContext);
  const handleVatModeChange = mode => {
    setVatMode(mode);
    dispatchDataLayerEntry("change_vat_mode", "click", {
      vatMode: mode === "totalGross" ? "incl." : "excl."
    });
  };
  return /* @__PURE__ */jsx45(ToggleField, {
    id: "vat-toggle",
    name: "vat-toggle",
    "data-testid": "vat-toggle",
    className,
    label: intl.formatMessage({
      id: "pricetable.pricemode.gross",
      defaultMessage: "Incl. VAT"
    }),
    checked: vatMode === "totalGross",
    onChange: checked => handleVatModeChange(checked ? "totalGross" : "totalNet")
  });
};
export { DeliveryOptions, Money, PricesComponent, PricesContextProvider, Pricing, SelectVatMode, Selector, SelectorContextProvider, SizeTableFormId, SupportArticleModal, VatModeContext, VatModeProvider, contentfulClient, generateSelectionParameters, getAttributes, getBusinessRules, getGroupFromUrl, getParamFromUrl, getPriceGroups, getPricePivot, getProductAttribute, getResolvedAttribute, getResolvedNumericAttribute, getResolvedStringAttribute, getSelectedPriceAttributes, getSelectionAttributes, getSelectionFromUrl, getTotalPrice, hasDiscount, hasGroupedQuantity, pricePivotAttributes, productClient, useMatchesState, useNewSelector, usePricesMachineContext, usePricesMachineSend, useSelectorContentById, useSelectorContentByPageId, useSelectorMachineContext, useSelectorMachineSend, useSelectorState, useSyncSelectionToUrl, validationClient };